{
  "ai": {
    "actions": {
      "addAttachments": "Fotos oder Dateien hinzufügen"
    },
    "attachments": {
      "imageAlt": "Bild",
      "remove": "Entfernen"
    },
    "conversation": {
      "emptyDescription": "Starte eine Unterhaltung, um hier Nachrichten zu sehen",
      "emptyTitle": "Noch keine Nachrichten"
    },
    "core": {
      "placeholder": "Was möchtest du wissen?",
      "stop": "Stopp",
      "submit": "Senden",
      "uploadFiles": "Dateien hochladen"
    },
    "sources": {
      "usedCount": "{count, plural, one {{count} Quelle genutzt} other {{count} Quellen genutzt}}"
    },
    "tool": {
      "errorHeading": "Fehler",
      "parameters": "Parameter",
      "statusAwaitingApproval": "Wartet auf Freigabe",
      "statusCompleted": "Abgeschlossen",
      "statusDenied": "Abgelehnt",
      "statusError": "Fehler",
      "statusPending": "Ausstehend",
      "statusResponded": "Beantwortet",
      "statusRunning": "Läuft"
    }
  },

  "auth": {
    "appleNativeSheet": {
      "appleFailed": "Anmeldung mit Apple fehlgeschlagen. Bitte versuch es gleich noch einmal.",
      "appleInvalidResponse": "Apple hat eine Antwort geschickt, die wir nicht lesen konnten. Bitte versuch es noch einmal.",
      "appleNotHandled": "Apple konnte die Anmeldeanfrage nicht verarbeiten. Bitte versuch es noch einmal.",
      "appleNotInteractive": "Apple konnte das Anmeldefenster nicht anzeigen. Bitte versuch es noch einmal.",
      "appleUnavailable": "Apple konnte die Anmeldung nicht starten. Prüf in den iOS-Einstellungen, ob du mit deinem Apple Account angemeldet bist, und versuch es dann noch einmal."
    },
    "appleSignInButton": {
      "continue": "Weiter mit Apple",
      "errorFallback": "Bei der Anmeldung mit Apple ist ein Fehler aufgetreten",
      "signingIn": "Anmeldung läuft…"
    },
    "authScreen": {
      "confirmPasswordLabel": "Passwort bestätigen",
      "confirmPasswordPlaceholder": "Passwort erneut eingeben",
      "errorPasswordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein",
      "errorPasswordsMismatch": "Die Passwörter stimmen nicht überein",
      "newPasswordLabel": "Neues Passwort",
      "newPasswordPlaceholder": "Mindestens 8 Zeichen",
      "passwordResetDescription": "Dein Passwort wurde erfolgreich zurückgesetzt.",
      "passwordResetTitle": "Passwort zurückgesetzt",
      "signIn": "Anmelden"
    },
    "errors": {
      "accountNotFound": "Konto nicht gefunden",
      "changeEmailDisabled": "Das Ändern der E-Mail-Adresse ist deaktiviert",
      "credentialAccountNotFound": "Kein Konto mit Passwort gefunden",
      "emailAlreadyVerified": "E-Mail-Adresse ist bereits bestätigt",
      "emailCanNotBeUpdated": "E-Mail-Adresse kann nicht geändert werden",
      "emailMismatch": "E-Mail-Adresse stimmt nicht überein",
      "emailNotVerified": "E-Mail-Adresse nicht bestätigt",
      "failedToUnlinkLastAccount": "Du kannst dein letztes verknüpftes Konto nicht trennen",
      "invalidEmail": "Ungültige E-Mail-Adresse",
      "invalidEmailOrPassword": "E-Mail-Adresse oder Passwort ungültig",
      "invalidOtp": "Ungültiger Code",
      "invalidPassword": "Ungültiges Passwort",
      "invalidToken": "Ungültiger Token",
      "linkedAccountAlreadyExists": "Verknüpftes Konto existiert bereits",
      "otpExpired": "Code abgelaufen",
      "passwordAlreadySet": "Für dieses Konto ist bereits ein Passwort festgelegt",
      "passwordTooLong": "Passwort zu lang",
      "passwordTooShort": "Passwort zu kurz",
      "sessionExpired": "Sitzung abgelaufen. Melde dich erneut an, um diese Aktion auszuführen.",
      "sessionNotFresh": "Sitzung nicht mehr aktuell",
      "socialAccountAlreadyLinked": "Social-Media-Konto bereits verknüpft",
      "tokenExpired": "Token abgelaufen",
      "tooManyAttempts": "Zu viele Versuche",
      "tooManyRequests": "Zu viele Versuche. Warte kurz und versuch es noch einmal.",
      "userAlreadyExists": "Konto existiert bereits.",
      "userAlreadyExistsUseAnotherEmail": "Konto existiert bereits. Verwende eine andere E-Mail-Adresse.",
      "userAlreadyHasPassword": "Für dieses Konto ist bereits ein Passwort festgelegt. Gib es ein, um das Konto zu löschen.",
      "userNotFound": "Konto nicht gefunden"
    },
    "filingExceptionNotice": {
      "worksFromDayOne": "Gästenachrichten, Kalender, Aufgaben und der KI-Assistent funktionieren ab dem ersten Tag."
    },
    "forgotPassword": {
      "backToSignIn": "Zurück zur Anmeldung",
      "codeLabel": "Code zum Zurücksetzen",
      "descriptionCode": "Wir haben einen Code an {email} geschickt. Gib ihn unten zusammen mit deinem neuen Passwort ein.",
      "descriptionEmail": "Gib deine E-Mail-Adresse ein, dann schicken wir dir einen 6-stelligen Code zum Zurücksetzen",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "name@beispiel.de",
      "errorCodeIncomplete": "Gib den 6-stelligen Code aus der E-Mail ein",
      "errorEmailRequired": "E-Mail-Adresse ist erforderlich",
      "resend": "Keinen Code erhalten? Erneut senden",
      "resetting": "Wird zurückgesetzt…",
      "sendCode": "Code senden",
      "submit": "Passwort zurücksetzen",
      "titleCode": "Code eingeben",
      "titleEmail": "Passwort vergessen"
    },
    "googleSignInButton": {
      "continue": "Weiter mit Google",
      "signingIn": "Anmeldung läuft…"
    },
    "legalConsent": {
      "agreement": "Mit dem Erstellen eines Kontos stimmst du unseren <terms>Nutzungsbedingungen</terms> und unserer <privacy>Datenschutzerklärung</privacy> zu."
    },
    "oauthConsent": {
      "allow": "Zugriff erlauben",
      "allowing": "Wird erlaubt…",
      "deny": "Ablehnen",
      "denying": "Wird abgelehnt…",
      "errorRequestInvalid": "Diese Verbindungsanfrage ist nicht mehr gültig. Schließ diesen Tab und verbinde dich neu aus deiner KI-App.",
      "errorSessionEnded": "Deine Vidimo-Sitzung ist beendet. Melde dich erneut an und verbinde dich dann neu aus deiner KI-App.",
      "errorUnreachable": "Vidimo ist nicht erreichbar. Prüf deine Verbindung und versuch es noch einmal.",
      "expiredDescription": "Diese Verbindungsanfrage ist ungültig oder abgelaufen. Schließ diesen Tab und verbinde dich neu aus deiner KI-App.",
      "expiredTitle": "Verbindungsanfrage abgelaufen",
      "goToSignIn": "Zur Anmeldung",
      "guestsDetail": "Kontaktdaten, Meldestatus",
      "guestsLabel": "Gäste & Meldung",
      "loading": "Wird geladen…",
      "occupancyDetail": "Kennzahlen, Zimmer, Team",
      "occupancyLabel": "Belegung & Infos zur Unterkunft",
      "importHeading": "Deine bestehenden Buchungen importieren",
      "importScope": "Inhaber und Manager können der KI-App erlauben, Buchungen aus deinem bisherigen System in eine Unterkunft zu kopieren, die in Vidimo noch in Vorbereitung ist. Die KI-App kann nur Buchungen ändern oder stornieren, die aus deinem bisherigen System importiert wurden, und nichts Importiertes erreicht Gäste, Kanäle oder Behörden.",
      "readOnlyHeading": "Nur Lesezugriff auf",
      "readOnlyScope": "Nur das, was deine Rolle in der App ohnehin sieht. Die KI-App kann nichts erstellen, ändern, senden oder löschen.",
      "readOnlyScopeExceptImport": "Nur das, was deine Rolle in der App ohnehin sieht. Außer dem Import von Buchungen kann die KI-App nichts erstellen, ändern, senden oder löschen.",
      "readableItem": "<strong>{label}</strong><muted>: {detail}</muted>",
      "reservationsDetail": "Buchungen, Daten, freie Zimmer",
      "reservationsLabel": "Reservierungen & Verfügbarkeit",
      "signInRequiredDescription": "Deine Vidimo-Sitzung ist beendet. Melde dich an und starte die Verbindung dann neu aus deiner KI-App.",
      "signInRequiredTitle": "Anmeldung erforderlich",
      "signedInAs": "Angemeldet als {email}. Du kannst die Verbindung jederzeit in {name} trennen.",
      "signedInAsUnnamed": "Angemeldet als {email}. Du kannst die Verbindung jederzeit in deiner KI-App trennen.",
      "tasksDetail": "Reinigung und Wartung",
      "tasksLabel": "Aufgaben",
      "title": "Zugriff auf deine Vidimo-Daten erlauben?",
      "touristTaxDetail": "geschuldete und bezahlte Beträge",
      "touristTaxLabel": "Kurtaxe & Salden",
      "wantsToConnect": "<app>{name}</app> möchte sich mit deinem Vidimo-Konto verbinden.",
      "wantsToConnectUnnamed": "Eine KI-App möchte sich mit deinem Vidimo-Konto verbinden."
    },
    "resetPassword": {
      "backToSignIn": "Zurück zur Anmeldung",
      "description": "Gib unten dein neues Passwort ein",
      "errorTokenMissing": "Token zum Zurücksetzen ungültig oder fehlt",
      "resetting": "Wird zurückgesetzt…",
      "submit": "Passwort zurücksetzen",
      "title": "Passwort zurücksetzen"
    },
    "signIn": {
      "description": "Gib deine E-Mail-Adresse ein, um dich bei deinem Konto anzumelden",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "name@beispiel.de",
      "errorCredentialsRequired": "E-Mail-Adresse und Passwort sind erforderlich",
      "forgotPassword": "Passwort vergessen?",
      "noAccount": "Noch kein Konto?",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Passwort eingeben",
      "signUp": "Registrieren",
      "signingIn": "Anmeldung läuft…",
      "submit": "Anmelden",
      "title": "Anmelden"
    },
    "signUp": {
      "creatingAccount": "Konto wird erstellt…",
      "description": "Registriere dich, um mit Vidimo loszulegen",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "name@beispiel.de",
      "errorCredentialsRequired": "E-Mail-Adresse und Passwort sind erforderlich",
      "errorNameRequired": "Anzeigename ist erforderlich",
      "errorPasswordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein",
      "haveAccount": "Schon ein Konto?",
      "nameLabel": "Anzeigename",
      "namePlaceholder": "Max Mustermann",
      "passwordHint": "Mindestens 8 Zeichen",
      "passwordLabel": "Passwort",
      "passwordPlaceholder": "Mindestens 8 Zeichen",
      "signIn": "Anmelden",
      "submit": "Konto erstellen",
      "title": "Konto erstellen"
    },
    "socialSignIn": {
      "divider": "Oder weiter mit"
    },
    "verifyEmail": {
      "backToSignIn": "Zurück zur Anmeldung",
      "continue": "Weiter",
      "errorLinkExpired": "Dieser Bestätigungslink ist abgelaufen. Fordere einen neuen an.",
      "errorLinkFailed": "Dieser Bestätigungslink hat nicht funktioniert.",
      "errorLinkInvalid": "Dieser Bestätigungslink ist nicht mehr gültig.",
      "errorLinkNotVerified": "Dieser Bestätigungslink hat nicht funktioniert. Fordere einen neuen an.",
      "errorNoSessionEmail": "Keine E-Mail-Adresse in der Sitzung gefunden",
      "errorNotConfirmed": "Wir konnten nicht bestätigen, dass deine E-Mail-Adresse verifiziert wurde.",
      "errorTokenMissing": "Bestätigungstoken ungültig oder fehlt",
      "failedTitle": "Bestätigung fehlgeschlagen",
      "goToSignIn": "Zur Anmeldung",
      "resend": "Bestätigungs-E-Mail erneut senden",
      "resent": "Gesendet: Sieh in deinem Posteingang nach dem neuen Link.",
      "sendAnother": "Neuen Link senden",
      "successDescription": "Deine E-Mail-Adresse wurde bestätigt. Du wirst automatisch angemeldet.",
      "successTitle": "E-Mail-Adresse bestätigt",
      "unconfirmedDescription": "Du bist abgemeldet, daher können wir das Ergebnis hier nicht bestätigen. Melde dich an: Wenn der Link funktioniert hat, ist deine E-Mail-Adresse bereits bestätigt.",
      "unconfirmedTitle": "Prüf deinen Bestätigungslink"
    }
  },

  "calendar": {
    "agendaData": {
      "arrival": "Anreise",
      "balanceDue": "{amount} offen",
      "departure": "Abreise",
      "due": "Fällig am {date}",
      "eta": "Ankunft ca. {time}",
      "guest": "Gast",
      "inHouse": "Im Haus",
      "paid": "Bezahlt",
      "until": "Bis {date}"
    },
    "calendarAgendaView": {
      "arrivals": "Anreisen",
      "departures": "Abreisen",
      "emptyDescription": "Keine Anreisen, Abreisen oder Gäste im Haus am {date}.",
      "emptyDescriptionToday": "Heute keine Anreisen, Abreisen oder Gäste im Haus.",
      "emptyTitle": "Nichts geplant",
      "inHouse": "Im Haus",
      "syncing": "Deine Tagesübersicht wird synchronisiert…",
      "tasksFor": "Aufgaben für {guestName}",
      "unassigned": "Nicht zugewiesen",
      "unconfirmed": "Unbestätigt"
    },
    "calendarAvailabilityBand": {
      "free": "Frei",
      "freeRoomsPerNight": "Freie Zimmer pro Nacht",
      "roomsFree": "{count, plural, one {Zimmer frei} other {Zimmer frei}}",
      "spokenDatePrefix": "{date}: "
    },
    "calendarLegend": {
      "markBase": "Grundpreis",
      "markChanged": "Gerade geändert",
      "markChosen": "Zum Ändern ausgewählt",
      "markChosenClosed": "Ausgewählt, nicht buchbar",
      "markClosed": "Nicht buchbar",
      "markMinStay": "Mindestaufenthalt",
      "markSeason": "Saisonpreis",
      "markSet": "Für diese Nacht festgelegt",
      "rates": "Preise",
      "reservations": "Reservierungen",
      "tapActivity": "Wer was geändert hat, siehst du in den Einstellungen der Unterkunft unter „Team“ > „Aktivität“.",
      "tapDate": "Tippe auf ein Datum, um diese Nacht für alle Einheitstypen der Unterkunft zu ändern.",
      "tapNight": "Tippe auf eine Nacht, um sie zu ändern.",
      "tapOtherRow": "Tippe auf eine Nacht in einer anderen Zeile, um diesen Einheitstyp hinzuzufügen.",
      "tapSpan": "Tippe auf eine zweite Nacht in derselben Zeile für mehrere Nächte am Stück.",
      "tasks": "Aufgaben",
      "title": "Legende"
    },
    "calendarPage": {
      "createFirstUnit": "Erste Einheit anlegen",
      "emptyDescription": "Füge deiner Unterkunft eine Einheit hinzu, um Reservierungen im Kalender zu verfolgen.",
      "emptyTitle": "Noch keine Einheiten",
      "legend": "Kalenderlegende",
      "newReservation": "Neue Reservierung",
      "newTask": "Neue Aufgabe",
      "tasksMissingTitle": "Aufgaben werden im Kalender gerade nicht angezeigt",
      "title": "Kalender",
      "unavailableDescription": "Vidimo konnte deine Einheiten auf diesem Gerät nicht laden. Beim erneuten Versuch startet die App neu.",
      "unavailableTitle": "Der Kalender lässt sich gerade nicht anzeigen"
    },
    "calendarView": {
      "blockDates": "Nächte sperren",
      "blockingHint": "Zieh in der Zeile eines Zimmers über die Nächte, die du sperren willst. Wisch zum Scrollen über die Datumsleiste oder die Zimmernamen. Um einen Aufenthalt zu öffnen, tipp zuerst auf „{done}“.",
      "doneBlocking": "Sperren beenden",
      "errorBlockFailed": "Die Nächte konnten nicht gesperrt werden. Versuch es noch einmal.",
      "jumpToDate": "Zu Datum springen",
      "next": "Weiter",
      "noUnits": "Keine Einheiten zum Anzeigen",
      "previous": "Zurück",
      "staffEmptyDescription": "Die Teamansicht zeigt die zugewiesenen Aufgaben und Abwesenheiten jedes Teammitglieds.",
      "staffEmptyTitle": "Keine Teammitglieder zum Anzeigen",
      "syncing": "Dein Kalender wird synchronisiert…",
      "today": "Heute",
      "unassignedLane": "Nicht zugewiesen",
      "unknownProperty": "Unbekannte Unterkunft"
    },
    "calendarViewMenu": {
      "title": "Ansicht",
      "triggerLabel": "Ansicht: {view}"
    },
    "propertyEmptyState": {
      "acceptInvitation": "Einladung annehmen",
      "back": "Zurück",
      "createDescription": "Lege eine neue Unterkunft an, um Gäste und Team zu verwalten.",
      "createInstead": "Stattdessen Unterkunft anlegen",
      "createTitle": "Unterkunft anlegen",
      "errorCreateFailed": "Die Unterkunft konnte nicht angelegt werden. Versuch es noch einmal.",
      "getStartedDescription": "Lege eine neue Unterkunft an oder tritt einer bestehenden mit einem Einladungscode bei.",
      "getStartedTitle": "Los geht’s",
      "invitedAs": "Eingeladen als {role}",
      "invitedDescription": "{count, plural, one {Du wurdest zu einer Unterkunft eingeladen. Nimm die Einladung an, um loszulegen.} other {Du wurdest zu diesen Unterkünften eingeladen. Nimm eine Einladung an, um loszulegen.}}",
      "invitedTitle": "Du bist eingeladen",
      "joinDescription": "Gib den erhaltenen Einladungscode ein, um deinem Team beizutreten.",
      "joinTitle": "Einer Unterkunft beitreten",
      "syncing": "Deine Unterkunft wird eingerichtet…",
      "syncingSlow": "Das dauert länger als üblich. Deine Unterkunft ist angelegt und erscheint, sobald deine Verbindung aufgeholt hat.",
      "toastCreated": "Unterkunft angelegt"
    },
    "timelineData": {
      "away": "Abwesend"
    },
    "todayPage": {
      "nextDay": "Nächster Tag",
      "pickDay": "Tag wählen",
      "previousDay": "Vorheriger Tag"
    },
    "transportSelector": {
      "changeTransport": "Kanal wechseln",
      "menuLabel": "Kanal auswählen"
    },
    "unitReadinessControl": {
      "errorUpdateFailed": "Der Zimmerstatus konnte nicht aktualisiert werden. Versuch es noch einmal.",
      "hint": "Wird beim Ändern gespeichert. Eine abgeschlossene Reinigungsaufgabe setzt den Status auf „Sauber“, ein Check-out auf „Schmutzig“, außer bei „Außer Betrieb“: Das kannst nur du aufheben.",
      "label": "Zimmerstatus",
      "outOfOrderHint": "„Außer Betrieb“ verhindert außerdem neue Buchungen in diesem Zimmer und pausiert den Türcode für alle, die gerade darin wohnen."
    }
  },

  "checkIn": {
    "guestRegistration": {
      "anotherGuest": "einem anderen Gast",
      "heldByOther": "{documentNumber} ist bereits bei {holderName} erfasst."
    },
    "useRegistrationOutbox": {
      "deferred": "{count, plural, one {Die Meldung von {guests} wurde von einem anderen Benutzerkonto übernommen. Sie wird übermittelt, sobald sich diese Person hier wieder anmeldet.} other {Die Meldungen von {guests} wurden von anderen Benutzerkonten übernommen. Sie werden übermittelt, sobald sich diese Personen hier wieder anmelden.}}",
      "dropped": "{count, plural, one {Die Meldung von {guests} konnte nicht übermittelt werden. Öffne die Reservierung, um sie zu korrigieren.} other {Die Meldungen von {guests} konnten nicht übermittelt werden. Öffne die Reservierungen, um sie zu korrigieren.}}",
      "filed": "{count, plural, one {Eine ausstehende Gästemeldung wurde übermittelt.} other {# ausstehende Gästemeldungen wurden übermittelt.}}",
      "guestsOneNameAndOthers": "{first} und {count, plural, one {# weiteren Person} other {# weiteren Personen}}",
      "guestsTwoNames": "{first} und {second}",
      "guestsTwoNamesAndOthers": "{first}, {second} und {count, plural, one {# weiteren Person} other {# weiteren Personen}}",
      "guestsUnnamed": "{count, plural, one {einem Gast} other {# Gästen}}"
    }
  },

  "common": {
    "countryPicker": {
      "emptyLabel": "Kein Land gefunden",
      "placeholder": "Land auswählen",
      "searchLabel": "Land suchen"
    },
    "dateRangePicker": {
      "nights": "{nights, plural, one {# Nacht} other {# Nächte}}",
      "placeholder": "Zeitraum wählen"
    },
    "detailsDrawer": {
      "close": "Schließen",
      "copyLinkLabel": "Link zu diesem Eintrag kopieren",
      "edit": "Bearbeiten"
    },
    "dialog": {
      "close": "Schließen"
    },
    "errors": {
      "generic": "Etwas ist schiefgelaufen. Bitte versuch es noch einmal.",
      "networkUnreachable": "Keine Verbindung. Prüf dein Netzwerk und versuch es noch einmal.",
      "subscriptionRequired": "Diese Unterkunft hat kein aktives Abo, daher ist das noch nicht möglich.",
      "unreadableNumber": "Gib eine Zahl wie {example, number} ein."
    },
    "insetForm": {
      "cancel": "Abbrechen",
      "save": "Speichern",
      "saving": "Wird gespeichert…"
    },
    "loading": "Wird geladen",
    "personCard": {
      "call": "Anrufen",
      "callLabel": "{name} anrufen",
      "idOnFile": "Ausweis erfasst",
      "message": "Nachricht",
      "openLabel": "{name} öffnen"
    },
    "phoneNumberInput": {
      "country": "Ländervorwahl",
      "international": "International",
      "invalid": "Prüf die Nummer und wähl über die Flagge das richtige Land."
    },
    "picker": {
      "done": "Fertig",
      "noMatches": "Keine Treffer",
      "search": "Suchen"
    }
  },

  "communications": {
    "connectRefusalDrafts": {
      "account_claimed": "Hallo, ich möchte ein Konto verbinden, das bereits mit einer anderen Unterkunft verknüpft ist. Könnt ihr mir helfen?",
      "number_claimed": "Hallo, ich möchte eine Nummer verbinden, die bereits mit einer anderen Unterkunft verknüpft ist. Könnt ihr mir helfen?",
      "property_preparing": "Hallo, ich möchte einen Kanal verbinden, während meine Unterkunft noch in Vorbereitung ist. Könnt ihr mir helfen?",
      "setup_broken": "Hallo, beim Verbinden eines Kanals ist die Einrichtung an einer Stelle stehen geblieben, an der die App nicht weitermachen kann. Könnt ihr mir helfen?",
      "subscription_required": "Hallo, beim Verbinden eines Kanals wird ein aktives Abo verlangt. Könnt ihr mir helfen?"
    },
    "activeCallView": {
      "activeCall": "Aktiver Anruf",
      "hangUp": "Auflegen",
      "minimiseCall": "Anruf minimieren",
      "mute": "Stummschalten",
      "roomStatus": "Zimmer {unitCode} · {status}",
      "speakerOff": "Lautsprecher aus",
      "speakerOn": "Lautsprecher an",
      "transfer": "Weiterleiten",
      "unmute": "Stummschaltung aufheben"
    },
    "aiChatListView": {
      "emptyDescription": "Starte eine neue Unterhaltung mit deinem KI-Assistenten",
      "emptyTitle": "Keine KI-Unterhaltungen",
      "newChat": "Neuer Chat"
    },
    "aiChatView": {
      "aiAssistant": "KI-Assistent",
      "chooseProperty": "Unterkunft wählen",
      "choosePropertyDescription": "Der Assistent antwortet immer für eine Unterkunft, also wähle die, zu der du etwas fragen möchtest.",
      "choosePropertyTitle": "Welche Unterkunft?",
      "emptyDescription": "Frag mich zu Gästen, Reservierungen oder Aufgaben im Betrieb",
      "emptyTitle": "Wie kann ich dir heute helfen?",
      "errorAmbiguousScopeDetail": "Der Assistent antwortet immer für eine Unterkunft. Wähle oben eine aus und frag noch einmal.",
      "errorAmbiguousScopeTitle": "Unterkunft wählen",
      "errorEmptyScopeDetail": "Dein Bereich enthält keine Unterkunft, auf die du Zugriff hast. Erweitere ihn oben und versuch es noch einmal.",
      "errorEmptyScopeTitle": "Nichts im Bereich",
      "errorPausedDetailNative": "Die KI ist in einem aktiven Abo für diese Unterkunft enthalten.",
      "errorPausedTitle": "KI ist pausiert",
      "errorSend": "Deine Nachricht konnte nicht gesendet werden. Versuch es noch einmal.",
      "errorTranscribe": "Deine Aufnahme konnte nicht transkribiert werden",
      "errorUnreachableDetail": "Prüf deine Verbindung und versuch es noch einmal.",
      "errorUnreachableTitle": "Der Assistent konnte nicht antworten",
      "newChat": "Neuer Chat",
      "retry": "Erneut versuchen",
      "retryTooltip": "Letzte Nachricht erneut senden",
      "suggestionCheckIns": "Zeig mir die Check-ins von heute",
      "suggestionMaintenance": "Gibt es Wartungsprobleme?",
      "suggestionOccupancy": "Wie war unsere Auslastung letzten Monat?"
    },
    "aiMessageParts": {
      "copied": "In die Zwischenablage kopiert",
      "copyTooltip": "Nachricht kopieren",
      "errorCopy": "Die Nachricht konnte nicht kopiert werden",
      "moreActions": "Weitere Aktionen",
      "regenerate": "Neu generieren",
      "sourceFallbackTitle": "Reservierungsreferenz"
    },
    "aiPromptComposer": {
      "placeholder": "Frag einfach",
      "placeholderTranscribing": "Wird transkribiert…"
    },
    "callEventBubble": {
      "callEnded": "Anruf beendet",
      "callWithDuration": "Anruf · {duration}",
      "calling": "Wird angerufen…",
      "incomingCall": "Eingehender Anruf",
      "incomingCallRinging": "Eingehender Anruf…",
      "missedCall": "Verpasster Anruf",
      "ongoingCall": "Laufender Anruf · {duration}",
      "outgoingCall": "Ausgehender Anruf",
      "outgoingMissedCall": "Ausgehender Anruf, nicht angenommen"
    },
    "chatHeader": {
      "back": "Zurück",
      "badgeGuest": "Gast",
      "badgeInternal": "Intern",
      "badgeSupport": "Support",
      "call": "{name} anrufen",
      "linkReservation": "Reservierung verknüpfen",
      "openReservation": "Reservierung öffnen",
      "unknownName": "Unbekannt"
    },
    "chatInputBar": {
      "placeholder": "Nachricht schreiben…",
      "recordVoice": "Sprachnachricht aufnehmen",
      "sendDocument": "Dokument senden",
      "sendPhotoOrVideo": "Foto oder Video senden",
      "transcribing": "Wird transkribiert…"
    },
    "chatItem": {
      "chatWith": "Chat mit {name}",
      "noMessages": "Noch keine Nachrichten",
      "unknownName": "Unbekannt"
    },
    "chatMessageBubble": {
      "copied": "In die Zwischenablage kopiert",
      "copyMessage": "Nachricht kopieren",
      "dismissReactionPicker": "Reaktionsauswahl schließen",
      "errorCopy": "Die Nachricht konnte nicht kopiert werden",
      "messagePlaceholder": "Nachricht",
      "senderAndTime": "{sender} · {time}"
    },
    "chatView": {
      "emptyDescription": "Schick eine Nachricht, um die Unterhaltung zu beginnen",
      "emptyTitle": "Unterhaltung beginnen",
      "scrollToNewest": "Zur neuesten Nachricht scrollen"
    },
    "chatsTabBar": {
      "ai": "KI",
      "guests": "Gäste",
      "openDialer": "Wähltastatur öffnen",
      "staff": "Team",
      "unread": "{count, plural, one {{count} ungelesen} other {{count} ungelesen}}"
    },
    "chatsView": {
      "emptyDescription": "Wähle einen Gäste-, Team- oder KI-Chat aus der Liste",
      "emptyTitle": "Unterhaltung auswählen",
      "hideConversationList": "Unterhaltungsliste ausblenden",
      "showConversationList": "Unterhaltungsliste einblenden"
    },
    "deliveryErrorCopy": {
      "genericFailure": "Diese Nachricht konnte nicht zugestellt werden.",
      "instagramGeneric": "Diese Antwort konnte auf Instagram nicht gesendet werden.",
      "instagramLateReplyRefused": "Nicht gesendet: Instagram hat Vidimo noch nicht dafür freigegeben, mehr als 24 Stunden nach der letzten Nachricht des Gastes zu antworten.",
      "instagramNoIdentity": "Nicht gesendet: Dieser Gast ist auf Instagram nicht erreichbar.",
      "instagramNotConnected": "Nicht gesendet: Instagram ist für diese Unterkunft nicht verbunden. Verbinde es neu unter „Einstellungen“ > „Nachrichten“.",
      "instagramUndeliverable": "Instagram hat diese Nachricht nicht zugestellt. Womöglich hat der Gast das Konto blockiert oder den Chat gelöscht.",
      "instagramWindowClosed": "Nicht gesendet: Das Antwortfenster von Instagram ist geschlossen. Der Gast muss erneut schreiben.",
      "invalidNumber": "Die Telefonnummer des Gastes scheint ungültig zu sein. Prüf die Kontaktdaten des Gastes.",
      "optedOut": "Der Gast hat Nachrichten von dieser Nummer abbestellt. Senden bleibt blockiert, bis er sie wieder zulässt.",
      "phoneUnreachable": "Das Handy des Gastes ist nicht erreichbar, vielleicht ist es aus oder ohne Empfang. Versuch es später noch einmal.",
      "whatsappWindowClosed": "Das 24-Stunden-Antwortfenster von WhatsApp ist geschlossen. Kontaktiere den Gast erneut mit einer genehmigten Vorlagennachricht."
    },
    "dialerDrawer": {
      "call": "Anrufen",
      "calling": "Wird angerufen…",
      "cancel": "Abbrechen",
      "description": "Wähle eine Nummer oder suche einen bestehenden Gast.",
      "errorAlreadyInCall": "Du bist bereits in einem Anruf",
      "errorCallingUnsupported": "Anrufe sind nur in der mobilen App möglich",
      "errorPermissionRequest": "Die Berechtigungsanfrage konnte nicht gesendet werden. Versuch es noch einmal.",
      "errorStartCall": "Der Anruf konnte nicht gestartet werden",
      "guest": "Gast",
      "noMatches": "Keine Treffer",
      "permissionRequestSent": "Berechtigungsanfrage über WhatsApp gesendet",
      "phoneNumber": "Telefonnummer",
      "phoneNumberPlaceholder": "Telefonnummer eingeben",
      "refusal": {
        "invalid_phone_number": "Diese Telefonnummer ist ungültig. Gib sie mit Ländervorwahl ein, zum Beispiel +49.",
        "whatsapp_not_connected": "Diese Unterkunft hat keine verbundene WhatsApp-Nummer. Verbinde eine in den Einstellungen und versuch es dann noch einmal."
      },
      "requestCallPermission": "Anrufberechtigung anfragen (WhatsApp)",
      "search": "Suchen",
      "searchPlaceholder": "Name oder Nummer suchen",
      "sending": "Wird gesendet…",
      "staff": "Team",
      "title": "Anruf starten"
    },
    "entityShareCard": {
      "guestFallbackName": "Gast",
      "kindBooking": "Buchung",
      "kindGuest": "Gast",
      "kindTask": "Aufgabe",
      "noUpcomingStay": "Kein bevorstehender Aufenthalt",
      "sharedBooking": "Hat eine Buchung geteilt",
      "sharedGuest": "Hat einen Gast geteilt",
      "sharedTask": "Hat eine Aufgabe geteilt",
      "stayDates": "{checkIn} – {checkOut}",
      "unassigned": "Nicht zugewiesen",
      "unscheduled": "Ohne Termin"
    },
    "guestChatDetails": {
      "erasedStaffSender": "Ehemaliges Teammitglied",
      "errorAccountLoading": "Dein Konto wird noch geladen. Versuch es gleich noch einmal",
      "errorNoMembership": "Deine Mitgliedschaft für diese Unterkunft konnte nicht ermittelt werden",
      "errorNoProperty": "Wähle zuerst eine Unterkunft aus",
      "errorNotSent": "Deine Nachricht konnte nicht gesendet werden. Versuch es noch einmal.",
      "errorNotStarted": "Dieser Chat konnte nicht gestartet werden. Versuch es noch einmal.",
      "guestFallback": "Gast",
      "linkOnlyStaffDescription": "Gäste können ihn nicht öffnen, daher gibt es nichts zu senden.",
      "linkOnlyStaffTitle": "Dieser Link funktioniert nur in Team-Chats",
      "linkRemovedDescription": "Er funktioniert nur in Team-Chats, daher sieht der Gast ihn nicht.",
      "linkRemovedTitle": "Link zum Eintrag entfernt"
    },
    "guestChatInputBar": {
      "waitingForGuest": "Warten, bis der Gast schreibt"
    },
    "guestChatListView": {
      "emptyDescription": "Warten auf neue Gästenachrichten",
      "emptyTitle": "Keine Gäste-Chats gefunden",
      "fallbackName": "Gast"
    },
    "guestChatMessageBubble": {
      "attachment": "Anhang",
      "copyErrorForSupport": "Fehler für den Support kopieren",
      "draftReply": "Antwort entwerfen",
      "drafting": "Wird entworfen…",
      "errorCopied": "Fehler für den Support kopiert",
      "errorCopyFailed": "Der Fehler konnte nicht kopiert werden",
      "retry": "Erneut versuchen",
      "retrySendFailed": "Erneutes Senden fehlgeschlagen, bitte versuch es noch einmal",
      "retryTranscriptionFailed": "Erneute Transkription fehlgeschlagen, bitte versuch es noch einmal",
      "showOriginal": "Original anzeigen",
      "showTranslation": "Übersetzung anzeigen",
      "statusDelivered": "Zugestellt",
      "statusFailed": "Fehlgeschlagen",
      "statusPending": "Ausstehend",
      "statusRead": "Gelesen",
      "statusSent": "Gesendet",
      "translate": "Übersetzen",
      "translateMessage": "Nachricht übersetzen",
      "translating": "Wird übersetzt…"
    },
    "guestChatView": {
      "draftFailed": "Es konnte keine Antwort entworfen werden. Versuch es noch einmal.",
      "placeholderCheckingAccess": "Dein Zugriff wird geprüft…",
      "placeholderDiverted": "Antwort per {transport}, da über {divertedFrom} nicht möglich",
      "placeholderLoadingChannels": "Kanäle werden geladen…",
      "placeholderNoChannel": "Hier kann noch kein Kanal senden",
      "placeholderReply": "Dem Gast antworten…",
      "placeholderUnreachable": "Der Gast ist über keinen Kanal erreichbar",
      "voiceNoteFailed": "Die Sprachnachricht konnte nicht gesendet werden"
    },
    "guestChats": {
      "linkFailed": "Diese Unterhaltung konnte nicht mit der Buchung verknüpft werden.",
      "refusal": {
        "chat_not_found": "Diese Unterhaltung gibt es nicht mehr.",
        "no_room": "Diese Buchung hat kein Zimmer, dem ein Gast hinzugefügt werden kann.",
        "party_full": "Für diese Buchung sind bereits alle erwarteten Gäste erfasst. Um diesen Gast hinzuzufügen, erhöhe zuerst die Zahl der Erwachsenen, Kinder oder Kleinkinder.",
        "reservation_not_active": "Zu dieser Buchung können keine Gäste mehr hinzugefügt werden.",
        "reservation_not_found": "Diese Buchung gibt es nicht mehr."
      }
    },
    "guestDetails": {
      "age": "{age, plural, one {{age} Jahr alt} other {{age} Jahre alt}}",
      "call": "Anrufen",
      "documentTypeIdCard": "Personalausweis",
      "documentTypeOther": "Sonstiges",
      "documentTypePassport": "Reisepass",
      "expires": "Gültig bis {date}",
      "guestInformation": "Gastdaten",
      "identityDocuments": "Ausweisdokumente",
      "issuedBy": "Ausgestellt von {country}",
      "loadError": "Dieses Gastprofil konnte nicht geladen werden.",
      "merge": "Zusammenführen",
      "message": "Nachricht",
      "notFoundDescription": "Dieser Gast gehört womöglich zu einer Unterkunft, die gerade nicht ausgewählt ist. Wechsle die Unterkunft und versuch es noch einmal.",
      "notFoundTitle": "Gast nicht gefunden",
      "relatedBookings": "Zugehörige Buchungen"
    },
    "guestDirectoryView": {
      "allStatuses": "Alle Status",
      "allUnits": "Alle Einheiten",
      "arrivalDates": "Anreisedaten",
      "callGuest": "{name} anrufen",
      "clear": "Zurücksetzen",
      "emptyDescription": "Gäste erscheinen hier, sobald sie buchen oder einchecken.",
      "emptyTitle": "Noch keine Gäste",
      "filteredCount": "{count, plural, one {{filtered} von {count}} other {{filtered} von {count}}}",
      "guestCount": "{count, plural, one {{count} Gast} other {{count} Gäste}}",
      "noMatchesDescription": "Keine Gäste entsprechen diesen Filtern.",
      "noMatchesTitle": "Keine Treffer",
      "openGuest": "{name} öffnen",
      "searchPlaceholder": "Name, Telefon oder E-Mail suchen…",
      "statusFilterLabel": "Nach Reservierungsstatus filtern",
      "syncing": "Deine Gäste werden synchronisiert…",
      "title": "Gäste",
      "unitFilterLabel": "Nach Einheit filtern"
    },
    "guestReplyDeniedBar": {
      "cannotReply": "Mit deiner Rolle in dieser Unterkunft kannst du Gästen nicht antworten",
      "preparing": "Diese Unterkunft ist in Vorbereitung, daher antwortet dein bisheriges System den Gästen weiterhin"
    },
    "guestTransports": {
      "emailNotConfigured": "Der E-Mail-Kanal ist noch nicht eingerichtet.",
      "inboundOnly": "{platform}-Nachrichten kommen hier an, aber Antworten können noch nicht gesendet werden.",
      "instagramNotSetUp": "Instagram ist noch nicht eingerichtet.",
      "smsNotConnected": "Mit dieser Unterkunft ist noch keine SMS-Nummer verbunden.",
      "smsUnavailable": "SMS ist noch nicht verfügbar.",
      "whatsAppNotConnected": "WhatsApp ist noch nicht mit dieser Unterkunft verbunden.",
      "whatsAppSettingUp": "WhatsApp wird noch eingerichtet. Das dauert meist ein paar Minuten."
    },
    "inCallOverlay": {
      "activeCall": "Aktiver Anruf",
      "expandActiveCall": "Aktiven Anruf vergrößern",
      "hangUp": "Auflegen",
      "mute": "Stummschalten",
      "speakerOff": "Lautsprecher aus",
      "speakerOn": "Lautsprecher an",
      "unmute": "Stummschaltung aufheben"
    },
    "incomingCallView": {
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "headerPhone": "Eingehend · Telefon",
      "headerWhatsApp": "Eingehend · WhatsApp",
      "hintCheckingInToday": "Reist heute an",
      "hintCheckingInTomorrow": "Reist morgen an",
      "hintCheckingOutToday": "Reist heute ab",
      "hintCheckingOutTomorrow": "Reist morgen ab",
      "hintInDays": "{count, plural, one {In # Tag} other {In # Tagen}}",
      "roomStatus": "Zimmer {unit} · {status}",
      "roomStatusWithHint": "Zimmer {unit} · {status} · {hint}",
      "unknownCaller": "Unbekannter Anrufer"
    },
    "incomingStaffCallView": {
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "header": "Eingehend · Intern",
      "internal": "Intern",
      "internalAtProperty": "Intern · {property}",
      "internalCall": "Interner Anruf"
    },
    "instagramWindowNotice": {
      "closed": "Das Antwortfenster von Instagram ist geschlossen. Der Gast muss erneut schreiben, bevor du antworten kannst.",
      "closesOn": "Instagram schließt diesen Chat am {date}.",
      "neverMessaged": "Instagram erlaubt nur Antworten. Der Gast muss dir zuerst schreiben."
    },
    "linkReservationPicker": {
      "description": "Wähle die Buchung, um die es in dieser Unterhaltung geht. {name} wird zur Gästeliste dieser Buchung hinzugefügt.",
      "noReservations": "Keine laufenden oder bevorstehenden Buchungen zum Verknüpfen",
      "noSearchMatches": "Keine Buchung passt zu deiner Suche",
      "searchPlaceholder": "Nach Gast, Buchungsnummer oder Einheit suchen…",
      "title": "Reservierung verknüpfen",
      "unnamedBooker": "Gast ohne Namen"
    },
    "loadEarlierMessages": {
      "label": "Ältere Nachrichten laden"
    },
    "media": {
      "tooLarge": "Diese Datei ist zu groß. Maximal {max}."
    },
    "mergeGuestPickerModal": {
      "descriptionNamed": "Führe diesen Gast mit einem anderen Profil zusammen. Wähle das Zielprofil aus. Die Angaben von {name} werden diesem Profil hinzugefügt.",
      "descriptionUnnamed": "Führe diesen Gast mit einem anderen Profil zusammen. Wähle das Zielprofil aus. Die Angaben dieses Gastes werden diesem Profil hinzugefügt.",
      "noOtherGuests": "Keine anderen Gäste zum Zusammenführen",
      "noSearchMatches": "Keine Gäste entsprechen deiner Suche",
      "searchPlaceholder": "Nach Gastnamen suchen…",
      "suggestedByAi": "Von der KI vorgeschlagen",
      "title": "Gäste zusammenführen"
    },
    "messageAttachment": {
      "document": "Dokument",
      "photo": "Foto",
      "photoUnavailable": "Foto nicht verfügbar",
      "videoUnavailable": "Video nicht verfügbar"
    },
    "messageContextMenu": {
      "dismissMenu": "Menü schließen",
      "moreActions": "Weitere Aktionen",
      "react": "Reagieren"
    },
    "messageReactionPicker": {
      "moreReactions": "Weitere Reaktionen",
      "reactWith": "Mit {emoji} reagieren"
    },
    "microphone": {
      "permissionMessage": "Um Anrufe zu tätigen und anzunehmen, braucht Vidimo Zugriff auf dein Mikrofon. Tippe auf „Einstellungen“ und aktiviere „Mikrofon“.",
      "permissionTitle": "Mikrofonzugriff nötig",
      "settingsGuidance": "Öffne „Einstellungen“ > „Apps“ > „Vidimo“ und aktiviere „Mikrofon“."
    },
    "nativeListeners": {
      "errorCallFailed": "Anruf fehlgeschlagen. Bitte versuch es noch einmal."
    },
    "reactionPills": {
      "reaction": "{count, plural, one {Reaktion {emoji}, {count}} other {Reaktion {emoji}, {count}}}"
    },
    "recordingErrorBar": {
      "dismiss": "Schließen",
      "error": "Fehler",
      "retry": "Erneut versuchen"
    },
    "sendAttachment": {
      "errorConnection": "Prüf deine Verbindung und versuch es noch einmal.",
      "errorNotSent": "Der Anhang konnte nicht gesendet werden",
      "refusal": {
        "outside_service_window": "WhatsApp erlaubt Anhänge nur innerhalb von 24 Stunden nach der letzten Nachricht des Gastes. Schick ihn per E-Mail oder sende eine Vorlage, um die Unterhaltung wieder zu öffnen.",
        "outside_service_window_voice": "WhatsApp erlaubt Sprachnachrichten nur innerhalb von 24 Stunden nach der letzten Nachricht des Gastes. Schick sie stattdessen per E-Mail.",
        "oversize": "{kind, select, image {Dieses Foto} video {Dieses Video} voice {Diese Sprachnachricht} other {Diese Datei}} ist {size} groß. {transport, select, email {E-Mail erlaubt {max}.} sms {MMS erlaubt {max}. Schick es stattdessen per E-Mail.} staff {Dieser Chat erlaubt {max}.} whatsapp {WhatsApp erlaubt {max}. Schick es stattdessen per E-Mail.} other {Dieser Chat erlaubt {max}. Schick es stattdessen per E-Mail.}}",
        "sms_no_media": "Per SMS lassen sich keine Anhänge senden. Wechsle in dieser Unterhaltung zu WhatsApp oder E-Mail.",
        "unsupported_channel": "Dieser Kanal unterstützt keine Anhänge."
      },
      "rejectedTitle": "Das lässt sich hier nicht senden",
      "rejectedType": "{type} kann nicht im Chat gesendet werden.",
      "rejectedUnknownType": "Dieser Dateityp kann nicht im Chat gesendet werden."
    },
    "staffChatDetails": {
      "groupChatFallbackName": "Gruppenchat",
      "internal": "Intern",
      "manageMembers": "Mitglieder in den Einstellungen der Unterkunft verwalten",
      "memberCount": "{count, plural, one {{count} Mitglied} other {{count} Mitglieder}}",
      "noMembers": "Keine Mitglieder in diesem Chat."
    },
    "staffChatDetailsPage": {
      "directMessageFallback": "Direktnachricht",
      "errorNoMembership": "Deine Mitgliedschaft für diese Unterkunft konnte nicht ermittelt werden",
      "errorNoSharedProperty": "Ihr habt keine gemeinsame Unterkunft",
      "errorNotSent": "Deine Nachricht konnte nicht gesendet werden. Versuch es noch einmal.",
      "errorNotStarted": "Dieser Chat konnte nicht gestartet werden. Versuch es noch einmal.",
      "errorSignedOut": "Melde dich an, um Nachrichten zu senden",
      "errorStillLoading": "Wird noch geladen. Versuch es gleich noch einmal",
      "staffChatFallback": "Team-Chat"
    },
    "staffChatListView": {
      "emptyDescription": "Starte eine Unterhaltung mit deinem Team",
      "emptyTitle": "Keine Team-Chats gefunden"
    },
    "staffChatMessageBubble": {
      "attachmentPlaceholder": "Anhang",
      "deleteMessage": "Nachricht löschen",
      "deletedByOther": "Diese Nachricht wurde gelöscht",
      "deletedByYou": "Du hast diese Nachricht gelöscht",
      "retryTranscriptionFailed": "Erneute Transkription fehlgeschlagen, bitte versuch es noch einmal"
    },
    "staffChatView": {
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "deleteDialogDescription": "Sie wird für alle in diesem Chat entfernt. Im Verlauf bleibt ein Hinweis, dass eine Nachricht gelöscht wurde.",
      "deleteDialogTitle": "Diese Nachricht löschen?",
      "deleteFailed": "Die Nachricht konnte nicht gelöscht werden",
      "replyPlaceholder": "{name} antworten…",
      "sendPlaceholder": "Nachricht senden…",
      "voiceNoteSendFailed": "Die Sprachnachricht konnte nicht gesendet werden"
    },
    "staffDetails": {
      "activeTasks": "{count, plural, one {Aktive Aufgaben ({count})} other {Aktive Aufgaben ({count})}}",
      "call": "Anrufen",
      "completedOn": "Erledigt am {date}",
      "message": "Nachricht",
      "noTasksAssigned": "Keine Aufgaben zugewiesen",
      "recentlyCompleted": "Kürzlich erledigt",
      "staffInformation": "Angaben zum Teammitglied"
    },
    "suggestionActions": {
      "arrivalUpdated": "Voraussichtliche Ankunft auf {time} geändert",
      "checkOutUpdated": "Check-out auf {time} geändert",
      "guestAdded": "{guestName} zur Buchung hinzugefügt",
      "guestAlreadyOnBooking": "{guestName} war bereits in dieser Buchung; die Unterhaltung ist jetzt damit verknüpft",
      "missingLink": "Diesem Vorschlag fehlt die Unterhaltung oder Buchung zum Verknüpfen.",
      "missingTimeChange": "Diesem Vorschlag fehlt, was er zum Übernehmen braucht.",
      "noStayDate": "Diese Buchung hat kein Datum, auf das sich die Uhrzeit beziehen kann.",
      "noTask": "Dieser Vorschlag enthält keine Aufgabe zum Erstellen.",
      "rateChangeMissing": "Dieser Hinweis nennt die betreffende Änderung nicht mehr.",
      "taskCreated": "Aufgabe erstellt: {title}"
    },
    "suggestionCard": {
      "accept": "Übernehmen",
      "dismiss": "Verwerfen",
      "dismissLabel": "Verwerfen: {title}"
    },
    "supportChatDetails": {
      "errorNotSent": "Deine Nachricht konnte nicht gesendet werden. Versuch es noch einmal."
    },
    "supportChatView": {
      "addPhoto": "Foto hinzufügen",
      "dictate": "Nachricht diktieren",
      "dictationFailed": "Das war nicht zu verstehen. Versuch es noch einmal.",
      "dictationNeedsSubscription": "Diktieren braucht ein aktives Abo. Tippen kannst du trotzdem.",
      "emptyDescription": "Sag uns, was du brauchst, in deiner eigenen Sprache: schriftlich, gesprochen oder als Foto. Wir sehen, aus welcher Unterkunft und von welchem Bildschirm du schreibst, das musst du also nicht erklären.",
      "emptyTitle": "Schreib dem Vidimo-Team",
      "photo": "Foto",
      "photoUnavailable": "Foto nicht verfügbar",
      "placeholder": "Schreib dem Vidimo-Team…",
      "removePhoto": "Foto entfernen",
      "send": "Senden",
      "showOriginal": "Original anzeigen",
      "showTranslation": "Übersetzung anzeigen",
      "stopDictating": "Diktieren beenden",
      "supportSession": "In einer Support-Sitzung antwortest du über das CRM.",
      "teamNameWithProperty": "Vidimo-Team · {propertyName}",
      "transcribing": "Wird transkribiert…"
    },
    "supportReplyBanner": {
      "open": "Öffnen"
    },
    "transcribe": {
      "failed": "Die Aufnahme konnte nicht transkribiert werden. Bitte versuch es noch einmal."
    },
    "transferPicker": {
      "empty": "Keine anderen Teammitglieder in dieser Unterkunft, an die du weiterleiten kannst.",
      "title": "Anruf weiterleiten an"
    },
    "useGuestCall": {
      "errorAlreadyInCall": "Du bist bereits in einem Anruf",
      "errorNotStarted": "Der Anruf konnte nicht gestartet werden"
    },
    "useOpenChat": {
      "errorNoProperty": "Wähle zuerst eine Unterkunft aus",
      "errorNoSharedProperty": "Ihr habt keine gemeinsame Unterkunft",
      "errorNotSwitched": "Wechsel zu dieser Unterkunft fehlgeschlagen",
      "errorSelf": "Du kannst dir nicht selbst schreiben",
      "errorStillLoading": "Wird noch geladen. Versuch es gleich noch einmal",
      "switched": "Unterkunft gewechselt",
      "switchedTo": "Zu {name} gewechselt"
    },
    "useShareAudienceGap": {
      "one": "{name} kann das nicht öffnen",
      "people": "{count, plural, one {{count} Person kann das nicht öffnen} other {{count} Personen können das nicht öffnen}}",
      "two": "{first} und {second} können das nicht öffnen"
    },
    "useVoiceRecording": {
      "micBlockedInBrowser": "Der Mikrofonzugriff ist blockiert. Erlaube ihn in deinen Browsereinstellungen und versuch es noch einmal.",
      "micPermissionMessage": "Um eine Sprachnachricht aufzunehmen, braucht Vidimo Zugriff auf dein Mikrofon. Tippe auf „Einstellungen“ und aktiviere „Mikrofon“.",
      "micUnavailable": "Kein Zugriff auf das Mikrofon. Bitte prüf die Berechtigungen.",
      "transcriptionFailed": "Transkription fehlgeschlagen",
      "transcriptionTimedOut": "Zeitüberschreitung bei der Transkription. Prüf deine Verbindung und versuch es noch einmal."
    },
    "voiceContext": {
      "errorNoActiveCall": "Kein aktiver Anruf zum Weiterleiten",
      "errorNotTransferred": "Der Anruf konnte nicht weitergeleitet werden. Versuch es noch einmal.",
      "errorUnsupported": "Anrufe sind nur in der mobilen App möglich"
    },
    "voiceNoteAttachment": {
      "noSpeech": "Keine Sprache erkannt",
      "pause": "Sprachnachricht pausieren",
      "play": "Sprachnachricht abspielen",
      "seek": "In Sprachnachricht springen",
      "transcribing": "Wird transkribiert…",
      "transcript": "Transkript",
      "transcriptUnavailable": "Transkript nicht verfügbar",
      "tryAgain": "Erneut versuchen"
    }
  },

  "connect": {
    "connectScreen": {
      "contactSupport": "Support kontaktieren",
      "returnToVidimo": "Zurück zu Vidimo"
    },
    "instagramConnectResult": {
      "cancelled": {
        "detail": "Die Verbindung wurde abgebrochen. Du kannst jederzeit in Vidimo neu starten.",
        "title": "Instagram nicht verbunden"
      },
      "connected": {
        "detail": "Dein Feed und deine Direktnachrichten sind bereit. Geh zurück zu Vidimo, um weiterzumachen.",
        "title": "Instagram verbunden"
      },
      "connectedElsewhere": {
        "detail": "Dieses Instagram-Konto ist bereits mit einer anderen Unterkunft verbunden. Trenne es dort zuerst oder verbinde ein anderes Konto.",
        "title": "Bereits anderswo verbunden"
      },
      "expired": {
        "detail": "Dieser Verbindungslink ist nicht mehr gültig. Starte neu in der Vidimo-App.",
        "title": "Link abgelaufen"
      },
      "failed": {
        "detail": "Beim Abschließen der Verbindung ist etwas schiefgelaufen. Versuch es in der Vidimo-App noch einmal.",
        "title": "Instagram nicht verbunden"
      },
      "invalidLink": {
        "detail": "Diesem Verbindungslink fehlen Angaben. Starte neu in der Vidimo-App.",
        "title": "Ungültiger Link"
      },
      "subscriptionRequired": {
        "detail": "Um einen Kanal zu verbinden, ist ein aktives Abo nötig.",
        "title": "Abo erforderlich"
      }
    },
    "whatsappConnect": {
      "expiredBody": "Aus Sicherheitsgründen sind diese Verbindungslinks nur kurz gültig, und dieser ist abgelaufen. Geh zurück zu Vidimo und fang über die WhatsApp-Karte unter „Nachrichten“ noch einmal an. An deiner Unterkunft hat sich nichts geändert.",
      "expiredTitle": "Link abgelaufen",
      "failedBody": "Die WhatsApp-Einrichtung konnte nicht geladen werden. Versuch es noch einmal oder starte neu in der Vidimo-App.",
      "failedTitle": "Etwas ist schiefgelaufen",
      "loading": "Wird geladen…",
      "noNumberBody": "Geh zurück zu Vidimo, gib deine WhatsApp-Nummer auf der WhatsApp-Karte unter „Nachrichten“ ein und starte die Verbindung dann noch einmal. Fragt die Karte nicht danach, starte Vidimo zuerst neu, damit es sich aktualisiert. An deiner Unterkunft hat sich nichts geändert.",
      "noNumberTitle": "Nummer in Vidimo eingeben",
      "openFromApp": "Diese Seite lässt sich nur aus der Vidimo-App öffnen.",
      "title": "WhatsApp verbinden",
      "tryAgain": "Erneut versuchen",
      "unavailableBody": "Die WhatsApp-Verbindung ist in dieser Umgebung nicht eingerichtet.",
      "unavailableTitle": "Hier nicht verfügbar"
    },
    "whatsappEmbeddedSignup": {
      "buttonContinue": "Weiter mit Facebook",
      "buttonFinishing": "Einrichtung wird abgeschlossen…",
      "buttonInPopup": "Im Pop-up fortfahren…",
      "buttonLoading": "Wird geladen…",
      "buttonTryAgain": "Erneut versuchen",
      "cancelled": "Die Registrierung wurde abgebrochen. Du kannst jederzeit neu starten.",
      "closeAnytime": "Du kannst dieses Fenster jederzeit schließen. An deiner Unterkunft ändert sich nichts, bis die WhatsApp-Einrichtung abgeschlossen ist.",
      "errorConnectFailed": "Die WhatsApp-Verbindung konnte nicht abgeschlossen werden. An deiner Unterkunft hat sich nichts geändert. Versuch es noch einmal.",
      "errorNoAccount": "Dein WhatsApp-Konto konnte nicht von Meta gelesen werden. Bitte versuch es noch einmal.",
      "errorUnconfirmed": "Wir konnten nicht bestätigen, dass WhatsApp verbunden ist. Sieh in Vidimo unter „Einstellungen“ > „Nachrichten“ nach, bevor du es noch einmal versuchst.",
      "expiredBody": "Dieser Verbindungslink ist abgelaufen, bevor die Registrierung fertig war. Geh zurück zu Vidimo und fang über die WhatsApp-Karte unter „Nachrichten“ noch einmal an. An deiner Unterkunft hat sich nichts geändert.",
      "introConnect": "Du richtest WhatsApp Business mit <number>{phone}</number> für <name>{property}</name> ein. Die Registrierung bei Meta dauert ein paar Minuten und läuft in einem Pop-up.",
      "introReconnect": "Deine WhatsApp-Verbindung mit <number>{phone}</number> für <name>{property}</name> muss erneut bestätigt werden. Die Registrierung bei Meta dauert ein paar Minuten und läuft in einem Pop-up.",
      "nextStepCheck": "WhatsApp prüft deine Nummer. Das dauert meist ein paar Minuten.",
      "nextStepCode": "Schickt WhatsApp dir einen Code per SMS oder Anruf, gib ihn auf der WhatsApp-Karte unter „Nachrichten“ ein.",
      "nextStepsHeading": "Wie es weitergeht",
      "pendingBody": "WhatsApp richtet die Nummer für {property} ein.",
      "pendingTitle": "Alles erledigt, ab hier übernehmen wir",
      "reload": "Neu laden",
      "sdkUnavailableBody": "Wenn du einen Inhaltsblocker nutzt, schalte ihn für diese Seite aus und lade sie neu. An deiner Unterkunft hat sich nichts geändert.",
      "sdkUnavailableTitle": "Die Registrierung von Meta wurde nicht geladen",
      "stepConfirmCode": "Bestätige den Code, den Meta an diese Nummer schickt. Kommt er erst, nachdem du diese Seite geschlossen hast, gib ihn in der Vidimo-App ein.",
      "stepPickAccount": "Wähle dein WhatsApp-Business-Konto aus oder erstelle eins, und gib dort dieselbe Nummer an. Die Nummer bleibt deine, eine Portierung ist nicht nötig.",
      "stepSignIn": "Melde dich mit dem Facebook-Konto an, das deinen Betrieb verwaltet (oder verwalten wird).",
      "successBody": "Deine WhatsApp-Business-Nummer ist jetzt mit {property} verknüpft.",
      "successTitle": "WhatsApp verbunden",
      "thisProperty": "diese Unterkunft",
      "titleReconnect": "WhatsApp neu verbinden"
    }
  },

  "labels": {
    "balanceDue": "{amount} offen",
    "blockReason": {
      "maintenance": "Wartung",
      "manual": "Manuell gesperrt",
      "owner": "Eigennutzung"
    },
    "blockReasonUnknown": "Gesperrt",
    "callStatus": {
      "connected": "Verbunden",
      "connecting": "Verbindung wird hergestellt…",
      "reconnecting": "Verbindung wird wiederhergestellt…",
      "ringing": "Klingelt…"
    },
    "cancellationPolicyDescription": {
      "flexible": "Kostenlose Stornierung bis 1 Tag vor dem Check-in.",
      "moderate": "Kostenlose Stornierung bis 5 Tage vor dem Check-in.",
      "non_refundable": "Diese Buchung ist nicht erstattungsfähig.",
      "strict": "Kostenlose Stornierung bis 14 Tage vor dem Check-in."
    },
    "cleaningKind": {
      "post-checkout": "Nach Check-out",
      "pre-checkin-refresh": "Auffrischung vor Anreise",
      "turnover": "Gästewechsel"
    },
    "drawerTitle": {
      "breakfast-service": "Frühstück",
      "guest": "Gast",
      "reservation-unit": "Reservierung",
      "staff": "Teammitglied",
      "staff-chat": "Chat-Mitglieder",
      "task": "Aufgabe"
    },
    "guestIdentity": {
      "detail": {
        "authorityRejected": "Die Behörde hat die Angaben abgelehnt",
        "filedOtherYourself": "Die andere Meldung hast du selbst erledigt",
        "noAutomaticFiling": "Vidimo übermittelt diese Meldung nicht",
        "otherFacility": "Unter einer anderen RNO-Nummer gemeldet",
        "reconnectCredentials": "Die Zugangsdaten für die Meldung müssen neu hinterlegt werden",
        "savedNeverFiled": "Beim Gast gespeichert, nicht gemeldet",
        "typedNeverScanned": "Von Hand eingegeben, nicht gescannt"
      },
      "status": {
        "actionNeeded": "Handlungsbedarf",
        "fileManually": "Manuell melden",
        "filedByYou": "Von dir gemeldet",
        "filing": "Wird gemeldet",
        "idNotScanned": "Ausweis nicht gescannt",
        "idOnFile": "Ausweis erfasst",
        "noIdOnFile": "Kein Ausweis erfasst",
        "notFiledYet": "Noch nicht gemeldet",
        "registered": "Gemeldet",
        "rejected": "Abgelehnt",
        "reportCancelled": "Meldung storniert",
        "submitted": "Übermittelt"
      }
    },
    "mealInclusion": {
      "complimentary": "Kostenlos",
      "included": "Im Preis inbegriffen"
    },
    "mealPlace": {
      "breakfast_area": "Frühstücksraum",
      "in_room": "Im Zimmer",
      "takeaway_box": "Zum Mitnehmen"
    },
    "regimeException": {
      "alloggiati-web": "Vidimo erfasst beim Check-in die Daten jedes Gastes für Alloggiati Web; die automatische Meldung an Alloggiati Web ist noch in Entwicklung. Deine ISTAT-Meldung (Ankünfte und Übernachtungen) kann Vidimo noch nicht erstellen oder übermitteln.",
      "declaration-meuble-de-tourisme": "Vidimo reicht die Meldung deiner Ferienunterkunft bei der Gemeinde (déclaration de meublé de tourisme) nicht für dich ein.",
      "eturizem": "Vidimo bereitet deine eTurizem-Meldungen vor. Die automatische Übermittlung an AJPES ist noch in Entwicklung.",
      "evisitor": "Vidimo kann deine Gäste noch nicht für dich in eVisitor an- und abmelden.",
      "imposta-di-soggiorno": "Vidimo kann die Kurtaxe (imposta di soggiorno) deiner Gemeinde noch nicht berechnen.",
      "istat-ross-1000": "Vidimo kann deine ISTAT-Meldung (Ankünfte und Übernachtungen) noch nicht erstellen oder übermitteln.",
      "ses-hospedajes": "Vidimo kann deine Meldungen an SES.Hospedajes noch nicht für dich übermitteln.",
      "siba": "Vidimo kann deine Gästemeldungen (boletins de alojamento) noch nicht für dich an SIBA übermitteln."
    },
    "registrationCredentialField": {
      "alloggiati_web": {
        "idAppartamento": "Apartment-ID",
        "password": "Passwort",
        "username": "Benutzername",
        "wskey": "Webservice-Schlüssel (WS Key)"
      },
      "eturizem": {
        "certificate": "Digitales Zertifikat (.p12 / KDP)",
        "certificatePassword": "Zertifikatspasswort",
        "password": "Passwort für das AJPES-Portal",
        "rno": "RNO-Nummer",
        "username": "Benutzername für das AJPES-Portal"
      },
      "evisitor": {
        "password": "Passwort",
        "username": "Benutzername"
      },
      "istat": {
        "password": "Passwort",
        "structureCode": "Betriebskennung",
        "username": "Benutzername"
      },
      "ses_hospedajes": {
        "clientCertificate": "SSL-Client-Zertifikat",
        "clientCertificatePassword": "Zertifikatspasswort",
        "password": "Passwort",
        "username": "Webservice-Benutzername"
      },
      "siba": {
        "accessKey": "Zugangsschlüssel (Chave de Acesso)",
        "establishment": "Betriebsnummer",
        "nipc": "Steuernummer (NIPC)"
      }
    },
    "registrationCredentialHelp": {
      "alloggiati_web": {
        "idAppartamento": "Nur nötig, wenn du mehrere Einheiten über ein Konto verwaltest.",
        "username": "Wird von deiner örtlichen Quästur (Questura) vergeben.",
        "wskey": "Wird in Alloggiati Web erzeugt. Nach jeder Passwortänderung brauchst du einen neuen, und pro Tag lässt sich nur einer erzeugen."
      },
      "eturizem": {
        "certificate": "Qualifiziertes slowenisches digitales Zertifikat, ausgestellt auf deinen Betrieb.",
        "certificatePassword": "Leer lassen, wenn das Zertifikat kein Passwort hat.",
        "rno": "Die Identifikationsnummer, die AJPES dieser Unterkunft im Register der Beherbergungsbetriebe (RNO) gegeben hat. Nur Ziffern.",
        "username": "Der Benutzername (uporabniško ime), mit dem du dich im AJPES-Portal anmeldest, nicht deine E-Mail-Adresse. AJPES lehnt hier eine E-Mail-Adresse ab. Nach der Anmeldung steht er oben rechts im Portal."
      },
      "evisitor": {
        "username": "Wird von deinem örtlichen Tourismusverband vergeben."
      },
      "istat": {
        "structureCode": "Die Kennung, die deine Region dieser Unterkunft zugewiesen hat (zum Beispiel B01205). Sie identifiziert die Unterkunft in jeder Meldung.",
        "username": "Wird vom Tourismusamt deiner Region vergeben, nicht von ISTAT."
      },
      "ses_hospedajes": {
        "clientCertificate": "Nur nötig, wenn das Ministerium für dein Konto ein Client-Zertifikat verlangt.",
        "clientCertificatePassword": "Leer lassen, wenn das Zertifikat kein Passwort hat.",
        "username": "Der Webservice-Benutzername aus der Sede Electrónica. Er endet auf WS."
      },
      "siba": {
        "accessKey": "Wird dir per Brief oder E-Mail zugeschickt.",
        "establishment": "Von der UCFE vergeben, als du die Einheit registriert hast.",
        "nipc": "Steuernummer der Beherbergungseinheit."
      }
    },
    "registrationCredentialPlaceholder": {
      "ses_hospedajes": {
        "username": "z. B. 1234567WS"
      }
    },
    "registrationField": {
      "arrivalDate": "Anreisedatum",
      "birthCountry": "Geburtsland",
      "birthPlace": "Geburtsort",
      "dateOfBirth": "Geburtsdatum",
      "departureDate": "Abreisedatum",
      "documentNumber": "Dokumentnummer",
      "documentType": "Dokumentart",
      "expiryDate": "Gültig bis",
      "firstName": "Vorname",
      "issuingCountry": "Ausstellungsland",
      "lastName": "Nachname",
      "nationality": "Staatsangehörigkeit",
      "personalNumber": "Persönliche Kennnummer",
      "residenceAddress": "Wohnanschrift",
      "residenceCountry": "Wohnsitzland",
      "sex": "Geschlecht",
      "stayPurpose": "Reisezweck"
    },
    "registrationOption": {
      "documentType": {
        "id_card": "Personalausweis",
        "other": "Sonstiges",
        "passport": "Reisepass"
      },
      "sex": {
        "F": "Weiblich",
        "M": "Männlich"
      },
      "stayPurpose": {
        "business": "Geschäftsreise",
        "education": "Studium/Ausbildung",
        "family": "Familienbesuch",
        "medical": "Gesundheitliche Gründe",
        "other": "Sonstiges",
        "tourism": "Tourismus"
      }
    },
    "registrationSystem": {
      "alloggiati_web": {
        "authority": "Polizia di Stato (örtliche Quästur / Questura)",
        "enrollmentSteps": {
          "enterCredentials": "Gib unten Benutzername, Passwort und WS Key ein.",
          "generateWsKey": "Melde dich an und erzeuge einen Webservice-Schlüssel (WS Key). Nach jeder Passwortänderung brauchst du einen neuen, und pro Tag lässt sich nur einer erzeugen.",
          "requestAccount": "Beantrage bei deiner örtlichen Quästur (Questura) ein Konto für Alloggiati Web. Du erhältst Benutzername und Passwort."
        }
      },
      "eturizem": {
        "authority": "AJPES",
        "enrollmentSteps": {
          "checkAccess": "Prüfe, ob dieses Konto Zugriff auf eTurizem hat. AJPES schaltet ihn separat frei, ohne ihn kann ein Portalkonto nicht melden.",
          "enterCredentials": "Gib unten diesen Benutzernamen und das Passwort ein, lade das Zertifikat hoch und trage die RNO-Nummer ein. Vidimo vergibt die laufende Nummer der Gästemeldungen (zaporedna številka prijave gosta), die es an eTurizem übermittelt, fortlaufend ab {guestbookBase, number}. So kann dein bisheriges Programm die Aufenthalte, die es schon übermittelt hat, selbst abschließen, ohne dass eine Meldung die andere überschreibt. Vidimo meldet alle Gäste, die ab dem Tag anreisen, an dem du die Verbindung herstellst. Lass das bisherige Programm von diesem Tag an keine neuen Anreisen mehr melden, sonst erfasst AJPES sie doppelt.",
          "findUsername": "Finde deinen Benutzernamen für das AJPES-Portal (uporabniško ime). Das ist der Name, den du beim Anlegen des Kontos gewählt hast, nicht deine E-Mail-Adresse: AJPES lehnt eine E-Mail-Adresse ab. Melde dich im AJPES-Portal an, dann steht er oben rechts.",
          "obtainCertificate": "Besorge dir ein qualifiziertes slowenisches digitales Zertifikat (.p12 / KDP), ausgestellt auf deinen Betrieb.",
          "registerAccommodation": "Registriere deine Unterkunft bei AJPES im slowenischen Register der Beherbergungsbetriebe (Register nastanitvenih obratov, RNO). Das Register vergibt eine Identifikationsnummer: Das ist deine RNO-Nummer."
        }
      },
      "evisitor": {
        "authority": "Kroatische Zentrale für Tourismus (örtlicher Tourismusverband)",
        "enrollmentSteps": {
          "enterCredentials": "Gib sie unten ein.",
          "receiveCredentials": "Dein örtlicher Tourismusverband vergibt Benutzername und Passwort für eVisitor."
        }
      },
      "istat": {
        "authority": "Regionales Amt für Tourismusstatistik (ISTAT-Netz)",
        "enrollmentSteps": {
          "enterCredentials": "Gib Betriebskennung, Benutzername und Passwort ein.",
          "requestAccess": "Beantrage beim Tourismusamt deiner Region (Ufficio Turismo) den Webservice-Zugang. Es vergibt Benutzername und Passwort und teilt dir deine Betriebskennung mit."
        }
      },
      "ses_hospedajes": {
        "authority": "Ministerio del Interior (Sede Electrónica)",
        "enrollmentSteps": {
          "enroll": "Registriere deine Unterkunft in der Sede Electrónica und aktiviere die Übermittlung per Webservice.",
          "obtainCertificate": "Falls das Ministerium es für dein Konto verlangt, besorge dir dort das SSL-Client-Zertifikat.",
          "receiveCredentials": "Du erhältst einen Webservice-Benutzernamen (er endet auf WS) und ein Passwort."
        }
      },
      "siba": {
        "authority": "UCFE (Sistema de Segurança Interna)",
        "enrollmentSteps": {
          "enterCredentials": "Gib unten Steuernummer, Betriebsnummer und Zugangsschlüssel ein.",
          "receiveAccessKey": "Die UCFE vergibt den Zugangsschlüssel (Chave de Acesso) für diesen Betrieb; einen Ersatz beantragst du unter siba@ssi.gov.pt.",
          "register": "Registriere deine Beherbergungseinheit bei der UCFE als SIBA-Nutzer, um eine Betriebsnummer zu erhalten."
        }
      }
    },
    "reservationSource": {
      "direct": "Direkt",
      "other": "Sonstige"
    },
    "reservationStatus": {
      "cancelled": "Storniert",
      "checked_in": "Eingecheckt",
      "checked_out": "Ausgecheckt",
      "confirmed": "Bestätigt",
      "declined": "Abgelehnt",
      "no_show": "Nicht erschienen",
      "requested": "Angefragt"
    },
    "role": {
      "manager": "Manager",
      "operator": "Mitarbeiter vor Ort",
      "owner": "Inhaber",
      "receptionist": "Rezeption"
    },
    "roleDescription": {
      "manager": "Führt das Tagesgeschäft. Verwaltet das Team außer Inhabern.",
      "operator": "Team vor Ort: sieht nur eigene Aufgaben und verknüpfte Reservierungen.",
      "owner": "Volle Kontrolle: Abrechnung, Einstellungen, Löschen.",
      "receptionist": "Betreut Gäste, Buchungen und Aufgaben. Keine Adminrechte."
    },
    "roomAmenity": {
      "10": "Bademantel",
      "105": "Herd",
      "107": "Telefon",
      "11": "Kostenlose Pflegeprodukte",
      "13": "Badewanne",
      "142": "Dusche",
      "144": "Schallschutz",
      "146": "Tisch und Stühle",
      "15": "Badewanne oder Dusche",
      "162": "Kleiderschrank",
      "166": "Klimasteuerung",
      "167": "Toaster",
      "18": "Kabel-TV",
      "19": "Kaffee-/Teezubereiter",
      "193": "Gemeinschaftsbad",
      "2": "Klimaanlage",
      "210": "Satelliten-TV",
      "223": "Bergblick",
      "224": "Meerblick",
      "228": "Hausschuhe",
      "245": "Privatpool",
      "246": "Flachbild-TV",
      "251": "Fernseher",
      "259": "Filme",
      "28": "Schreibtisch",
      "3": "Wecker",
      "32": "Geschirrspüler",
      "41": "Kamin",
      "5": "Radio",
      "50": "Haartrockner",
      "5017": "Balkon",
      "55": "Bügeleisen",
      "59": "Küche",
      "61": "Kochnische",
      "68": "Mikrowelle",
      "69": "Minibar",
      "7": "Terrasse",
      "77": "Backofen",
      "85": "Eigenes Bad",
      "88": "Kühlschrank",
      "92": "Safe"
    },
    "supportTeamName": "Vidimo-Team",
    "taskAssignmentPreset": {
      "first_available": "Erste verfügbare Person",
      "specific_staff": "Bestimmte Person",
      "unassigned": "Nicht zuweisen"
    },
    "taskFunction": {
      "check_in": "Check-in",
      "check_out": "Check-out",
      "cleaning": "Reinigung",
      "concierge": "Concierge",
      "maintenance": "Wartung"
    },
    "taskRuleTrigger": {
      "any": "Jede Reinigung"
    },
    "taskStatus": {
      "cancelled": "Abgesagt",
      "completed": "Erledigt",
      "in_progress": "In Arbeit",
      "missed": "Verpasst",
      "paused": "Pausiert",
      "pending": "Offen"
    },
    "transport": {
      "email": "E-Mail",
      "phone": "Telefon",
      "sms": "SMS"
    },
    "unitReadiness": {
      "clean": "Sauber",
      "dirty": "Schmutzig",
      "inspected": "Kontrolliert",
      "out_of_order": "Außer Betrieb"
    },
    "unitType": {
      "apartment": "Apartment",
      "double": "Doppelzimmer",
      "family": "Familienzimmer",
      "quadruple": "Vierbettzimmer",
      "single": "Einzelzimmer",
      "studio": "Studio",
      "suite": "Suite",
      "triple": "Dreibettzimmer",
      "twin": "Zweibettzimmer",
      "villa": "Villa"
    }
  },

  "meals": {
    "breakfastService": {
      "roomNotAssigned": "Kein Zimmer zugewiesen"
    },
    "breakfastServiceBody": {
      "breakfastArea": "Frühstücksraum",
      "cancel": "Abbrechen",
      "complimentaryTag": "kostenlos",
      "coverCount": "{count, plural, one {# Gedeck} other {# Gedecke}}",
      "done": "Fertig",
      "emptyBody": "Niemand, der heute Nacht hier übernachtet, hat am {date} Frühstück.",
      "emptyTitle": "Heute Morgen kein Frühstück",
      "errorRoomNotUpdated": "Das Zimmer konnte nicht aktualisiert werden. Versuch es noch einmal.",
      "errorRoomsNotMoved": "Die Zimmer konnten nicht verschoben werden. Versuch es noch einmal.",
      "groupCount": "{count, plural, one {# Zimmer} other {# Zimmer}} · {covers}",
      "loading": "Frühstück wird geladen",
      "movedTo": "{count, plural, one {# Zimmer} other {# Zimmer}} · {place, select, breakfast_area {Frühstücksraum} in_room {im Zimmer} takeaway_box {zum Mitnehmen} other {{place}}}",
      "roomsOnDate": "{count, plural, one {# Zimmer} other {# Zimmer}} · {date}",
      "rowLabel": "{room}, {covers}",
      "rowLabelServed": "{room}, {covers}, serviert",
      "select": "Auswählen",
      "selectedCount": "{count, plural, one {# ausgewählt} other {# ausgewählt}}",
      "serveInRoom": "Im Zimmer servieren",
      "served": "Serviert"
    },
    "breakfastSummaryRow": {
      "ariaLabel": "Frühstück, {covers, plural, one {# Gedeck} other {# Gedecke}} in {rooms, plural, one {# Zimmer} other {# Zimmern}}",
      "inRoomCount": "{count, plural, one {# im Zimmer} other {# im Zimmer}}",
      "servedCount": "{count, plural, one {# serviert} other {# serviert}}",
      "title": "Frühstück · {count, plural, one {# Zimmer} other {# Zimmer}}"
    },
    "reservationBreakfastCard": {
      "chargeForMorning": "Für diesen Morgen berechnen",
      "coversAt": "{count, plural, one {# Gedeck} other {# Gedecke}} · {place, select, breakfast_area {Frühstücksraum} in_room {im Zimmer} takeaway_box {zum Mitnehmen} other {{place}}}",
      "errorMorningNotUpdated": "Dieser Morgen konnte nicht aktualisiert werden. Versuch es noch einmal.",
      "givenBy": "Spendiert von {name}",
      "makeComplimentary": "Kostenlos machen",
      "makeComplimentaryHint": "Kostenlos machen: Es wird von der Rechnung abgezogen",
      "markNotTaken": "Als nicht genutzt markieren",
      "markServed": "Als serviert markieren",
      "morningCount": "{count, plural, one {# Morgen} other {# Morgen}}",
      "notCharged": "Nicht berechnet",
      "statusExpected": "Erwartet",
      "statusNotTaken": "Nicht genutzt",
      "statusServed": "Serviert",
      "title": "Frühstück",
      "unconfirmedCount": "{count, plural, one {# Morgen} other {# Morgen}} unbestätigt"
    }
  },

  "notifications": {
    "attention": {
      "activityFailed": "Wird automatisch wiederholt",
      "activityPending": "Zur Meldung vorgemerkt",
      "activitySubmitting": "Wird gerade gemeldet",
      "severityAtRisk": "Frist läuft bald ab",
      "severityNeedsAction": "Handlungsbedarf"
    },
    "filingAttentionSection": {
      "activityNotConfirmed": "Meldung noch nicht bestätigt",
      "activitySubmitted": "Übermittelt, Bestätigung der Behörde ausstehend",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "deadlinePassed": "Frist abgelaufen",
      "detailNoDeadline": "{activity}, und die gesetzliche Meldefrist läuft bald ab.",
      "detailWithDeadline": "{activity} · {relative}",
      "title": "Gästemeldung"
    },
    "notificationMenu": {
      "activity": "Aktivität",
      "close": "Benachrichtigungen schließen",
      "emptyDescription": "Vorgeschlagene Aktionen und Aktivitäten erscheinen hier",
      "emptySearchDescription": "Versuch es mit einem anderen Suchbegriff",
      "errorApplyFailed": "Dieser Vorschlag konnte nicht übernommen werden. Er ist womöglich veraltet.",
      "errorDismissFailed": "Dieser Vorschlag konnte nicht verworfen werden. Versuch es noch einmal.",
      "errorMissingMergeProfiles": "Diesem Vorschlag fehlen die Profile zum Zusammenführen.",
      "errorNotCleared": "Diese Karte konnte nicht entfernt werden. Versuch es noch einmal.",
      "errorNotClearedAfter": "{message}, aber diese Karte konnte nicht entfernt werden. Versuch es noch einmal.",
      "noActivity": "Noch keine Aktivität",
      "noPendingSuggestions": "Keine offenen Vorschläge",
      "noResults": "Keine Ergebnisse",
      "searchPlaceholder": "Vorschläge und Aktivität durchsuchen…",
      "suggestedActions": "Vorgeschlagene Aktionen",
      "title": "Benachrichtigungen"
    },
    "notificationPrimer": {
      "decline": "Nicht jetzt",
      "description": "Aktiviere Benachrichtigungen, dann meldet Vidimo neue Nachrichten von Gästen und Team, Anreisen und Stornierungen sowie Meldefristen. Ohne sie erfährst du davon erst, wenn du die App das nächste Mal öffnest.",
      "enable": "Benachrichtigungen aktivieren",
      "title": "Sofort wissen, wenn ein Gast schreibt"
    },
    "pushRegistration": {
      "androidChannelName": "Benachrichtigungen"
    },
    "relativeDeadline": {
      "dueInDays": "{count, plural, one {fällig in {count} Tag} other {fällig in {count} Tagen}}",
      "dueInHours": "{count, plural, one {fällig in {count} Std.} other {fällig in {count} Std.}}",
      "dueInMinutes": "{count, plural, one {fällig in {count} Min.} other {fällig in {count} Min.}}",
      "overdueByDays": "{count, plural, one {{count} Tag überfällig} other {{count} Tage überfällig}}",
      "overdueByHours": "{count, plural, one {{count} Std. überfällig} other {{count} Std. überfällig}}",
      "overdueByMinutes": "{count, plural, one {{count} Min. überfällig} other {{count} Min. überfällig}}"
    },
    "statisticsAttentionSection": {
      "activityNotConfirmed": "Noch nicht bestätigt",
      "activitySubmitted": "Übermittelt, Bestätigung des Amts ausstehend",
      "title": "Statistikmeldungen"
    },
    "taxReturnAttentionSection": {
      "detail": "{amount} bis {date} zu zahlen",
      "dueSoon": "Bald fällig",
      "overdue": "Überfällig",
      "title": "Kurtaxe",
      "uncomputed": "{count, plural, one {Kurtaxe für # Aufenthalt noch nicht berechnet} other {Kurtaxe für # Aufenthalte noch nicht berechnet}}"
    },
    "timeOffProposalCard": {
      "confirm": "Bestätigen",
      "dismiss": "Verwerfen",
      "errorMarkAway": "Abwesenheit konnte nicht eingetragen werden. Versuch es noch einmal.",
      "markedAway": "{who} als abwesend eingetragen",
      "markedAwayReleased": "{who} als abwesend eingetragen · {count, plural, one {# Aufgabe} other {# Aufgaben}} nicht mehr zugewiesen",
      "markedAwayReleasedDescription": "Weise sie in „Aufgaben“ aus der Spalte „Nicht zugewiesen“ neu zu.",
      "review": "Prüfen",
      "staffMemberFallback": "Teammitglied",
      "viewSourceMessage": "Ursprüngliche Nachricht ansehen"
    }
  },

  "rates": {
    "controls": {
      "fewerLabel": "{label}, weniger",
      "moreLabel": "{label}, mehr"
    },
    "copy": {
      "board": {
        "noPrice": "Kein Preis",
        "notKept": "So weit im Voraus werden Nächte nicht auf diesem Handy gespeichert.",
        "pastMonth": "So weit zurück werden Nächte nicht auf diesem Handy gespeichert.",
        "tapHint": "Tippe auf eine Nacht, um sie zu ändern, oder auf ein Datum, um alle Einheitstypen zu ändern.",
        "tapHintProperty": "Tippe auf eine Nacht, um sie zu ändern, oder auf ein Datum, um alle Einheitstypen von {propertyName} zu ändern."
      },
      "changeNights": {
        "bookedWhenClosing": "{count, plural, one {{count} dieser Nächte hat bereits Buchungen. Schließen stoppt nur neue Buchungen.} other {{count} dieser Nächte haben bereits Buchungen. Schließen stoppt nur neue Buchungen.}}",
        "cancel": "Abbrechen",
        "chooseUnitType": "Wähle mindestens einen Einheitstyp.",
        "close": "Schließen",
        "fields": {
          "checkIn": "Check-in",
          "checkOut": "Check-out",
          "maximumStay": "Maximalaufenthalt",
          "minimumStay": "Mindestaufenthalt",
          "price": "Preis",
          "sale": "Buchbarkeit"
        },
        "firstNight": "Erste Nacht",
        "firstThenLast": "Tippe auf die erste Nacht, dann auf die letzte",
        "lastNight": "Letzte Nacht",
        "leaveAsIs": "Unverändert lassen",
        "minFromSeason": "Aus Saison",
        "nothingToSend": "Wähle etwas zum Ändern.",
        "priceFor": "Neuer Preis für {unitTypeName}",
        "priceToSet": "Neuer Preis",
        "priceUseSeasonOrBase": "Saison- oder Grundpreis",
        "saveLabel": "Speichern",
        "setAPrice": "Stattdessen Preis festlegen",
        "tapForSpan": "Tippe auf eine zweite Nacht für einen Zeitraum.",
        "tapToWiden": "Tippe auf eine zweite Nacht für einen Zeitraum oder auf eine andere Zeile, um sie hinzuzufügen.",
        "title": "Nächte ändern",
        "toWord": "bis",
        "useSeasonOrBaseInstead": "Stattdessen Saison- oder Grundpreis verwenden",
        "was": "Vorher: {reads}."
      },
      "changes": {
        "sendAgain": "Erneut senden",
        "showTheseNights": "Diese Nächte anzeigen",
        "status": "Status",
        "taskId": "Kanal-Referenz",
        "title": "Preisänderungen",
        "undo": "Diese Änderung rückgängig machen",
        "whatChanged": "Was geändert wurde",
        "whatWasSent": "Was gesendet wurde",
        "who": {
          "automatic": "Automatisch",
          "automaticAt": "Automatisch, {time}",
          "bySupport": "Vidimo-Support im Namen von {actor}",
          "inTheApp": "{name}, {time}, in der App",
          "onBehalf": "{agent} (Vidimo-Support) im Namen von {actor}",
          "unknown": "Unbekannt"
        }
      },
      "delivery": {
        "awaitingFullSync": "Wird mit der nächsten vollständigen Synchronisierung gesendet",
        "notConnected": "Keine Buchungsplattform verbunden, daher nur in Vidimo geändert",
        "notMapped": "Nicht gesendet: Dieser Einheitstyp ist nicht mit deinen Kanälen verknüpft",
        "notSent": "Nicht an deine Kanäle gesendet",
        "passedUnanswered": "Von deinen Kanälen nicht bestätigt, bevor diese Nächte vorbei waren",
        "sending": "Wird an deine Kanäle gesendet",
        "sent": "An deine Kanäle gesendet",
        "sentAt": "Um {time} an deine Kanäle gesendet",
        "unmapped": "{count, plural, one {{unitTypes} ist nicht mit deinen Kanälen verknüpft und wurde daher nicht gesendet.} other {{unitTypes} sind nicht mit deinen Kanälen verknüpft und wurden daher nicht gesendet.}}"
      },
      "discard": {
        "body": "Du hast Nächte ausgewählt oder einen Wert eingegeben. Diese Änderung verwerfen?",
        "discard": "Verwerfen",
        "forTapOn": "Eine Änderung für {propertyName} beginnen? Was du hier eingegeben hast, wird verworfen.",
        "keep": "Weiter bearbeiten"
      },
      "editor": {
        "closedOn": "{of, plural, one {{on} von {of} Nacht geschlossen} other {{on} von {of} Nächten geschlossen}}",
        "detailsKept": "Details einer Änderung werden 90 Tage aufbewahrt.",
        "lastChanged": "Zuletzt geändert von {who}, {when}.",
        "notAllowedOn": "{of, plural, one {Nicht erlaubt an {on} von {of} Nacht} other {Nicht erlaubt an {on} von {of} Nächten}}",
        "varies": "Unterschiedlich"
      },
      "errors": {
        "belowLowest": "Der niedrigste Preis für {unitTypeName} ist {price}.",
        "conflict": "Diese Nächte wurden auf einem anderen Gerät geändert, seit du sie zuletzt gesehen hast. Sieh noch einmal nach und sende dann erneut.",
        "lowestNotAbove0": "Gib einen Mindestpreis über 0 ein.",
        "lowestOverBase": "Der Mindestpreis darf nicht über dem Grundpreis liegen.",
        "offline": "Du bist offline, daher wurde nichts gespeichert. Speichere erneut, sobald du wieder online bist.",
        "priceAbove0": "Gib einen Preis über 0 ein.",
        "priceToType": "Gib den neuen Preis ein.",
        "priceUnreadable": "Gib einen Preis wie {example, number} ein.",
        "pricedUnder": "{which, select, nights {{nights, plural, one {{nights} Nacht von {unitTypeName} hat einen Preis unter {amount}. Erhöhe ihn zuerst und lege dann den Mindestpreis fest.} other {{nights} Nächte von {unitTypeName} haben einen Preis unter {amount}. Erhöhe sie zuerst und lege dann den Mindestpreis fest.}}} seasons {{seasons, plural, one {{seasons} Saison von {unitTypeName} hat einen Preis unter {amount}. Erhöhe ihn zuerst und lege dann den Mindestpreis fest.} other {{seasons} Saisons von {unitTypeName} haben einen Preis unter {amount}. Erhöhe sie zuerst und lege dann den Mindestpreis fest.}}} other {{nights, plural, one {{nights} Nacht} other {{nights} Nächte}} und {seasons, plural, one {{seasons} Saison} other {{seasons} Saisons}} von {unitTypeName} haben einen Preis unter {amount}. Erhöhe sie zuerst und lege dann den Mindestpreis fest.}}",
        "staysContradict": "Der Mindestaufenthalt ist länger als der Maximalaufenthalt, daher kann in dieser Nacht kein Aufenthalt beginnen."
      },
      "heldBack": {
        "basePrice": "Der Grundpreis ist bereits {price}, daher ändert sich für {unitTypeName} nichts.",
        "seasonMinimum": "Das Saisonminimum ist bereits {nights}, daher ändert sich nichts.",
        "seasonPrice": "Die Saison {seasonName} ergibt bereits {price}, daher ändert sich für {unitTypeName} nichts.",
        "seasonPriceUnnamed": "Der Saisonpreis ist bereits {price}, daher ändert sich für {unitTypeName} nichts."
      },
      "hold": {
        "sendNow": "Jetzt senden",
        "waiting": "{changes, plural, one {{changes} Änderung geht} other {{changes} Änderungen gehen}} in {seconds, plural, one {{seconds} s} other {{seconds} s}} an deine Kanäle"
      },
      "night": {
        "allowed": "Erlaubt",
        "checkIn": "Check-in",
        "checkOut": "Check-out",
        "closed": "Geschlossen",
        "fallBackToBase": "Grundpreis verwenden ({price})",
        "fallBackToSeason": "Saison {name} verwenden ({price})",
        "maximumStay": "Maximalaufenthalt",
        "minFromSeason": "{count, plural, one {{count} aus Saison} other {{count} aus Saison}}",
        "minimumStay": "Mindestaufenthalt",
        "noLimit": "Keine Grenze",
        "noMinimum": "Kein Minimum",
        "notAllowed": "Nicht erlaubt",
        "notForSale": "Kein Preis, daher nicht buchbar",
        "open": "Offen",
        "price": "Preis",
        "priceFromBase": "Grundpreis",
        "priceFromBaseAt": "Grundpreis ({price})",
        "priceFromSeason": "Aus Saison {name}",
        "priceFromSeasonAt": "Aus Saison {name} ({price})",
        "priceRange": "{low}–{high}",
        "priceSetForNight": "Für diese Nacht festgelegt",
        "priceSetForNights": "Für diese Nächte festgelegt",
        "sale": "Buchbarkeit",
        "seeTheChange": "Änderung ansehen.",
        "unitsFree": "{total, plural, one {{free} von {total} Einheit frei} other {{free} von {total} Einheiten frei}}"
      },
      "nights": "{count, plural, one {{count} Nacht} other {{count} Nächte}}",
      "planned": {
        "checkInAllowed": "{position, select, first {Check-in erlaubt} other {Check-in erlaubt}}",
        "checkInNotAllowed": "{position, select, first {Check-in nicht erlaubt} other {Check-in nicht erlaubt}}",
        "checkOutAllowed": "{position, select, first {Check-out erlaubt} other {Check-out erlaubt}}",
        "checkOutNotAllowed": "{position, select, first {Check-out nicht erlaubt} other {Check-out nicht erlaubt}}",
        "chooseNights": "Wähle die Nächte, die du ändern willst",
        "chooseSomething": "Wähle etwas zum Ändern",
        "chooseUnitType": "Wähle mindestens einen Einheitstyp",
        "close": "{position, select, first {Geschlossen} other {geschlossen}}",
        "maxStay": "{position, select, first {{nights, plural, one {Maximalaufenthalt {nights} Nacht} other {Maximalaufenthalt {nights} Nächte}}} verb {{nights, plural, one {Maximalaufenthalt {nights} Nacht} other {Maximalaufenthalt {nights} Nächte}}} other {{nights, plural, one {Maximalaufenthalt {nights} Nacht} other {Maximalaufenthalt {nights} Nächte}}}}",
        "maxStayCleared": "{position, select, first {Kein Maximalaufenthalt} other {kein Maximalaufenthalt}}",
        "minStay": "{position, select, first {{nights, plural, one {Mindestaufenthalt {nights} Nacht} other {Mindestaufenthalt {nights} Nächte}}} verb {{nights, plural, one {Mindestaufenthalt {nights} Nacht} other {Mindestaufenthalt {nights} Nächte}}} other {{nights, plural, one {Mindestaufenthalt {nights} Nacht} other {Mindestaufenthalt {nights} Nächte}}}}",
        "minStayCleared": "{position, select, first {Mindestaufenthalt aus Saison} other {Mindestaufenthalt aus Saison}}",
        "price": "{position, select, first {Preis {price}} verb {Preis {price}} other {Preis {price}}}",
        "priceCleared": "{position, select, first {Saison- oder Grundpreis} other {Saison- oder Grundpreis}}",
        "reopen": "{position, select, first {Wieder geöffnet} other {wieder geöffnet}}",
        "sentence": "{changes} für {unitTypes}, {span} ({count, plural, one {{count} Nacht} other {{count} Nächte}})."
      },
      "sent": {
        "checkInAllowed": "Check-in erlaubt",
        "checkInNotAllowed": "Check-in nicht erlaubt",
        "checkOutAllowed": "Check-out erlaubt",
        "checkOutNotAllowed": "Check-out nicht erlaubt",
        "closed": "geschlossen",
        "maxStay": "{nights, plural, one {max. Aufenthalt {nights}} other {max. Aufenthalt {nights}}}",
        "maxStayCleared": "kein Maximalaufenthalt",
        "minStay": "{nights, plural, one {min. Aufenthalt {nights}} other {min. Aufenthalt {nights}}}",
        "minStayCleared": "Mindestaufenthalt aus Saison",
        "priceCleared": "Preis zurück auf Saison- oder Grundpreis",
        "reopened": "wieder geöffnet"
      },
      "summary": {
        "closedFor": "{span} für {unitTypes} geschlossen",
        "line": "{unitTypes}: {fields}, {span}",
        "lineNights": "{unitTypes}: {fields}, {span} ({count, plural, one {{count} Nacht} other {{count} Nächte}})",
        "reopenedFor": "{span} für {unitTypes} wieder geöffnet",
        "undone": "Rückgängig gemacht: {body}",
        "unitTypesHeadline": "{types, plural, one {{types} Einheitstyp, {span}} other {{types} Einheitstypen, {span}}}",
        "unitsFreeHeadline": "Freie Einheiten gesendet",
        "unitsFreeLine": "{free, plural, one {{unitType}: {free}, {span}} other {{unitType}: {free}, {span}}}",
        "unitsFreeSent": "Freie Einheiten gesendet: {lines}. {trigger, select, nightly_refresh {Nächtliche Aktualisierung.} other {Nach einer Buchung oder Sperre.}}"
      },
      "toast": {
        "nothingConnected": "Keine Buchungsplattform verbunden, daher ändert das deine Preise nur in Vidimo.",
        "saved": "Gespeichert",
        "undo": "Rückgängig",
        "undone": "Rückgängig gemacht",
        "waiting": "Deine letzte Änderung wird noch gespeichert. Speichere gleich noch einmal."
      },
      "viewMenu": {
        "rates": "Preise",
        "staff": "Team",
        "units": "Einheiten"
      },
      "words": {
        "and": "{head} und {last}",
        "sentences": "{head}. {next}",
        "series": "{head}, {next}"
      }
    },
    "rateChangeDetailPage": {
      "awaitingFullSync": "{what}: Deine Kanäle haben sie noch nicht bestätigt, daher sendet Vidimo sie mit der nächsten vollständigen Synchronisierung.",
      "changedLine": "{unitType}, {span} ({count}): {changes}",
      "copied": "Kopiert",
      "copy": "Kopieren",
      "copyFailed": "Kopieren fehlgeschlagen",
      "fieldCheckIn": "Check-in",
      "fieldCheckOut": "Check-out",
      "fieldMaxStay": "Maximalaufenthalt",
      "fieldMinStayArrival": "Mindestaufenthalt bei Anreise",
      "fieldMinStayThrough": "Mindestaufenthalt über diese Nacht",
      "fieldPrice": "Preis",
      "fieldSale": "Buchbarkeit",
      "fieldUnitsFree": "freie Einheiten",
      "loading": "Wird geladen…",
      "noValueChanged": "Kein Wert geändert",
      "notFound": "Änderung nicht gefunden.",
      "notSent": "{what}: Deine Kanäle haben sie nicht übernommen.",
      "notSentBecauseConnection": "Vidimo hatte für diese Unterkunft keinen Zugriff mehr auf deine Kanäle.",
      "notSentBecauseValues": "Prüfe diese Werte und sende sie dann erneut.",
      "passedUnanswered": "{what}: Deine Kanäle haben sie nicht bestätigt, bevor diese Nächte vorbei waren.",
      "pushedLine": "{unitType} {span}: {fields}",
      "saved": "Gespeichert {time}.",
      "sending": "{what}: wird gesendet.",
      "sent": "{what}, an deine Kanäle gesendet",
      "sentAt": "{what}, um {time} an deine Kanäle gesendet",
      "taskIdAwaiting": "{taskId}: kommt nach dem Senden",
      "wasNow": "{field} war {before}, jetzt {after}",
      "whatRates": "Preise und Regeln",
      "whatUnitsFree": "Freie Einheiten"
    },
    "ratesBoard": {
      "cellLabel": "{rowName}, {day}: {price}",
      "cellLabelClosed": "{rowName}, {day}: {price}, geschlossen",
      "dateTapLabel": "Alle Einheitstypen am {day}",
      "dateTapPropertyLabel": "Alle Einheitstypen von {propertyName} am {day}",
      "units": "{count, plural, one {# Einheit} other {# Einheiten}}"
    },
    "ratesView": {
      "emptyDescription": "Füge dieser Unterkunft Einheiten hinzu, bevor du Preise festlegst.",
      "emptyTitle": "Noch keine Einheiten",
      "nextMonth": "Nächster Monat",
      "previousMonth": "Vorheriger Monat",
      "thisMonth": "Dieser Monat"
    }
  },

  "reservations": {
    "assignUnitSelect": {
      "checking": "Freie Einheiten werden geprüft…",
      "errorNotAssigned": "Diese Einheit konnte nicht zugewiesen werden. Versuch es noch einmal.",
      "errorUnitTaken": "Ein anderer Aufenthalt belegt diese Einheit bereits in einigen dieser Nächte. Wähle eine andere Einheit.",
      "noneFree": "Keine Einheit ist in allen Nächten frei",
      "placeholder": "Einheit zuweisen"
    },
    "cancelReservationAction": {
      "cancelAction": "Reservierung stornieren",
      "cancelBody": "Die Buchung von {guestName} wird storniert und die Einheit für diese Nächte freigegeben.",
      "cancelTitle": "Diese Reservierung stornieren?",
      "cancelToast": "Reservierung storniert",
      "declineAction": "Anfrage ablehnen",
      "declineBody": "Die Anfrage von {guestName} wird abgelehnt und die Einheit bleibt für diese Nächte frei.",
      "declineTitle": "Diese Anfrage ablehnen?",
      "declineToast": "Anfrage abgelehnt",
      "errorCancel": "Die Reservierung konnte nicht storniert werden. Versuch es noch einmal.",
      "errorDecline": "Die Anfrage konnte nicht abgelehnt werden. Versuch es noch einmal.",
      "errorUndoCancel": "Rückgängig machen fehlgeschlagen. Die Reservierung ist weiterhin storniert.",
      "errorUndoDecline": "Rückgängig machen fehlgeschlagen. Die Anfrage ist weiterhin abgelehnt.",
      "keepIt": "Behalten",
      "undo": "Rückgängig"
    },
    "checkInInviteCard": {
      "deliveryBounced": "Unzustellbar: Die Adresse hat sie nicht angenommen",
      "deliveryComplained": "Vom Empfänger als Spam markiert",
      "deliveryDelivered": "Zugestellt",
      "deliverySent": "Gesendet, Bestätigung ausstehend",
      "deliverySuppressed": "Nicht versucht: Die Adresse steht auf einer Sperrliste",
      "errorNotSent": "Die Einladung konnte nicht gesendet werden",
      "errorPreview": "Die Vorschau konnte nicht geladen werden",
      "noInvitation": "Keine Einladung für diese Buchung",
      "notSentYet": "Für diese Buchung wurde noch keine Einladung gesendet.",
      "previewEmail": "E-Mail-Vorschau",
      "sendAgain": "Erneut senden",
      "sendInvitation": "Einladung senden",
      "sentTo": "Am {date} an {email} gesendet{count, plural, =0 {} =1 {} one {} other { ({count}-mal)}}.",
      "sentToast": "Check-in-Einladung an {email} gesendet",
      "title": "Check-in-Einladung",
      "unavailableNoDates": "Trag zuerst Check-in- und Check-out-Datum ein.",
      "unavailableNoEmail": "Diese Buchung kam ohne E-Mail-Adresse herein.",
      "unavailableNotActive": "Diese Buchung ist storniert, daher gibt es nichts zu senden.",
      "unavailableNotFound": "Wir konnten diese Buchung nicht finden."
    },
    "checkInLinkCard": {
      "copied": "Kopiert",
      "copy": "Kopieren",
      "description": "Schick ihn deinem Gast, dann öffnet sich der Check-in ohne Anmeldung. Die Vorschau zeigt dir, was der Gast sieht.",
      "errorCreate": "Der Check-in-Link konnte nicht erstellt werden",
      "errorNotCopied": "Der Link konnte nicht kopiert werden",
      "noLink": "Kein Link für diese Buchung",
      "preview": "Vorschau",
      "title": "Link zum Self-Check-in",
      "toastCopied": "Link kopiert",
      "unavailableNoDates": "Trag zuerst Check-in- und Check-out-Datum ein.",
      "unavailableNotActive": "Diese Buchung ist storniert, daher gibt es keinen Check-in.",
      "unavailableNotFound": "Wir konnten diese Buchung nicht finden."
    },
    "collectPaymentSheet": {
      "amountLabel": "Betrag ({currency})",
      "channelWarning": "Diese Buchung kam über einen Kanal, der den Zimmerpreis normalerweise selbst kassiert. Belastest du ihn erneut, zahlt der Gast doppelt: Kassiere nur Extras.",
      "copied": "Kopiert",
      "copy": "Kopieren",
      "createLink": "Zahlungslink erstellen",
      "creating": "Wird erstellt…",
      "errorCopy": "Kopieren fehlgeschlagen: Markiere den Link und kopiere ihn von Hand.",
      "errorCreateLink": "Der Link konnte nicht erstellt werden. Versuch es noch einmal.",
      "errorNoAmount": "Gib einen Betrag ein.",
      "holdLapsesWarning": "Dieser Aufenthalt dauert länger als die 7 Tage der Vorautorisierung. Die Karte wird um den {date} freigegeben, also vor dem Check-out des Gastes, und danach kannst du den Betrag nicht mehr einziehen. Wähle in den Zahlungseinstellungen <strong>Belasten</strong>, wenn du bis zur Abreise abgesichert sein willst.",
      "holdNotice": "Der Betrag wird auf der Karte des Gastes vorautorisiert: Das Geld bleibt beim Gast, belastet wird erst, wenn du es einziehst. Die Vorautorisierung hält etwa 7 Tage; danach wird die Karte automatisch freigegeben und du kannst nichts mehr einziehen.",
      "linkCopied": "Zahlungslink kopiert",
      "pendingUntilPaid": "Der Posten erscheint auf dem Gastkonto als ausstehend, bis der Gast bezahlt hat.",
      "presetBalance": "Gesamter offener Betrag",
      "presetDeposit": "30 % Anzahlung",
      "presetTouristTax": "Kurtaxe",
      "sendHoldLink": "Schick das dem Gast. Damit wird der Betrag auf seiner Karte vorautorisiert: Das Geld bleibt beim Gast, bis du es einziehst.",
      "sendLink": "Schick das dem Gast. Das Gastkonto wird aktualisiert, sobald er bezahlt.",
      "title": "Zahlung kassieren"
    },
    "confirmMoneyAction": {
      "cancel": "Abbrechen",
      "working": "Wird ausgeführt…"
    },
    "editGuestForm": {
      "avatarAlt": "Gast",
      "backToGuests": "Zurück zu den Gästen",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "gast@beispiel.de (Pflicht ohne Name/Telefon)",
      "errorNotSaved": "Der Gast konnte nicht gespeichert werden. Versuch es noch einmal.",
      "firstNameLabel": "Vorname",
      "firstNamePlaceholder": "Vorname (optional mit Telefon/E-Mail)",
      "lastNameLabel": "Nachname",
      "lastNamePlaceholder": "Nachname (optional mit Telefon/E-Mail)",
      "nationalityLabel": "Staatsangehörigkeit",
      "nationalityPlaceholder": "Staatsangehörigkeit auswählen",
      "notFound": "Gast nicht gefunden",
      "phoneLabel": "Telefon",
      "phonePlaceholder": "(Pflicht ohne Name)",
      "saved": "Gastdaten gespeichert.",
      "title": "Gast bearbeiten"
    },
    "editReservationForm": {
      "accessibilityLabel": "Barrierefreiheit",
      "accessibilityPlaceholder": "z. B. Erdgeschoss bevorzugt, rollstuhlgerecht",
      "adultsLabel": "Erwachsene",
      "arrivalTimeLabel": "Voraussichtliche Ankunftszeit",
      "backToCalendar": "Zurück zum Kalender",
      "beforeCreating": "Vor dem Erstellen",
      "beforeSaving": "Vor dem Speichern",
      "channelCancelledNote": "Auf {source} storniert: Nur der Kanal kann sie wiederherstellen",
      "channelDatesNote": "Die Daten werden von {source} verwaltet: Ändere sie dort, dann werden sie übernommen",
      "channelManagedNote": "Synchronisiert von {source}. Aufenthaltsdaten und Stornierungen werden auf dem Kanal verwaltet und automatisch übernommen. Gastdaten, Notizen und Einheit kannst du hier bearbeiten.",
      "checkInTimeLabel": "Check-in-Zeit",
      "checkOutTimeLabel": "Check-out-Zeit",
      "checkingAvailability": "Verfügbarkeit wird geprüft…",
      "childrenLabel": "Kinder",
      "create": "Erstellen",
      "datesLabel": "Check-in – Check-out",
      "dietaryLabel": "Ernährung",
      "dietaryPlaceholder": "z. B. vegetarischer Willkommenskorb, Nussallergie",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "erika@beispiel.de",
      "errorAdultsRequired": "Gib die Anzahl der Erwachsenen an, um einen Gast einzuchecken",
      "errorCheckInDateRequired": "Check-in-Datum ist erforderlich",
      "errorCheckInTimeInvalid": "Die Check-in-Zeit muss eine Uhrzeit wie 13:00 sein",
      "errorCheckOutBeforeCheckIn": "Der Check-out muss nach dem Check-in liegen",
      "errorCheckOutDateRequired": "Check-out-Datum ist erforderlich",
      "errorCheckOutTimeRequired": "Check-out-Zeit ist erforderlich",
      "errorFirstNameRequired": "Vorname des Gastes ist erforderlich",
      "errorNotCreated": "Diese Reservierung konnte nicht erstellt werden. Deine Angaben sind noch da, versuch es noch einmal.",
      "errorNotSaved": "Diese Reservierung konnte nicht gespeichert werden. Deine Änderungen sind noch da, versuch es noch einmal.",
      "errorPropertyRequired": "Unterkunft ist erforderlich",
      "errorRoomRequired": "Wähle ein Zimmer für diese Buchung",
      "firstNameLabel": "Vorname",
      "firstNamePlaceholder": "Erika",
      "groupBookingNote": "Diese Buchung umfasst mehrere Einheiten; Einheiten lassen sich hier noch nicht ändern",
      "guestHeading": "Gast",
      "hasPetsLabel": "Reist mit Haustier",
      "infantsLabel": "Kleinkinder",
      "lastNameLabel": "Nachname",
      "lastNamePlaceholder": "Mustermann",
      "notFound": "Reservierung nicht gefunden",
      "petNotesLabel": "Hinweise zum Haustier",
      "petNotesPlaceholder": "z. B. 1 kleiner Hund (Bello)",
      "phoneLabel": "Telefon",
      "propertyLabel": "Unterkunft",
      "propertyLocked": "Die Unterkunft lässt sich nach dem Erstellen der Reservierung nicht mehr ändern",
      "propertyPlaceholder": "Unterkunft auswählen",
      "save": "Speichern",
      "statusLabel": "Status",
      "stayDetailsHeading": "Aufenthalt",
      "titleEdit": "Reservierung bearbeiten",
      "titleNew": "Neue Reservierung",
      "toastCreated": "Reservierung erstellt.",
      "toastSaved": "Reservierung gespeichert.",
      "unitConflict": "Diese Einheit ist vom {checkIn} bis {checkOut} bereits belegt. Passe die Daten an oder wähle eine andere Einheit.",
      "unitConflictBy": "Diese Einheit ist vom {checkIn} bis {checkOut} bereits von {name} belegt. Passe die Daten an oder wähle eine andere Einheit.",
      "unitConflictByWithRef": "Diese Einheit ist vom {checkIn} bis {checkOut} bereits von {name} belegt (Ref. {reference}). Passe die Daten an oder wähle eine andere Einheit.",
      "unitConflictWithRef": "Diese Einheit ist vom {checkIn} bis {checkOut} bereits belegt (Ref. {reference}). Passe die Daten an oder wähle eine andere Einheit.",
      "unitLabel": "Einheit",
      "unitPlaceholder": "Zimmer auswählen",
      "unitsFree": "{free, plural, one {{free} von {total} frei} other {{free} von {total} frei}}"
    },
    "guestRegistrationStatus": {
      "authorityQuote": "„{reason}“",
      "authorityQuoteAt": "– {when}",
      "cancelAction": "Diese Meldung stornieren",
      "cancelConfirm": "Meldung stornieren",
      "cancelHint": "Nur, wenn dieser Gast nicht hier übernachtet: bei Nichterscheinen oder einer Meldung für die falsche Unterkunft. Das lässt sich nicht rückgängig machen.",
      "cancelKeep": "Meldung behalten",
      "cancelTitle": "Diese Meldung bei {authority} stornieren?",
      "cancelledToast": "Meldung bei {authority} storniert.",
      "cancelledWith": "Meldung bei {authority} storniert",
      "cancelledWithOn": "Meldung bei {authority} am {when} storniert",
      "downloadReceipt": "Empfangsbestätigung herunterladen",
      "errorCancel": "Die Meldung konnte nicht storniert werden. Versuch es noch einmal.",
      "errorCancelRefused": "Die Meldung wurde nicht storniert.",
      "errorDownloadReceipt": "Die Empfangsbestätigung konnte nicht heruntergeladen werden. Versuch es noch einmal.",
      "errorMarkFiled": "Die Meldung konnte nicht markiert werden. Versuch es noch einmal.",
      "errorRetry": "Die Meldung konnte nicht erneut versucht werden. Versuch es noch einmal.",
      "errorRetryFailedAgain": "Die Meldung ist erneut fehlgeschlagen.",
      "fixAndRefile": "Korrigieren und neu melden",
      "headlineAuthRefused": "{authority} hat die Zugangsdaten dieser Unterkunft abgelehnt",
      "headlineAuthUnused": "Die Zugangsdaten dieser Unterkunft für {authority} konnten nicht verwendet werden",
      "headlineFiledByHost": "Die andere Meldung dieses Gastes an {authority} hast du selbst erledigt",
      "headlineIncomplete": "{authority} konnte diese Meldung nicht abschließen",
      "headlineMissingData": "{authority} braucht Angaben, die dieser Meldung fehlen",
      "headlineNoConnector": "Vidimo übermittelt diese Meldung nicht an {authority}",
      "headlineNotReached": "Diese Meldung hat {authority} nicht erreicht",
      "headlineOtherFacility": "{authority} führt diesen Gast unter einer anderen RNO-Nummer",
      "headlineUnattributed": "{authority} hat diese Meldung möglicherweise bereits erhalten",
      "headlineValidation": "{authority} hat diese Meldung abgelehnt",
      "lastTried": "Zuletzt versucht {when}",
      "legalDeadline": "Gesetzliche Frist · {deadline}",
      "markFiledAction": "Als manuell gemeldet markieren",
      "markFiledConfirm": "Als gemeldet markieren",
      "markFiledDescription": "Nur, wenn dieser Gast bei {authority} gemeldet ist: Du hast ihn selbst gemeldet oder im Portal gefunden. Vidimo erinnert dich dann nicht mehr daran und meldet diesen Gast danach nicht erneut.",
      "markFiledNotYet": "Noch nicht",
      "markFiledTitle": "Diese Meldung als erledigt markieren?",
      "markedFiledToast": "Als gemeldet markiert.",
      "nextStepAuth": "Hinterlege die Zugangsdaten der Unterkunft neu und versuch es dann noch einmal.",
      "nextStepFiledByHost": "Melde auch diesen Gast selbst vor Ablauf der Frist und markiere ihn dann hier als gemeldet.",
      "nextStepMissingData": "Ergänze die fehlenden Angaben und speichere, um neu zu melden.",
      "nextStepNoConnector": "Melde diesen Gast vor Ablauf der Frist selbst bei der Behörde und markiere ihn dann hier als gemeldet.",
      "nextStepOtherFacility": "Die Meldung dieses Gastes läuft im Portal der Behörde unter einer anderen RNO-Nummer. Hat der Gast im Beherbergungsbetrieb mit der anderen Nummer gewohnt, schließe die Meldung dort ab. Sonst storniere sie und melde den Gast unter der aktuellen Nummer. Markiere ihn dann hier als gemeldet. Wurde die RNO-Nummer dieser Unterkunft versehentlich geändert, stelle die alte wieder her und versuche es erneut.",
      "nextStepTransient": "Wird automatisch wiederholt.",
      "nextStepUnattributed": "Wir haben die Meldung für diesen Gast übermittelt, konnten aber nicht feststellen, ob die Behörde ihn registriert hat. Prüfe es im Portal der Behörde: Ist der Gast dort, tippe auf „Als manuell gemeldet markieren“, sonst auf „Erneut versuchen“.",
      "nextStepValidation": "Korrigiere die Angaben unten und speichere. Die Meldung wird für dich neu übermittelt.",
      "openPortal": "{authority} öffnen",
      "reconnectCredentials": "Zugangsdaten neu hinterlegen",
      "retry": "Erneut versuchen",
      "retrySubmittedToast": "Meldung übermittelt.",
      "withdrawDescription": "{authority} markiert den Eintrag als storniert, sodass dieser Gast nicht mehr als hier übernachtend gemeldet ist. Nutze das, wenn er nicht hier war: bei Nichterscheinen oder einem Aufenthalt, der für die falsche Unterkunft gemeldet wurde. Das lässt sich in Vidimo nicht rückgängig machen, und Vidimo meldet diesen Gast danach nicht erneut.",
      "withdrawnBody": "Der Eintrag bleibt im Register, als storniert markiert. Dieser Gast ist nicht als hier übernachtend gemeldet."
    },
    "mergeConfirmView": {
      "cancel": "Abbrechen",
      "confirm": "Zusammenführen bestätigen",
      "description": "Die Angaben von {source} werden dem Profil von {target} hinzugefügt.",
      "source": "Quelle",
      "target": "Ziel",
      "title": "Zusammenführen bestätigen"
    },
    "registrationDetailsForm": {
      "checkOutAtDeparture": "Die Abmeldung wird bei der Abreise übermittelt.",
      "correctDetails": "Angaben korrigieren",
      "correctingNote": "Beim Speichern gehen die korrigierten Angaben mit jeder Meldung raus, die noch aussteht oder abgelehnt wurde. Bereits von der Behörde angenommene Meldungen werden nicht erneut gesendet.",
      "errorNotSaved": "Die Angaben konnten nicht gespeichert werden. Versuch es noch einmal.",
      "idDocument": "Ausweisdokument",
      "noIdOnFile": "Noch kein Ausweis erfasst.",
      "optional": "Optional",
      "placeholderBirthCountry": "Geburtsland auswählen",
      "placeholderDocumentType": "Dokumentart auswählen",
      "placeholderIssuingCountry": "Ausstellungsland auswählen",
      "placeholderNationality": "Staatsangehörigkeit auswählen",
      "placeholderResidenceCountry": "Wohnsitzland auswählen",
      "placeholderSex": "Geschlecht auswählen",
      "placeholderStayPurpose": "Reisezweck auswählen",
      "saved": "Meldedaten gespeichert.",
      "savedBlockedAuth": "Gespeichert. Für die Meldung müssen die behördlichen Zugangsdaten der Unterkunft noch neu hinterlegt werden.",
      "savedBlockedFiledByHost": "Gespeichert. Die andere Meldung dieses Gastes hast du selbst erledigt, also melde auch diese selbst bei der Behörde.",
      "savedBlockedMissingData": "Gespeichert, aber der Meldung fehlen noch Angaben.",
      "savedBlockedNoConnector": "Gespeichert. Vidimo meldet diesen Gast nicht. Melde ihn bitte vor Ablauf der Frist selbst bei der Behörde.",
      "savedBlockedOtherFacility": "Gespeichert. Die Meldung dieses Gastes läuft unter einer anderen RNO-Nummer. Hat der Gast nicht im Beherbergungsbetrieb mit der anderen Nummer gewohnt, storniere die Meldung im Portal der Behörde und melde den Gast unter der aktuellen Nummer. Sonst schließe sie dort ab.",
      "savedBlockedUnknown": "Gespeichert, aber die Meldung braucht noch Aufmerksamkeit.",
      "savedBlockedValidation": "Gespeichert, aber die Behörde hat sie erneut abgelehnt.",
      "savedFiled": "Gespeichert und gemeldet. Die Behörde hat es bestätigt.",
      "savedSubmitted": "Gespeichert und übermittelt. Bestätigung ausstehend.",
      "scanAgain": "Dokument erneut scannen",
      "scanId": "Ausweis scannen",
      "title": "Meldung",
      "typeId": "Ausweisdaten eingeben"
    },
    "reservationFolioCard": {
      "add": "Hinzufügen",
      "addCharge": "Posten hinzufügen",
      "addChargeTitle": "Posten hinzufügen",
      "amountPlaceholder": "Betrag ({currency})",
      "balanceDue": "Offener Betrag",
      "breakfastControlLabel": "Frühstück wird für die Morgen des Aufenthalts festgelegt: Zum Frühstück",
      "breakfastControlTitle": "Wird für die Morgen des Aufenthalts unter „Frühstück“ festgelegt",
      "cancel": "Abbrechen",
      "capture": "Einziehen",
      "captureConfirm": "{amount} einziehen",
      "captureDescription": "{amount} wird von der Karte des Gastes auf dein Stripe-Konto übertragen. Das ist die gesamte Vorautorisierung: Du kannst danach erstatten, aber den Rest nicht später einziehen.",
      "captureTitle": "Diese Vorautorisierung einziehen?",
      "chargeKind": "Art des Postens",
      "chipFailed": "fehlgeschlagen",
      "chipHoldExpired": "Vorautorisierung abgelaufen",
      "chipOnHold": "vorautorisiert",
      "chipPending": "ausstehend",
      "chipRefunded": "erstattet",
      "chipReleased": "freigegeben",
      "collectPayment": "Zahlung kassieren",
      "collectedByChannelName": "Kassiert von {channel}",
      "complimentary": "Kostenlos",
      "descriptionPlaceholder": "Beschreibung",
      "errorChargeNotAdded": "Der Posten konnte nicht hinzugefügt werden. Versuch es noch einmal.",
      "errorChargeRemoveRolledBack": "Der Posten konnte nicht entfernt werden. Er steht wieder auf dem Gastkonto.",
      "errorEnterAmount": "Gib einen Betrag ein",
      "errorMoneyActionFailed": "Das hat nicht geklappt. Versuch es noch einmal.",
      "errorPaymentNotRecorded": "Die Zahlung konnte nicht erfasst werden. Versuch es noch einmal.",
      "errorPaymentRemoveRolledBack": "Die Zahlung konnte nicht entfernt werden. Sie steht wieder auf dem Gastkonto.",
      "fromChannel": "Vom Kanal",
      "fromChannelName": "Von {channel}",
      "holdCaptured": "Vorautorisierung eingezogen",
      "holdReleased": "Vorautorisierung freigegeben",
      "inTheRate": "Im Preis",
      "kindAccommodation": "Zimmerpreis",
      "kindAdjustment": "Korrektur",
      "kindDiscount": "Rabatt",
      "kindFee": "Gebühr",
      "kindTax": "Steuer",
      "methodBankTransfer": "Überweisung",
      "methodCard": "Karte",
      "methodCash": "Bar",
      "methodChannelCollected": "Vom Kanal kassiert",
      "methodDeposit": "Anzahlung",
      "methodGiftVoucher": "Gutschein",
      "methodOther": "Sonstige",
      "noCharges": "Noch keine Posten.",
      "notTaken": "Nicht genutzt",
      "partyAdults": "{count, plural, one {# Erwachsener} other {# Erwachsene}}",
      "partyAdultsAndChildren": "{adults, plural, one {# Erwachsener} other {# Erwachsene}} · {children, plural, one {# Kind} other {# Kinder}}",
      "partyChildren": "{count, plural, one {# Kind} other {# Kinder}}",
      "partyCovers": "{count, plural, one {# Gedeck} other {# Gedecke}}",
      "paymentMethod": "Zahlungsart",
      "quantityPlaceholder": "Menge",
      "rateAdultsAndChildren": "Erwachsene {adult} · Kinder {child}",
      "ratePerPerson": "{amount} pro Person",
      "record": "Erfassen",
      "recordPayment": "Zahlung erfassen",
      "recordPaymentTitle": "Zahlung erfassen",
      "referencePlaceholder": "Referenz (optional)",
      "refund": "Erstatten",
      "refundConfirm": "{amount} erstatten",
      "refundDescription": "{amount} geht von deinem Stripe-Konto an den Gast zurück. Stripe erstattet seine Transaktionsgebühr bei einer Rückerstattung nicht.",
      "refundIssued": "Erstattung veranlasst",
      "refundTitle": "Diese Zahlung erstatten?",
      "release": "Freigeben",
      "releaseConfirm": "{amount} freigeben",
      "releaseDescription": "Die Vorautorisierung über {amount} auf der Karte des Gastes wird aufgehoben und kann danach nicht mehr eingezogen werden. Für eine neue müsste der Gast erneut bezahlen.",
      "releaseTitle": "Diese Vorautorisierung freigeben?",
      "removeCharge": "Posten entfernen",
      "removePayment": "Zahlung entfernen",
      "title": "Gastkonto",
      "total": "Gesamt",
      "touristTax": "Kurtaxe",
      "voucherCodePlaceholder": "Gutscheincode (optional)"
    },
    "reservationTaxCard": {
      "filedThrough": "Gemeldet über {system}",
      "guestNumber": "Gast {number}",
      "guestShare": "{band} · {nights, plural, one {# Nacht} other {# Nächte}}",
      "needsBirthDates": "{count, plural, =0 {Ergänze die Geburtsdaten der Gäste} one {Ergänze das Geburtsdatum für # Gast} other {Ergänze die Geburtsdaten für # Gäste}}",
      "needsCategory": "Wähle die Kategorie der Unterkunft",
      "needsGuests": "Gib an, wie viele Gäste übernachten, um diese Steuer zu sehen",
      "needsIntegration": "Richte {system} ein, um diese Steuer zu sehen",
      "needsMunicipality": "Wähle die Gemeinde der Unterkunft, um diese Steuer zu sehen",
      "needsPrice": "Ergänze die Zimmerpreise, um diese Steuer zu sehen",
      "needsRegistration": "Richte die Gästemeldung ein, um diese Steuer zu sehen",
      "noLines": "Für diesen Aufenthalt wurde noch keine Kurtaxe berechnet.",
      "notCovered": "Noch nicht abgedeckt",
      "paysFree": "Befreit",
      "paysFull": "Voller Satz",
      "paysHalf": "Halber Satz",
      "paysPercent": "{percent} des Satzes",
      "ratePercent": "{percent} des Preises, höchstens {cap}",
      "ratePerNight": "{rate} pro Nacht",
      "ratePerNightFrom": "Ab {date}: {rate} pro Nacht",
      "rateWithSurcharge": "{rate} + {surcharge} {label}",
      "title": "Kurtaxe",
      "zone": "Satz für {zone}"
    },
    "reservationTaxNote": {
      "add": "Steuerhinweis hinzufügen",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "help": "Was das Team über die Kurtaxe dieses Aufenthalts weiß, aber nicht in der Buchung steht, z. B. dass der Gast eine Kurverordnung vorgelegt hat. Nur das Team sieht diesen Hinweis.",
      "label": "Steuerhinweis",
      "placeholder": "z. B. Gast hat eine ärztliche Kurverordnung vorgelegt",
      "save": "Hinweis speichern",
      "saveFailed": "Der Steuerhinweis konnte nicht gespeichert werden. Versuch es noch einmal."
    },
    "reservationUnitDetails": {
      "adults": "{count, plural, one {{count} Erwachsener} other {{count} Erwachsene}}",
      "blockedChannelCancelled": "Auf dem Kanal storniert: Nur der Kanal kann sie wiederherstellen.",
      "blockedPermission": "Du darfst den Status dieser Reservierung nicht ändern.",
      "blockedPreparing": "Diese Unterkunft ist in Vorbereitung, daher läuft dieser Aufenthalt noch über ihr bisheriges System. Er kann hier noch nicht geändert oder storniert werden, und es kann noch kein Check-in-Link gesendet werden.",
      "bookedVia": "Gebucht über",
      "bookerTitle": "Buchende Person",
      "bookingReference": "Buchungsnummer",
      "call": "Anrufen",
      "callAriaLabel": "{name} anrufen",
      "checkInLabel": "Check-in",
      "checkOutLabel": "Check-out",
      "children": "{count, plural, one {{count} Kind} other {{count} Kinder}}",
      "copyRoomLinkLabel": "Link zu Zimmer {room} kopieren",
      "duration": "{count, plural, one {{count} Nacht} other {{count} Nächte}}",
      "durationLabel": "Dauer",
      "expectedArrivalLabel": "Voraussichtliche Ankunft",
      "guestSummary": "{occupancy} · {idsOnFile} von {count, plural, one {{count} Ausweis} other {{count} Ausweisen}} erfasst",
      "guestsTitle": "Gäste",
      "houseRulesAccepted": "Akzeptiert am {date}",
      "houseRulesLabel": "Hausordnung",
      "infants": "{count, plural, one {{count} Kleinkind} other {{count} Kleinkinder}}",
      "moreGuestsExpected": "{count, plural, one {{count} weiterer Gast erwartet} other {{count} weitere Gäste erwartet}}",
      "notGiven": "Nicht angegeben",
      "notOnBookingYet": "Noch nicht in der Buchung · Ausweis scannen, um hinzuzufügen",
      "notSpecified": "Nicht angegeben",
      "occupancyLabel": "Belegung",
      "openGuestLabel": "{name} öffnen",
      "registrationAriaLabel": "Meldung von {name}: {status}",
      "reservationInformation": "Reservierungsdetails",
      "room": "Zimmer {room}",
      "scanBooker": "Ausweis scannen",
      "scanBookerAriaLabel": "Ausweis von {name} scannen",
      "scanId": "Ausweis scannen",
      "specialRequest": "Besonderer Wunsch",
      "taskWithUnit": "{task} · Einheit {unit}",
      "tasksTitle": "Aufgaben",
      "typeId": "Ausweis eingeben",
      "unassigned": "{count, plural, one {Nicht zugewiesen} other {# nicht zugewiesen}}",
      "unitLabel": "Einheit",
      "unitsLabel": "Einheiten",
      "unknownUnit": "Unbekannte Einheit",
      "unscheduled": "Ohne Termin"
    },
    "stayAction": {
      "checkIn": "Einchecken",
      "checkInGuest": "{guestName} einchecken",
      "checkOut": "Auschecken",
      "checkOutGuest": "{guestName} auschecken"
    },
    "unitOptions": {
      "booked": "Belegt"
    },
    "useStayAction": {
      "errorNotUpdated": "Der Aufenthalt konnte nicht aktualisiert werden. Versuch es noch einmal."
    }
  },

  "settings": {
    "accessSection": {
      "doorCode": "Türcode",
      "doorCodeDescription": "Gäste erhalten am Anreisetag einen Code für das Tastenfeld",
      "label": "Zugangsart",
      "lockbox": "Schlüsselsafe",
      "lockboxDescription": "Gäste holen den Schlüssel aus einem Codekasten",
      "placeholder": "Zugangsart auswählen",
      "receptionCloses": "Rezeption schließt",
      "receptionOpens": "Rezeption öffnet",
      "smartLock": "Smart Lock",
      "smartLockDescription": "Gäste öffnen mit einem Code oder einer App",
      "staffedReception": "Besetzte Rezeption",
      "staffedReceptionDescription": "Gäste holen die Schlüssel an der Rezeption ab"
    },
    "account": {
      "interfaceLanguage": {
        "automatic": "Automatisch ({language})",
        "description": "Menüs, Schaltflächen und Bildschirme werden in dieser Sprache angezeigt.",
        "title": "Sprache der App"
      }
    },
    "accountDeletion": {
      "genericFailure": "Dein Konto konnte nicht gelöscht werden. Versuch es noch einmal.",
      "protectedAccount": "Dieses Konto ist geschützt und kann nicht gelöscht werden.",
      "soleOwner": "{properties} {count, plural, one {hat} other {haben}} außer dir keinen weiteren Inhaber. Ernenne jemand anderen zum Inhaber oder lösche {count, plural, one {die Unterkunft} other {die Unterkünfte}}, bevor du dein Konto löschst."
    },
    "accountPassword": {
      "genericFailure": "Dein Passwort konnte nicht festgelegt werden. Versuch es noch einmal.",
      "sessionStale": "Melde dich zu deiner Sicherheit ab und wieder an, bevor du ein Passwort festlegst."
    },
    "accountView": {
      "appearanceDescription": "Änderungen gelten sofort auf diesem Gerät.",
      "appearanceTitle": "Darstellung",
      "errorNameRequired": "Name ist erforderlich",
      "errorPhotoNotSaved": "Dein Foto konnte nicht gespeichert werden. Versuch es noch einmal.",
      "hapticsDescription": "Ein kurzes Vibrieren, wenn ein Check-in, ein Scan oder ein Gästewechsel durch ist, damit du beim Gast bleiben kannst. Gilt sofort auf diesem Gerät.",
      "hapticsTitle": "Haptik",
      "hapticsToggle": "Bei Bestätigungen vibrieren",
      "languageArabic": "Arabisch",
      "languageDefault": "Standard (Englisch)",
      "languageChinese": "Chinesisch",
      "languageEnglish": "Englisch",
      "languageFrench": "Französisch",
      "languageGerman": "Deutsch",
      "languageItalian": "Italienisch",
      "languageJapanese": "Japanisch",
      "languagePortuguese": "Portugiesisch",
      "languageSlovenian": "Slowenisch",
      "languageSpanish": "Spanisch",
      "nameDescription": "Wird deinem Team und in deinen gesendeten Nachrichten angezeigt.",
      "namePlaceholder": "Deinen Namen eingeben",
      "nameTitle": "Vollständiger Name",
      "phoneDescription": "Deine geschäftliche Nummer.",
      "phoneTitle": "Telefonnummer",
      "photoAlt": "Profil",
      "photoCaption": "Tippen, um das Profilfoto zu ändern",
      "subtitle": "Profil und Angaben verwalten",
      "themeDark": "Dunkel",
      "themeLight": "Hell",
      "themeSystem": "System",
      "title": "Konto",
      "translationLanguageDescription": "Nachrichten in anderen Sprachen werden in diese Sprache übersetzt.",
      "translationLanguageTitle": "Übersetzungssprache"
    },
    "addressSection": {
      "countryLabel": "Land",
      "hint": "Suche die Adresse der Unterkunft und wähle sie aus. Wir nutzen sie, um den Standort festzulegen und das Land einzutragen.",
      "label": "Adresse",
      "placeholder": "Adresse der Unterkunft suchen…"
    },
    "availabilityDisplay": {
      "availableDuring": "Verfügbar {summary}",
      "awayOn": "Abwesend am {date}",
      "awayRange": "Abwesend {range}",
      "awayThrough": "Abwesend bis {end}",
      "awayToday": "Heute abwesend",
      "awayTomorrow": "Morgen abwesend",
      "outsideAvailability": "Außerhalb der Verfügbarkeit"
    },
    "breakfastPage": {
      "adult": "Erwachsene",
      "child": "Kinder",
      "errorSave": "Die Frühstückseinstellungen konnten nicht gespeichert werden. Versuch es noch einmal.",
      "from": "Von",
      "inclusionCharged": "Kostenpflichtig",
      "inclusionChargedDetail": "Gäste zahlen extra. Kostenlos ist es nur bei Buchungen mit Frühstückstarif (Übernachtung mit Frühstück).",
      "inclusionComplimentary": "Kostenlos",
      "inclusionComplimentaryDetail": "Gratis für alle Gäste, egal welchen Tarif sie gebucht haben. Nichts landet auf der Rechnung.",
      "inclusionIncluded": "Im Preis inbegriffen",
      "inclusionLabel": "Wie es bezahlt wird",
      "placeLabel": "Meist serviert",
      "priceHint": "Pro Person und Morgen, in {currency}. Wer als Kind zählt, ergibt sich aus der Buchung; bei Buchungen über Kanäle gilt deren eigene Altersregel.",
      "priceLabel": "Preis",
      "save": "Speichern",
      "saved": "Gespeichert",
      "serveBreakfast": "Frühstück anbieten",
      "serveBreakfastHint": "Aus bedeutet: Es werden keine Frühstücke geplant und unter „Heute“ erscheint nichts.",
      "serviceHint": "Gäste sehen diese Zeiten. Wo serviert wird, lässt sich für jedes Zimmer am jeweiligen Morgen ändern.",
      "serviceLabel": "Servicezeiten",
      "title": "Frühstück",
      "unavailableDescription": "Vidimo kann die Frühstückseinstellungen auf diesem Gerät nicht laden. Versuch es noch einmal; die App wird dabei neu geladen.",
      "unavailableTitle": "Das Frühstück lässt sich gerade nicht ändern",
      "until": "Bis"
    },
    "cancellationSection": {
      "flexible": "Flexibel",
      "hint": "{policyDescription} Gäste, die über deine öffentliche Seite buchen, sehen das vor dem Bezahlen, und Erstattungen richten sich danach.",
      "label": "Stornobedingungen",
      "moderate": "Moderat",
      "nonRefundable": "Nicht erstattungsfähig",
      "placeholder": "Stornobedingungen auswählen",
      "strict": "Streng"
    },
    "channelCards": {
      "announced": "Verbinde {label}, um Verfügbarkeit und Preise in beide Richtungen abzugleichen und neue Reservierungen direkt in Vidimo zu holen.",
      "cancel": "Abbrechen",
      "comingSoon": "Verbindungen mit {label} kommen bald.",
      "connectButton": "{label} verbinden",
      "connectTitle": "{label} verbinden",
      "connecting": "Wird verbunden…",
      "continue": "Weiter",
      "errorConnect": "Der Kanal konnte nicht verbunden werden. Versuch es noch einmal.",
      "errorOpenSetup": "Die Kanaleinrichtung konnte nicht geöffnet werden. Versuch es noch einmal.",
      "errorSync": "Synchronisierung fehlgeschlagen. Versuch es noch einmal.",
      "explainerLogin": "Du schließt auf einer sicheren Einrichtungsseite ab, halte also deine Zugangsdaten für {label} bereit.",
      "explainerOwnerOnly": "Nur das Eigentümerkonto des Inserats kann {label} verbinden, kein Co-Host.",
      "explainerSync": "Verfügbarkeit und Preise bleiben in beide Richtungen mit {label} abgeglichen, und neue Reservierungen kommen in Vidimo an.",
      "noUnits": "Füge dieser Unterkunft zuerst eine Einheit hinzu.",
      "opening": "Wird geöffnet…",
      "setUpChannels": "{label} einrichten",
      "statusError": "Fehler",
      "syncAction": "Verfügbarkeit & Preise synchronisieren",
      "syncDone": "Verfügbarkeit und Preise mit {label} neu synchronisiert.",
      "syncSlow": "{label} antwortet langsam. Die Synchronisierung wird automatisch abgeschlossen.",
      "syncStarted": "Synchronisierung gestartet. Sie läuft im Hintergrund weiter.",
      "syncing": "Wird synchronisiert…",
      "warnings": {
        "delayed": "Die Synchronisierung verzögert sich. Wir versuchen es automatisch weiter, du musst nichts tun.",
        "ourSide": "Bei uns ist mit diesem Kanal etwas schiefgelaufen. Unser Team weiß bereits Bescheid.",
        "unlinkedRoom": "Wir konnten eine neue Buchung nicht zuordnen. Prüfe die Einrichtung dieses Kanals."
      },
      "whichUnits": "Welche Einheiten sind auf {label} inseriert?"
    },
    "chrome": {
      "statusActionNeeded": "Handlungsbedarf",
      "statusConnected": "Verbunden",
      "statusOff": "Aus",
      "statusSettingUp": "Wird eingerichtet"
    },
    "cleaningChecklistEditor": {
      "addStep": "Schritt hinzufügen",
      "alwaysLast": "· immer zuletzt",
      "guestNeedsHint": "Gästewünsche aus der Buchung, etwa ein Babybett oder ein Haustier, werden direkt vor dem abschließenden Rundgang eingefügt.",
      "listFull": "{count, plural, one {Eine Checkliste kann höchstens # Schritt enthalten.} other {Eine Checkliste kann höchstens # Schritte enthalten.}}",
      "moveDown": "Schritt {position} nach unten",
      "moveUp": "Schritt {position} nach oben",
      "remove": "Schritt {position} entfernen",
      "saveList": "Checkliste speichern",
      "saving": "Wird gespeichert…",
      "stepBlank": "Fülle diesen Schritt aus oder entferne ihn.",
      "stepLabel": "Schritt {position}",
      "stepLength": "{length} / {max}",
      "stepPlaceholder": "Schritt beschreiben",
      "stepTooLong": "{count, plural, one {{count} Zeichen zu lang.} other {{count} Zeichen zu lang.}}",
      "unsavedChanges": "Ungespeicherte Änderungen"
    },
    "cleaningPage": {
      "allRooms": "Alle Zimmer",
      "assignHeading": "Wer die Aufgabe bekommt",
      "discard": "Verwerfen",
      "discardDescription": "Diese Checkliste hat ungespeicherte Änderungen. Wenn du jetzt wechselst, gehen sie verloren.",
      "discardDescriptionReload": "Du hast ungespeicherte Änderungen. Wenn du die App jetzt neu lädst, gehen sie verloren.",
      "discardTitle": "Änderungen verwerfen?",
      "errorReset": "Die Checkliste konnte nicht geändert werden. Versuch es noch einmal.",
      "errorSave": "Die Checkliste konnte nicht gespeichert werden. Versuch es noch einmal.",
      "giveOwnList": "Eigene Checkliste für {unitName} anlegen",
      "hintPostCheckout": "Ein Gast ist abgereist und an diesem Tag reist niemand an.",
      "hintRefresh": "Die Rezeption macht das gereinigte Zimmer kurz vor jeder Anreise fertig.",
      "hintTurnover": "Jemand reist ab und am selben Tag reist jemand anderes an.",
      "inheritedPostCheckoutFromProperty": "{unitName} nutzt die Checkliste der Unterkunft für die Reinigung nach dem Check-out:",
      "inheritedPostCheckoutFromStandard": "{unitName} nutzt die Standard-Checkliste für die Reinigung nach dem Check-out:",
      "inheritedPreCheckinRefreshFromProperty": "{unitName} nutzt die Checkliste der Unterkunft für die Auffrischung vor der Anreise:",
      "inheritedPreCheckinRefreshFromStandard": "{unitName} nutzt die Standard-Checkliste für die Auffrischung vor der Anreise:",
      "inheritedTurnoverFromProperty": "{unitName} nutzt die Checkliste der Unterkunft für den Gästewechsel:",
      "inheritedTurnoverFromStandard": "{unitName} nutzt die Standard-Checkliste für den Gästewechsel:",
      "intro": "Diese Einstellungen legen fest, wer jede von Vidimo erstellte Reinigungsaufgabe bekommt und mit welchen Schritten sie angelegt wird. Eine Zuweisung von Hand hat immer Vorrang, und bestehende Aufgaben bleiben, wie sie angelegt wurden.",
      "keepEditing": "Weiter bearbeiten",
      "kindLabel": "Art der Reinigung",
      "loading": "Deine Checklisten werden geladen…",
      "ownListCreated": "{name} hat jetzt eine eigene Checkliste. Bearbeite sie unten.",
      "refreshError": "Die Auffrischung konnte nicht ein- oder ausgeschaltet werden. Versuch es noch einmal.",
      "refreshHint": "Die Rezeption macht jedes gereinigte Zimmer kurz vor der Anreise des Gastes noch einmal fertig. Gilt nur für Buchungen, die nach dem Einschalten hinzugefügt werden.",
      "refreshLabel": "Auffrischung vor jeder Anreise",
      "resetLabelProperty": "Checkliste der Unterkunft verwenden",
      "resetLabelStandard": "Auf Standard-Checkliste zurücksetzen",
      "resetToProperty": "{name} nutzt jetzt die Checkliste der Unterkunft.",
      "resetToStandard": "Auf die Standard-Checkliste zurückgesetzt.",
      "saveAndSwitch": "Speichern und wechseln",
      "saveFirstDescription": "Diese Checkliste hat ungespeicherte Änderungen. Speichere sie vor dem Wechsel oder verwirf sie.",
      "saveFirstTitle": "Änderungen speichern?",
      "saved": "Checkliste gespeichert. Reinigungsaufgaben, die Vidimo ab jetzt erstellt, nutzen sie.",
      "scopeHint": "Gib einem Zimmer nur dann eine eigene Checkliste, wenn es sich von den anderen unterscheidet, etwa durch einen Balkon oder einen Whirlpool.",
      "scopeLabel": "Gilt für",
      "stepsHeading": "Checkliste",
      "thisRoom": "Dieses Zimmer",
      "title": "Reinigung",
      "unavailableDescription": "Vidimo kann die Checklisten auf diesem Gerät nicht laden. Beim erneuten Versuch startet die App neu.",
      "unavailableTitle": "Checklisten lassen sich gerade nicht ändern",
      "undo": "Rückgängig"
    },
    "createPage": {
      "created": "Unterkunft angelegt",
      "createdPendingSync": "Unterkunft angelegt. Sie erscheint, sobald deine Verbindung aufgeholt hat.",
      "description": "Lege eine neue Unterkunft an, um Gäste und Team zu verwalten.",
      "errorNotCreated": "Die Unterkunft konnte nicht angelegt werden. Versuch es noch einmal.",
      "title": "Unterkunft anlegen"
    },
    "createPropertyForm": {
      "addressHint": "Suche die Adresse und wähle sie aus, um den Standort festzulegen und das Land auszufüllen. Die Adresse kannst du auch später ergänzen.",
      "addressLabel": "Adresse",
      "addressNoCountry": "Diese Adresse hat kein Land. Wähle es unten aus.",
      "addressPlaceholder": "Adresse der Unterkunft suchen…",
      "cancel": "Abbrechen",
      "countryHint": "Bestimmt Gästemeldung, Kurtaxe und Mehrwertsteuer der Unterkunft.",
      "countryLabel": "Land *",
      "countryPlaceholder": "Land auswählen",
      "nameLabel": "Name der Unterkunft *",
      "namePlaceholder": "Name der Unterkunft eingeben",
      "submit": "Weiter"
    },
    "credentialHealth": {
      "accepted": "{system} hat am {checkedAt} deine Anmeldung und einen Testdatensatz akzeptiert. Bei der Prüfung wird nichts gemeldet.",
      "badge": {
        "enterAgain": "Neu eingeben",
        "keyRefused": "Schlüssel abgelehnt",
        "noAnswer": "Keine Antwort",
        "refusedAccount": "Konto abgelehnt",
        "signInRefused": "Anmeldung abgelehnt",
        "works": "Konto funktioniert"
      },
      "enterAgain": "Seit {since} kann Vidimo die gespeicherten Zugangsdaten nicht verwenden, daher wurde nichts an {system} gesendet. Gib sie neu ein.",
      "keyRefused": "Seit {since} lehnt {system} diesen {key} ab.{said} Erzeuge einen neuen und gib ihn über „Zugangsdaten aktualisieren“ ein. {help}",
      "noAnswer": "{system} hat auf die Prüfung von Vidimo am {checkedAt} nicht geantwortet.{streak} Vidimo prüft innerhalb eines Tages erneut.",
      "recordRefused": "Deine Anmeldung funktioniert. Am {checkedAt} hat {system} den Testdatensatz von Vidimo abgelehnt; das müssen wir beheben, nicht du.{said} Es wurde nichts gemeldet.",
      "refusedAccount": "Seit {since} akzeptiert {system} die Anmeldung, lehnt aber die Prüfung für dieses Konto ab.{said} Prüfe, ob der Webservice für dieses Konto aktiviert ist und ob eine Apartment- oder Kontonummer unten stimmt.",
      "said": " Antwort: „{message}“.",
      "signInRefused": "Seit {since} lehnt {system} die Anmeldung mit diesen Zugangsdaten ab.{said} Prüfe Benutzername und Passwort.",
      "streak": " Seit {since} gab es keine Rückmeldung.",
      "unanswered": "{system} hat am {checkedAt} statt eines Ergebnisses einen Fehler zurückgegeben: „{message}“.{streak} Vidimo prüft innerhalb eines Tages erneut."
    },
    "customDomainView": {
      "addDomain": "Domain hinzufügen",
      "copied": "In die Zwischenablage kopiert",
      "copyRecordValue": "Wert des {type}-Eintrags kopieren",
      "dnsInstructions": "Füge diese Einträge bei deinem Domain-Anbieter hinzu. DNS-Änderungen können ein paar Minuten brauchen, bis sie greifen.",
      "domainAdded": "Domain hinzugefügt: Richte die DNS-Einträge ein, um sie zu verifizieren",
      "domainLabel": "Deine Domain",
      "domainLive": "Deine Domain ist live",
      "domainPlaceholder": "dein-hotel.de",
      "domainRemoved": "Eigene Domain entfernt",
      "errorAdd": "Die Domain konnte nicht hinzugefügt werden",
      "errorCopy": "Kopieren in die Zwischenablage fehlgeschlagen",
      "errorRemove": "Die Domain konnte nicht entfernt werden",
      "intro": "Stell die Places-Website deiner Unterkunft unter deiner eigenen Domain bereit, z. B. <example>www.dein-hotel.de</example>. Gäste sehen die Adresse vidimo.app nie.",
      "loadFailedBody": "Prüf deine Verbindung und versuch es noch einmal.",
      "loadFailedTitle": "Die Domain-Einstellungen konnten nicht geladen werden",
      "openSite": "Website öffnen",
      "primary": "primär",
      "remove": "Entfernen",
      "retry": "Erneut versuchen",
      "siteLiveBody": "Gäste erreichen dich unter {url}.",
      "siteLiveTitle": "Deine Website ist live",
      "statusActive": "Aktiv",
      "statusError": "Fehler",
      "statusPendingDns": "DNS ausstehend",
      "statusVerifying": "Wird verifiziert",
      "stillWaiting": "Warten noch auf DNS, das kann ein paar Minuten dauern",
      "title": "Eigene Domain",
      "verificationFailedBody": "Prüf die DNS-Einträge unten und versuch es noch einmal.",
      "verificationFailedTitle": "Verifizierung fehlgeschlagen",
      "verify": "Verifizieren"
    },
    "deleteAccountSection": {
      "confirmPhrase": "endgültig löschen",
      "description": "Lösche dein Konto und deine persönlichen Daten endgültig, einschließlich deines Profils, deiner Nachrichten in Team-Chats und deines Zugriffs auf alle Unterkünfte, zu denen du gehörst. Das lässt sich nicht rückgängig machen.",
      "errorLoad": "Dieses Konto konnte nicht geprüft werden. Prüf deine Verbindung und versuch es noch einmal.",
      "errorNotDeleted": "Dein Konto konnte nicht gelöscht werden. Versuch es noch einmal.",
      "errorOffline": "Du bist offline, daher kann dieses Konto gerade nicht geprüft werden.",
      "title": "Konto löschen"
    },
    "deleteConfirmDialog": {
      "cancel": "Abbrechen",
      "confirmNamePrompt": "Gib zur Bestätigung ein: <strong>{entityName}</strong>",
      "confirmPhrasePrompt": "Um das Löschen von <strong>{entityName}</strong> zu bestätigen, gib <strong>„{expectedValue}“</strong> ein",
      "deleting": "Wird gelöscht…",
      "placeholder": "„{expectedValue}“ eingeben"
    },
    "deleteDangerSection": {
      "checking": "Wird geprüft…",
      "retry": "Erneut versuchen"
    },
    "disconnectIntegration": {
      "cancel": "Abbrechen",
      "disconnect": "Trennen",
      "disconnected": "{channel} getrennt",
      "disconnecting": "Wird getrennt…",
      "error": "{channel} konnte nicht getrennt werden. Versuch es noch einmal.",
      "title": "{channel} trennen?"
    },
    "editableSettingCard": {
      "errorNotSaved": "Speichern fehlgeschlagen. Versuch es noch einmal.",
      "save": "Speichern",
      "saved": "Gespeichert",
      "saving": "Wird gespeichert…"
    },
    "emailPreviewSheet": {
      "frameTitle": "E-Mail-Vorschau",
      "loading": "Wird geladen…",
      "sampleNote": "Ein Beispiel mit Name und Adresse deiner Unterkunft. Daten, Gast und Buchungsnummer sind erfunden.",
      "subject": "Betreff",
      "title": "Vorschau"
    },
    "facilityNumber": {
      "addedWithLogin": "Du gibst die {field} ein, wenn du unten die Zugangsdaten hinterlegst.",
      "elsewhere": "Das Register führt diese {field} in {other}, nicht in dieser Gemeinde. Prüfe die Nummer oder die Gemeinde der Unterkunft.",
      "errorSave": "Die {field} konnte nicht gespeichert werden. Versuch es noch einmal.",
      "listed": "Im Register für diese Gemeinde eingetragen.",
      "listedNamed": "Das Register führt {name} unter dieser Nummer.",
      "neededForTax": "Die Kurtaxe hängt hier davon ab, wo in der Gemeinde deine Unterkunft liegt, welcher Art sie ist oder wer sie betreibt. Deshalb braucht Vidimo diese Nummer, um die Kurtaxe zu berechnen.",
      "notListed": "Das Register führt unter dieser {field} keinen aktiven Betrieb in dieser Gemeinde. Ein heute eingetragener Betrieb erscheint dort erst am nächsten Tag.",
      "registerIncomplete": "Im Register stehen noch nicht genug Angaben zu diesem Betrieb, um die Kurtaxe zu berechnen. Vidimo zeigt die Kurtaxe an, sobald sie vorliegen.",
      "save": "Speichern",
      "saved": "{field} gespeichert",
      "saving": "Wird gespeichert…"
    },
    "guestPortalForm": {
      "cancel": "Abbrechen",
      "errorNotSaved": "Das Gästeportal konnte nicht gespeichert werden. Versuch es noch einmal.",
      "intro": "Gäste lesen das auf ihrer Aufenthaltsseite, und KI-Antwortentwürfe nutzen es als Grundlage. WLAN-Passwort und Türcodes erfahren die Entwürfe nie.",
      "parking": "Parken",
      "parkingSummary": "{count, plural, =0 {Noch nicht eingerichtet} one {# Stellplatz} other {# Stellplätze}}",
      "save": "Speichern",
      "subtitle": "Was Gäste auf ihrer Aufenthaltsseite lesen",
      "title": "Gästeportal"
    },
    "guestPortalPage": {
      "title": "Gästeportal"
    },
    "guestPreviewPage": {
      "desktopUnavailable": "Die Vorschau öffnet sich in der Web-App und in den Apps für Handy und Tablet.",
      "title": "Als Gast ansehen"
    },
    "guestRegistryPage": {
      "bornOn": "geb. {date}",
      "document": "{type} {number}",
      "documentIdCard": "Personalausweis",
      "documentOther": "Dokument",
      "documentPassport": "Reisepass",
      "documentWithIssuer": "{type} {number} ({country})",
      "emptyDescription": "Gäste erscheinen hier, sobald sie einchecken.",
      "emptyFilteredDescription": "Keine Einträge entsprechen diesen Filtern.",
      "emptyTitle": "Keine Einträge",
      "errorLoad": "Das Gästeverzeichnis konnte nicht geladen werden. Versuch es noch einmal.",
      "loadMore": "Mehr laden",
      "loadingMore": "Wird geladen…",
      "noDocument": "Kein Dokument",
      "occupancy": "{adults, plural, one {# Erw.} other {# Erw.}}",
      "occupancyUnknownAdults": "? Erw.",
      "occupancyUnknownAdultsWithChildren": "? Erw. · {children, plural, one {# Ki.} other {# Ki.}}",
      "occupancyWithChildren": "{adults, plural, one {# Erw.} other {# Erw.}} · {children, plural, one {# Ki.} other {# Ki.}}",
      "title": "Gästeverzeichnis"
    },
    "guestRegistryParams": {
      "statusAll": "Alle Aufenthalte",
      "statusCheckedIn": "Im Haus",
      "statusCheckedOut": "Abgereist"
    },
    "guestRegistryRegistryFilterBar": {
      "allTime": "Gesamter Zeitraum",
      "count": "{count, plural, one {{count} Eintrag} other {{count} Einträge}}",
      "countPartial": "{shown} von {total, plural, one {{total} Eintrag} other {{total} Einträgen}}",
      "customRange": "Eigener Zeitraum",
      "exportCsv": "CSV exportieren",
      "exporting": "Wird exportiert…",
      "intro": "Gesetzlicher Nachweis, wer hier übernachtet hat, erfasst beim Check-in. Neue Einträge kommen nur hinzu, bestehende werden nie geändert, auch nicht durch Ansehen oder Exportieren.",
      "rangePlaceholder": "Zeitraum wählen",
      "searchPlaceholder": "Gastnamen suchen…",
      "statusFilterLabel": "Nach Aufenthaltsstatus filtern",
      "yearFilterLabel": "Nach Jahr filtern"
    },
    "guestRegistryUseGuestRegistry": {
      "errorExport": "Das Gästeverzeichnis konnte nicht exportiert werden.",
      "errorLoadMore": "Weitere Einträge konnten nicht geladen werden."
    },
    "houseRulesSection": {
      "houseInfoHint": "Wie alles funktioniert: Heizung, Mülltonnen, Geräte, Ruhezeiten.",
      "houseInfoLabel": "Infos zum Haus",
      "houseInfoPlaceholder": "Die Heizung regelst du am Bedienfeld neben der Tür.\nDie Mülltonnen kommen dienstagabends raus.",
      "houseRulesHint": "Eine Regel pro Zeile. Gäste lesen sie in ihrem Portal und stimmen beim Check-in einmal zu; lass das Feld leer, um diesen Schritt auszulassen.",
      "houseRulesLabel": "Hausordnung",
      "houseRulesPlaceholder": "Rauchen ist im ganzen Haus verboten.\nNachtruhe von 22:00 bis 08:00 Uhr.",
      "localTipsHint": "Deine Tipps in der Nähe: Essen, Verkehrsmittel, was man nicht verpassen sollte.",
      "localTipsLabel": "Tipps vor Ort",
      "localTipsPlaceholder": "Bester Kaffee: die Bäckerei an der Ecke.\nDer Bus 6 fährt direkt in die Altstadt."
    },
    "importsPage": {
      "applyChange": "Von {source} übernehmen",
      "brief": "{guest} · {dates} · {rooms}",
      "briefBlock": "Gesperrt · {dates} · {rooms}",
      "briefCancelled": "{brief} · storniert",
      "candidate": "Frühere Buchung {number}",
      "changes": "{added} hinzugefügt · {amended} aktualisiert · {cancelled} storniert · {unchanged} unverändert",
      "current": "Stand in Vidimo",
      "detail": "{field}: {value}",
      "detailNone": "keine Angabe",
      "details": {
        "adults": "Erwachsene",
        "amountMinor": "Gesamt",
        "children": "Kinder",
        "email": "E-Mail",
        "infants": "Kleinkinder",
        "notes": "Notizen",
        "phone": "Telefon",
        "reason": "Grund",
        "source": "Quelle",
        "status": "Buchungsstatus"
      },
      "emptyDescription": "Diese Unterkunft läuft bereits über Vidimo, daher lassen sich keine Buchungen mehr importieren. Importe gibt es nur für eine Unterkunft, die noch in Vorbereitung ist.",
      "emptyTitle": "Keine Buchungen importiert",
      "errorLoad": "Deine Importe konnten nicht geladen werden. Versuch es gleich noch einmal.",
      "held": "{count, plural, one {# Buchung braucht deine Entscheidung} other {# Buchungen brauchen deine Entscheidung}}",
      "heldReason": {
        "host_changed": "Du hast Buchung {number} in Vidimo geändert oder Gäste in einem Zimmer erfasst, aus dem {source} die Buchung inzwischen herausgenommen hat, und {source} hat sie seitdem geändert. Deine Version bleibt erhalten, bis du entscheidest.",
        "host_deleted": "Du hast Buchung {number} in Vidimo gelöscht, und {source} hat sie seitdem geändert. Sie bleibt gelöscht, bis du entscheidest.",
        "possible_match": "Buchung {number} in {source} ist möglicherweise eine, die ein früherer Import unter einer anderen Nummer angelegt hat. Sie wurde nicht hinzugefügt, also ist nichts doppelt."
      },
      "heldRoomRemoved": "Das Zimmer dieser Buchung wurde aus Vidimo entfernt, daher lässt sich die Version aus {source} hier nicht verwenden.",
      "heldUntilNext": "Entscheide, bevor deine KI-App den nächsten Import ausführt: Sie schließt diese Fälle und fragt bei allen, die dann noch unklar sind, erneut nach.",
      "how": {
        "connect": "Füge Vidimo in Claude oder ChatGPT als Konnektor hinzu und lass „{importLabel}“ angehakt, wenn Vidimo fragt.",
        "copied": "Kopiert",
        "copy": "Prompt kopieren",
        "copyFailed": "Kopieren fehlgeschlagen. Markiere den Prompt und kopiere ihn von Hand.",
        "guide": "Anleitung lesen",
        "paste": "Füge diesen Prompt in einen neuen Chat ein. Deine KI-App hilft dir, alles Fehlende hinzuzufügen, stellt ein paar Fragen und kopiert die Buchungen.",
        "prompt": "Ich möchte meine Buchungen aus meinem bisherigen System in meine Vidimo-Unterkunft {property} kopieren. Prüfe als Erstes, ob du die zwei Dinge hast, die dafür nötig sind. Fehlt eines davon, hör auf, sag mir, welches, und führe mich durch die Einrichtung.\n\n1. Die Tools von Vidimo, etwa getImportPlaybook. Hast du sie nicht, ist Vidimo in diesem Chat entweder ausgeschaltet oder in dieser App noch nicht hinzugefügt. Bitte mich zuerst, in den Konnektoren dieser App nachzusehen: Ist Vidimo dort, schalte ich es ein. Wenn nicht, hilf mir, es als benutzerdefinierten Konnektor mit der Adresse {connectorUrl} hinzuzufügen. In Claude geht das über Customize, Connectors, Add, Add custom connector. In ChatGPT über Plugins, Add, Add custom MCP server. Das sind die englischen Bezeichnungen: Ist meine Oberfläche nicht auf Englisch, nenn mir die, die bei mir angezeigt werden. Wenn Vidimo fragt, melde ich mich an und lasse „{importLabel}“ angehakt. Sag mir dann, dass ich einen neuen Chat beginnen und diesen Prompt noch einmal einfügen soll, denn ein Chat hat nur die Konnektoren, die beim Start des Chats eingeschaltet waren. Wenn du Webseiten öffnen kannst: Die Schritte stehen auch unter {guideUrl}.\n\n2. Einen Browser, den du für mich bedienen kannst, in dem ich mich bei meinem System anmelde und du seine Seiten liest, etwa Claude in Chrome oder den Work mode von ChatGPT. Eine Websuche reicht nicht, denn für mein System muss ich angemeldet sein. Wenn du in diesem Chat keinen nutzen kannst, sag mir, wie ich in dieser App einen bekomme.\n\nSobald du beides hast, rufe getImportPlaybook auf und folge seinen Anweisungen.",
        "signIn": "Öffne in dem Browser, den deine KI-App nutzt, dein bisheriges System und melde dich an.",
        "title": "Importiere deine Buchungen mit deiner KI-App"
      },
      "ignore": "Nicht hinzufügen",
      "intro": "Jeder Import, den deine KI-App ausgeführt hat, abgeglichen mit den Summen deines bisherigen Systems, wo es sie anzeigt.",
      "introUndo": "Solange diese Unterkunft in Vorbereitung ist, kannst du einen Import rückgängig machen und so die Buchungen entfernen, die er angelegt hat.",
      "keep": "Behalten",
      "keepDeleted": "Gelöscht lassen",
      "keepMine": "Meine Version behalten",
      "matches": "Stimmt mit {source} überein: Die Buchungen jedes Monats und die Nächte jedes Zimmers passen.",
      "mismatch": "Weicht von {source} ab",
      "missingInVidimo": "{room}, Nächte {nights}: in {source} gebucht, in Vidimo frei",
      "monthDifference": "{month}: {pms, plural, one {# Anreise} other {# Anreisen}} in {source}, {vidimo} in Vidimo",
      "noTotals": "Die Summen von {source} wurden mit diesem Import nicht übermittelt, daher kann Vidimo nicht bestätigen, dass nichts fehlt. Vergleiche ihn selbst mit {source}.",
      "notInPms": "{room}, Nächte {nights}: in Vidimo gebucht, in {source} frei",
      "notSent": "{count, plural, one {# Buchung aus einem früheren Import war in diesem nicht enthalten. Sie wurde unverändert gelassen, nicht storniert.} other {# Buchungen aus früheren Importen waren in diesem nicht enthalten. Sie wurden unverändert gelassen, nicht storniert.}}",
      "problems": "{count, plural, one {# Punkt zum Prüfen} other {# Punkte zum Prüfen}}, gemeldet von deiner KI-App am Ende des Imports",
      "proposed": "Stand in {source}",
      "resolveFailed": "Deine Entscheidung konnte nicht gespeichert werden. Versuch es gleich noch einmal.",
      "resolveRefused": "Diese Entscheidung lässt sich so nicht anwenden: Die Buchung wurde inzwischen geändert, passt nicht mehr zu ihrem Zeitraum oder ihren Zimmern oder würde Gäste entfernen, die du in einem Zimmer erfasst hast. Prüfe die Buchung in Vidimo und entscheide dann erneut.",
      "restore": "Aus {source} wiederherstellen",
      "runTitle": "Aus {source}",
      "sameBooking": "Dieselbe Buchung",
      "separateBooking": "Als neue Buchung hinzufügen",
      "status": {
        "finished": "Fertig",
        "open": "Läuft",
        "undone": "Rückgängig gemacht"
      },
      "stillImporting": "Der Import läuft noch. Sobald er fertig ist, wird er mit den Summen von {source} abgeglichen, sofern deine KI-App sie senden kann.",
      "title": "Importierte Buchungen",
      "superseded": "Seitdem wurde ein späterer Import aus {source} abgeschlossen, daher zählt der Abgleich dieses Imports nicht mehr: Sieh dir den späteren an.",
      "totals": "{source}: {pmsBookings, plural, one {# Buchung} other {# Buchungen}} mit Anreise, {pmsNights, plural, one {# Zimmernacht} other {# Zimmernächte}}. Vidimo: {vidimoBookings, plural, one {# Buchung} other {# Buchungen}}, {vidimoNights, plural, one {# Zimmernacht} other {# Zimmernächte}}.",
      "totalsFrom": "Abgeglichen mit den Summen von {source}, Stand {date}.",
      "undo": "Import rückgängig machen",
      "undoAmended": "Änderungen, die er an Buchungen aus früheren Importen vorgenommen hat, bleiben erhalten.",
      "undoBody": "Damit entfernst du aus Vidimo {reservations, plural, one {die Buchung} other {die # Buchungen}}{blocks, plural, =0 {} one { und # gesperrtes Zimmer} other { und # gesperrte Zimmer}}, die dieser Import aus {source} kopiert hat. In {source} ändert sich nichts, und Buchungen, die du selbst angelegt hast oder die andere Importe hinzugefügt haben, bleiben erhalten.",
      "undoFailed": "Der Import konnte nicht rückgängig gemacht werden. Versuch es gleich noch einmal.",
      "undoGuestDetails": "{count, plural, one {# der importierten Buchungen enthält Gäste, die du erfasst hast: Diese Einträge werden ebenfalls entfernt, die Gastprofile bleiben erhalten.} other {# der importierten Buchungen enthalten Gäste, die du erfasst hast: Diese Einträge werden ebenfalls entfernt, die Gastprofile bleiben erhalten.}}",
      "undoNothingAdded": "Nichts, was dieser Import angelegt hat, ist noch in Vidimo, daher entfernt das Rückgängigmachen nichts. Er wird als rückgängig gemacht markiert, und die Fälle, die er noch für deine Entscheidung zurückgehalten hat, werden geschlossen.",
      "undoOpenBody": "Dieser Import läuft noch. Wenn du ihn rückgängig machst, wird er gestoppt und jede Buchung, die er bisher aus {source} kopiert hat, aus Vidimo entfernt (derzeit {reservations}). In {source} ändert sich nichts, und Buchungen, die du selbst angelegt hast oder die andere Importe hinzugefügt haben, bleiben erhalten.",
      "undoRefusedActive": "Diese Unterkunft läuft jetzt über Vidimo, daher kann ein Import nicht mehr rückgängig gemacht werden. Ändere ihre Buchungen einzeln.",
      "undoTitle": "Diesen Import rückgängig machen?",
      "undone": "Import rückgängig gemacht: {reservations, plural, one {# Buchung} other {# Buchungen}}{blocks, plural, =0 {} one { und # gesperrtes Zimmer} other { und # gesperrte Zimmer}} entfernt.",
      "undoneOn": "Am {date} rückgängig gemacht. Die Buchungen, die er angelegt hatte, wurden entfernt.",
      "unknownRoom": "Ein gelöschtes Zimmer"
    },
    "infoEdit": {
      "errorNotDeleted": "Die Unterkunft konnte nicht gelöscht werden. Versuch es noch einmal."
    },
    "inviteMemberDrawer": {
      "emailHint": "Wir schicken per E-Mail einen Link zum Beitreten und einen Einladungscode für die App.",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "name@beispiel.de",
      "errorFailed": "Einladung fehlgeschlagen",
      "noPermission": "Du darfst in dieser Unterkunft keine Mitglieder einladen.",
      "roleLabel": "Rolle",
      "submit": "Einladung senden",
      "submitPending": "Wird gesendet…",
      "title": "Mitglied einladen"
    },
    "joinPage": {
      "description": "Gib den erhaltenen Einladungscode ein, um deinem Team beizutreten.",
      "title": "Einer Unterkunft beitreten"
    },
    "joinPropertyForm": {
      "cancel": "Abbrechen",
      "codeLabel": "Einladungscode",
      "codePlaceholder": "Einladungscode eingeben",
      "submit": "Beitreten"
    },
    "linkError": {
      "alreadyLinkedToDifferentUser": "Dieses Konto ist bereits mit einem anderen Vidimo-Konto verbunden. Trenne es dort zuerst.",
      "emailDoesNotMatch": "Dieses Konto nutzt eine andere E-Mail-Adresse. Du kannst nur ein Konto mit derselben E-Mail-Adresse wie dieses verbinden.",
      "emailNotFound": "Dieser Anbieter hat keine E-Mail-Adresse übermittelt, daher lässt sich das Konto nicht zuordnen.",
      "generic": "Dieses Konto konnte nicht verbunden werden. Versuch es noch einmal.",
      "unableToLinkAccount": "Dieses Konto konnte nicht verbunden werden. Stell sicher, dass die E-Mail-Adresse beim Anbieter bestätigt ist, und versuch es dann noch einmal."
    },
    "linkSocialAccount": {
      "linkFailed": "Dein {provider}-Konto konnte nicht verknüpft werden"
    },
    "membersAvailability": {
      "notFound": "Mitglied nicht gefunden"
    },
    "membersMembers": {
      "errorNotResent": "Die Einladung konnte nicht erneut gesendet werden. Versuch es noch einmal.",
      "errorNotWithdrawn": "Die Einladung konnte nicht zurückgezogen werden. Versuch es noch einmal.",
      "resent": "Einladung erneut an {email} gesendet",
      "withdrawn": "Einladung zurückgezogen"
    },
    "connectRefusal": {
      "account_claimed": "Dieses Konto gehört bereits zu einer anderen Unterkunft und kann hier nicht verbunden werden.",
      "contactSupport": "Support kontaktieren",
      "number_claimed": "Diese Nummer gehört bereits zu einer anderen Unterkunft und kann hier nicht verbunden werden.",
      "numberClaimedBy": "Diese Nummer gehört bereits zu {property} und kann hier nicht verbunden werden.",
      "property_preparing": "Diese Unterkunft ist in Vorbereitung, daher lässt sich noch nichts verbinden. Eine Verbindung könnte einen Dienst übernehmen, den dein bisheriges System betreibt.",
      "setup_broken": "Die Einrichtung hängt an einer Stelle fest, an der die App nicht weiterkommt. Das Vidimo-Team kann das für dich klären.",
      "subscription_required": "Um einen Kanal zu verbinden, ist ein aktives Abo nötig."
    },
    "messagingCards": {
      "addressCopied": "Adresse kopiert",
      "checking": "Wird geprüft…",
      "codeAccepted": "Code akzeptiert. Verbindung wird abgeschlossen.",
      "codeHint": "WhatsApp schickt ihn per SMS oder automatischem Anruf. Es kann ein paar Minuten dauern, bis er ankommt.",
      "codeLabel": "Gib den Code ein, den WhatsApp dir geschickt hat",
      "codeLabelSentTo": "Gib den an {e164} gesendeten Code ein",
      "comingSoon": "Demnächst",
      "connectFailed": "Verbindung fehlgeschlagen. Versuch es noch einmal.",
      "connectInstagram": "Instagram verbinden",
      "connectWhatsApp": "WhatsApp verbinden",
      "copyEmailAddress": "E-Mail-Adresse kopieren",
      "disconnectInstagramDescription": "Neue Direktnachrichten erreichen Vidimo nicht mehr, und das Konto wird freigegeben, sodass es hier oder bei einer anderen Unterkunft neu verbunden werden kann. Deine bisherigen Unterhaltungen bleiben in den Chats.",
      "disconnectWhatsAppDescription": "Gästenachrichten an diese Nummer erreichen Vidimo nicht mehr. Deine bisherigen Unterhaltungen bleiben in den Chats.",
      "emailDescription": "Gäste können an diese Adresse schreiben. Ihre Nachrichten landen hier in den Chats, ohne Einrichtung und ohne Weiterleitung.",
      "errorCode": "Dieser Code hat nicht funktioniert. Prüf ihn und versuch es noch einmal.",
      "errorConnectInstagram": "Die Instagram-Verbindung konnte nicht gestartet werden",
      "errorCopyAddress": "Die Adresse konnte nicht kopiert werden",
      "errorLinkPhone": "Die Nummer konnte nicht verknüpft werden. Versuch es noch einmal.",
      "errorOpenManagement": "Die WhatsApp-Verwaltung konnte nicht geöffnet werden. Versuch es noch einmal.",
      "errorReachWhatsApp": "WhatsApp ist nicht erreichbar. Versuch es gleich noch einmal.",
      "errorStartConnection": "Die Verbindung konnte nicht gestartet werden. Versuch es noch einmal.",
      "instagramConnected": "Feed und Direktnachrichten sind verbunden.",
      "instagramPitch": "Zeig deinen Feed und beantworte DMs direkt im Posteingang.",
      "instagramReplyRule": "Auf Instagram kannst du erst antworten, nachdem ein Gast dir geschrieben hat.",
      "linkPhone": "Nummer verknüpfen",
      "linking": "Wird verknüpft…",
      "manageWhatsApp": "In WhatsApp Business verwalten",
      "number": "Nummer: <number>{e164}</number>",
      "numberConnected": "Verbundene Nummer: <number>{e164}</number>",
      "numberConnecting": "Nummer wird verbunden: <number>{e164}</number>",
      "opening": "Wird geöffnet…",
      "phoneLinked": "Telefonnummer verknüpft",
      "phoneNumberLabel": "Telefonnummer (E.164)",
      "phoneSubtitle": "Twilio-Telefonie und -SMS für diese Unterkunft",
      "reconnectInstagram": "Instagram neu verbinden",
      "reconnecting": "Wird neu verbunden…",
      "retryConnection": "Verbindung erneut versuchen",
      "senderOffline": {
        "displayNameRejected": "WhatsApp hat den Anzeigenamen für diese Nummer nicht genehmigt. Wähle im WhatsApp Manager einen anderen Namen und versuch die Verbindung dann erneut.",
        "numberReassigned": "Diese Nummer ist jetzt bei einem anderen WhatsApp-Konto registriert, daher erreichen Gästenachrichten diese Unterkunft nicht mehr.",
        "numberRemoved": "Diese Nummer wurde aus WhatsApp Business entfernt. Versuch die Verbindung erneut, um sie wieder einzurichten.",
        "policyRestricted": "WhatsApp hat diese Nummer wegen eines Verstoßes gegen die Geschäftsrichtlinien eingeschränkt. Im WhatsApp Manager siehst du, was zu beheben ist.",
        "unrecognised": "WhatsApp hat diese Nummer deaktiviert. Versuch die Verbindung erneut, um sie wieder einzurichten, oder sieh dir die Details im WhatsApp Manager an."
      },
      "statusActionNeeded": "Handlungsbedarf",
      "statusActive": "Aktiv",
      "statusConnected": "Verbunden",
      "submit": "Senden",
      "twilioSidLabel": "SID der Twilio-Nummer (optional)",
      "update": "Aktualisieren",
      "whatsAppEmpty": "Verbinde eine WhatsApp-Business-Nummer, um Gästenachrichten für diese Unterkunft zu empfangen.",
      "whatsAppNumberHeld": "WhatsApp gibt diese Nummer noch nicht frei. Trenne sie und verbinde sie dann erneut.",
      "whatsAppNumberHint": "Gib dieselbe Nummer an, wenn du dich im nächsten Schritt bei Meta registrierst.",
      "whatsAppNumberLabel": "WhatsApp-Nummer",
      "whatsAppReconnected": "WhatsApp neu verbunden",
      "whatsAppSettingUp": "Meist ein paar Minuten. Du kannst diesen Bildschirm verlassen: Die Einrichtung wird von selbst abgeschlossen.",
      "whatsAppSettingUpTitle": "Deine Nummer wird bei WhatsApp eingerichtet",
      "whatsAppSubtitle": "Gästenachrichten über die eigene Nummer der Unterkunft",
      "whatsAppUnavailable": "Das Verbinden von WhatsApp ist in dieser Umgebung nicht verfügbar."
    },
    "municipalitySection": {
      "countryPending": "Das Land der Unterkunft wurde gerade geändert. Die Gemeinden des neuen Landes erscheinen hier, sobald die Änderung bei Vidimo angekommen ist.",
      "loadFailed": "Die Gemeinde konnte nicht geladen werden. Prüf deine Verbindung.",
      "noCountry": "Gib zuerst unter <link>Allgemein</link> Adresse und Land der Unterkunft an.",
      "noMatch": "Keine Gemeinde gefunden",
      "notListed": "Vidimo hat die Gemeindeliste dieses Landes noch nicht.",
      "pickFailed": "Die Gemeinde konnte nicht gespeichert werden. Versuch es noch einmal.",
      "placeholder": "Gemeinde auswählen",
      "retired": "Diese Gemeinde steht nicht mehr auf der amtlichen Liste. Wähle die Nachfolgegemeinde.",
      "retry": "Erneut versuchen",
      "searchFailed": "Suche fehlgeschlagen. Prüf deine Verbindung.",
      "searchLabel": "Gemeinde suchen",
      "searching": "Wird gesucht…",
      "source": "{method, select, host {Von dir ausgewählt} address_register {Aus deiner Adresse ermittelt} other {Für diese Unterkunft festgelegt}}",
      "title": "Gemeinde",
      "typeToSearch": "Gib zum Suchen einen Namen ein"
    },
    "notificationsView": {
      "complianceDescription": "Gästemeldungen, die Vidimo nicht übermittelt, und solche, deren gesetzliche Meldefrist bald abläuft",
      "complianceLabel": "Meldefristen",
      "messagesDescription": "Neue Nachrichten von Gästen und deinem Team",
      "messagesLabel": "Nachrichten",
      "reservationsDescription": "Anreisende Gäste, Stornierungen und abgelaufene Kartenvorautorisierungen",
      "reservationsLabel": "Reservierungen",
      "title": "Benachrichtigungen"
    },
    "operationalState": {
      "badge": "In Vorbereitung",
      "blocked": "Diese Unterkunft ist in Vorbereitung, daher läuft sie noch nicht über Vidimo. Dein bisheriges System kümmert sich weiterhin um ihre Reservierungen und Gäste.",
      "description": "Die Unterkunft läuft noch über dein bisheriges System. Richte sie ein und sieh dich in Ruhe um: Was du hier tust, erreicht noch keine Gäste, Kanäle oder Behörden.",
      "importBookings": "Buchungen importieren",
      "noConnections": "Kanäle, WhatsApp, Instagram und Telefonnummern lassen sich nicht verbinden.",
      "noFilings": "Es werden keine Gästemeldungen oder Statistiken übermittelt.",
      "noGuestContact": "Gäste erhalten keine Nachrichten, Check-in-Links oder Zahlungsanfragen.",
      "noReservations": "Reservierungen können nicht erstellt, geändert oder storniert werden.",
      "privateWebsite": "Deine Website und deine Buchungsseite bleiben privat.",
      "title": "Diese Unterkunft ist in Vorbereitung"
    },
    "parkingEditor": {
      "addParking": "Parkplatz hinzufügen",
      "addPhotos": "Fotos hinzufügen",
      "cancel": "Abbrechen",
      "checkOnMap": "Auf der Karte prüfen",
      "delete": "Diesen Parkplatz löschen",
      "directionsLabel": "Anfahrt",
      "directionsPlaceholder": "Einfahrt über die Hauptstraße. Am Schranken ein Ticket ziehen; wir entwerten es an der Rezeption.",
      "errorUpload": "Dieses Foto konnte nicht hochgeladen werden.",
      "linkErrorNoLocation": "In diesem Link haben wir keinen Standort gefunden. Setz in Google Maps eine Markierung an die Stelle, tippe auf „Teilen“ und füge den Link hier ein.",
      "linkErrorNotGoogle": "Hier funktionieren nur Google-Maps-Links. Öffne die Stelle in Google Maps, tippe auf „Teilen“ und füge den Link ein.",
      "linkErrorTooLong": "{count, plural, one {Dieser Link ist zu lang zum Speichern (über {count} Zeichen). Setz stattdessen eine Markierung in Google Maps und teile sie.} other {Dieser Link ist zu lang zum Speichern (über {count} Zeichen). Setz stattdessen eine Markierung in Google Maps und teile sie.}}",
      "linkErrorUnreadable": "Dieser Link konnte nicht gelesen werden. Prüf deine Verbindung und versuch es noch einmal.",
      "locationLabel": "Standort",
      "mapsLinkHint": "Für einen Platz ohne Adresse setz eine Markierung in Google Maps und füge ihren Link ein. Optional: Lass das Feld leer, wenn die Anfahrt alles sagt.",
      "mapsLinkLabel": "Google-Maps-Link",
      "mapsLinkPlaceholder": "Oder Google-Maps-Link einfügen",
      "nameLabel": "Name",
      "namePlaceholder": "Tiefgarage am Marktplatz",
      "photoAlt": "Parkplatz {number}",
      "photosHint": "{count, plural, one {Einfahrt, Schranke oder Stellplatz: bis zu # Foto. Screenshots gehen auch.} other {Einfahrt, Schranke oder Stellplatz: bis zu # Fotos. Screenshots gehen auch.}}",
      "photosLabel": "Fotos",
      "pinnedAt": "Markiert bei {latitude}, {longitude}",
      "removeLocation": "Standort entfernen",
      "removePhoto": "Foto {number} entfernen",
      "save": "Speichern",
      "searchAddress": "Adresse suchen",
      "searchDifferentAddress": "Andere Adresse suchen",
      "uploading": "Wird hochgeladen…",
      "useLink": "Link verwenden"
    },
    "parkingEditorPage": {
      "deleted": "{label} gelöscht.",
      "deleting": "Wird gelöscht…",
      "errorDelete": "Der Parkplatz konnte nicht gelöscht werden. Versuch es noch einmal.",
      "errorRestore": "Der Parkplatz konnte nicht wiederhergestellt werden. Füge ihn neu hinzu.",
      "errorSave": "Der Parkplatz konnte nicht gespeichert werden. Versuch es noch einmal.",
      "newTitle": "Neuer Parkplatz",
      "notFound": "Dieser Parkplatz wurde gelöscht oder hat nie existiert.",
      "saved": "Parkplatz gespeichert.",
      "title": "Parken",
      "undo": "Rückgängig"
    },
    "parkingPage": {
      "add": "Parkplatz hinzufügen",
      "emptyDescription": "Füge die Garage, Straße oder Wiese hinzu, die deine Gäste nutzen, mit Anfahrt und einem Foto der Einfahrt.",
      "emptyTitle": "Noch keine Parkplätze",
      "errorReorder": "Die Reihenfolge konnte nicht geändert werden. Versuch es noch einmal.",
      "intro": "Sag Gästen, wo sie das Auto abstellen können. Sie sehen das vor der Anreise, um die Fahrt zu planen, und während des ganzen Aufenthalts.",
      "loading": "Deine Parkplätze werden geladen…",
      "moveDown": "{label} nach unten",
      "moveUp": "{label} nach oben",
      "photoCount": "{count, plural, one {{count} Foto} other {{count} Fotos}}",
      "pinnedLocation": "Markierter Standort",
      "title": "Parken"
    },
    "passwordDialog": {
      "cancel": "Abbrechen",
      "changeDescription": "Gib dein aktuelles Passwort ein und wähle dann ein neues. Hier bleibst du angemeldet; auf anderen Geräten wirst du abgemeldet.",
      "changeSubmit": "Passwort ändern",
      "changeTitle": "Passwort ändern",
      "confirmPasswordLabel": "Neues Passwort bestätigen",
      "confirmPasswordPlaceholder": "Passwort erneut eingeben",
      "currentPasswordLabel": "Aktuelles Passwort",
      "errorCurrentRequired": "Gib dein aktuelles Passwort ein",
      "errorMismatch": "Die Passwörter stimmen nicht überein",
      "errorNotSaved": "Dein Passwort konnte nicht gespeichert werden. Versuch es noch einmal.",
      "errorTooShort": "Das Passwort muss mindestens {count, plural, one {# Zeichen} other {# Zeichen}} lang sein",
      "newPasswordLabel": "Neues Passwort",
      "newPasswordPlaceholder": "Mindestens {count, plural, one {# Zeichen} other {# Zeichen}}",
      "setDescription": "Wähle ein Passwort, damit du dich auch mit deiner E-Mail-Adresse anmelden kannst. Deine bisherigen Anmeldemethoden funktionieren weiter.",
      "setSubmit": "Passwort festlegen",
      "setTitle": "Passwort festlegen",
      "submitPending": "Wird gespeichert…"
    },
    "paymentsCard": {
      "statusActionNeeded": "Handlungsbedarf",
      "statusConnected": "Verbunden",
      "statusDisabled": "Deaktiviert",
      "statusNotConnected": "Nicht verbunden",
      "statusOff": "Aus",
      "statusSetupUnfinished": "Einrichtung unvollständig",
      "subtitle": "Kartenzahlungen von Gästen über dein eigenes Stripe-Konto",
      "subtitleSettles": "Stripe · Auszahlung in {currency}",
      "subtitleSettlesAccountCurrency": "Stripe · Auszahlung in deiner Kontowährung",
      "title": "Kartenzahlungen"
    },
    "paymentsPage": {
      "title": "Zahlungen"
    },
    "paymentsView": {
      "checkAgain": "Erneut prüfen",
      "checkingWithStripe": "Wird bei Stripe geprüft",
      "connectStripe": "Stripe-Konto verbinden",
      "continueStripeSetup": "Stripe-Einrichtung fortsetzen",
      "depositChargeBody": "Kassiere das Geld im Voraus. Es landet in deinem Stripe-Guthaben, und eine Rückgabe ist eine Erstattung.",
      "depositChargeLabel": "Belasten",
      "depositHoldBody": "Reserviere den Betrag auf der Karte des Gastes, ohne ihn einzuziehen. Zieh ein, was du brauchst, oder gib den Rest frei. Vorautorisierungen verfallen nach etwa 7 Tagen.",
      "depositHoldLabel": "Auf der Karte vorautorisieren",
      "depositsTitle": "Kautionen",
      "description": "Nimm Kartenzahlungen von Gästen über dein eigenes Stripe-Konto an. Das Geld geht direkt an dich, Vidimo behält nichts ein.",
      "errorLoad": "Einstellungen konnten nicht geladen werden",
      "errorOpenStripe": "Stripe konnte nicht geöffnet werden",
      "errorReachStripe": "Stripe ist nicht erreichbar",
      "errorSave": "Speichern fehlgeschlagen",
      "finishingSetup": "Einrichtung mit Stripe wird abgeschlossen. Das dauert meist ein paar Sekunden.",
      "loadFailed": "Deine Zahlungseinstellungen konnten nicht geladen werden. Dein Stripe-Konto und bereits erhaltene Zahlungen sind davon nicht betroffen.",
      "offHint": "Lass das ausgeschaltet, um Zahlungen weiter wie bisher von Hand zu erfassen.",
      "openStripe": "Stripe öffnen",
      "payoutsEnabled": "Auszahlungen sind aktiviert.",
      "payoutsEnabledSettles": "Auszahlungen sind aktiviert. Auszahlung in {currency}.",
      "payoutsNotEnabled": "Auszahlungen sind noch nicht aktiviert.",
      "payoutsNotEnabledSettles": "Auszahlungen sind noch nicht aktiviert. Auszahlung in {currency}.",
      "statusActive": "Bereit für Zahlungen",
      "statusDisabled": "Von Stripe deaktiviert",
      "statusNotStarted": "Nicht verbunden",
      "statusPending": "Einrichtung unvollständig",
      "statusRestricted": "Handlungsbedarf",
      "stripeAccount": "Stripe-Konto",
      "stripeDashboardHint": "Erstattungen, Auszahlungen und Rückbuchungen verwaltest du in deinem eigenen Stripe-Dashboard.",
      "title": "Kartenzahlungen",
      "tryAgain": "Erneut versuchen",
      "unavailable": "Kartenzahlungen sind in dieser Umgebung noch nicht verfügbar."
    },
    "propertyActivityView": {
      "emptyDescription": "Änderungen an Preisen, Reservierungen, Aufgaben und Gästen erscheinen hier, sobald sie passieren.",
      "emptyTitle": "Noch nichts",
      "errorLoad": "Die Aktivität konnte nicht gelesen werden. Zum Aktualisieren nach unten ziehen.",
      "intro": "Wer hier Preise, Reservierungen, Aufgaben und Gäste geändert hat, und wann. Bei Preisänderungen steht dabei, ob deine Kanäle sie übernommen haben.",
      "loading": "Wird geladen…",
      "noPropertyDescription": "Wähle eine Unterkunft, um ihre Aktivität zu sehen.",
      "noPropertyTitle": "Keine Unterkunft ausgewählt",
      "ratesChanged": "Preise oder Regeln für {nights} geändert",
      "ratesChangedSpan": "Preise oder Regeln für {nights} geändert, {span}",
      "title": "Aktivität",
      "unitsFreeUpdated": "Freie Einheiten für {nights} aktualisiert",
      "unitsFreeUpdatedSpan": "Freie Einheiten für {nights} aktualisiert, {span}"
    },
    "propertyBlocksView": {
      "emptyDescription": "Nichts ist aus dem Verkauf genommen. Füge oben eine Sperre hinzu, um Nächte zu sperren.",
      "emptyTitle": "Keine gesperrten Nächte",
      "errorAdd": "Die Sperre konnte nicht hinzugefügt werden. Versuch es noch einmal.",
      "errorRemoveRolledBack": "Die Sperre konnte nicht entfernt werden. Sie ist wieder da.",
      "everyUnitType": "Alle {unitType}",
      "firstNight": "Erste Nacht",
      "fromSource": "· von {source}",
      "intro": "Nimm Nächte ohne Buchung aus dem Verkauf: Eigennutzung, Wartung oder eine manuelle Sperre. Gesperrte Nächte werden weder hier noch auf deinen verbundenen Kanälen verkauft.",
      "lastNight": "Letzte Nacht",
      "noPropertyDescription": "Wähle eine Unterkunft, um ihre gesperrten Nächte zu verwalten.",
      "noPropertyTitle": "Keine Unterkunft ausgewählt",
      "reason": "Grund",
      "removeBlock": "Sperre ab {firstNight} entfernen",
      "submit": "Nächte sperren",
      "targetLabel": "Was gesperrt wird",
      "targetPlaceholder": "Einheit oder Einheitstyp wählen",
      "title": "Gesperrte Nächte",
      "unknownUnit": "Unbekannte Einheit"
    },
    "propertyColorPicker": {
      "customPlaceholder": "#RRGGBB (eigene)",
      "hint": "Farbmarkierung, an der du diese Unterkunft überall in der App erkennst. Leer lassen, um automatisch eine feste Farbe aus der ID der Unterkunft zu wählen.",
      "label": "Farbe",
      "reset": "Automatisch",
      "swatchLabel": "Farbe auf {color} setzen"
    },
    "propertyEmailsView": {
      "bookingConfirmationDescription": "Wird gesendet, wenn ein Gast auf deiner eigenen Website bucht und bezahlt. Buchungen über einen Kanal bestätigt der Kanal, nicht wir.",
      "bookingConfirmationLabel": "Buchungsbestätigung",
      "checkInInviteDescription": "Wird einmal gesendet, wenn eine Buchung eingeht, und bittet den Gast um den Online-Check-in. Schaltest du das aus, kommen auch die Gastdaten für deine Meldungen nicht mehr vor dem Check-in an.",
      "checkInInviteLabel": "Check-in-Einladung",
      "errorNotLoaded": "Deine E-Mail-Einstellungen konnten nicht geladen werden",
      "errorNotSaved": "Speichern fehlgeschlagen. Versuch es noch einmal.",
      "errorPreviewNotLoaded": "Die Vorschau konnte nicht geladen werden",
      "intro": "Diese E-Mails gehen automatisch an deine Gäste, von der eigenen Adresse deiner Unterkunft, damit eine Antwort dich in den Chats erreicht. Tippe bei jeder auf „Vorschau“, um zu lesen, was dein Gast erhält.",
      "paymentsNeeded": "Noch nichts zu senden: Diese E-Mail geht raus, wenn ein Gast auf deiner eigenen Website bezahlt, dafür müssen zuerst <link>Kartenzahlungen</link> eingerichtet sein.",
      "preview": "Vorschau",
      "signInLinkNote": "Gäste können auch einen Anmeldelink für ihren Aufenthalt anfordern. Damit möchte ein Gast zurück in die eigene Buchung, daher wird er immer gesendet. Was du selbst in den Chats schreibst, geht raus, wenn du es sendest.",
      "title": "Gäste-E-Mails"
    },
    "propertyForm": {
      "avatarFallbackName": "Unterkunft",
      "cancel": "Abbrechen",
      "confirmPhrase": "löschen",
      "deleteDescription": "Diese Unterkunft und alle zugehörigen Daten (Einheiten, Reservierungen, Aufgaben) endgültig entfernen. Das lässt sich nicht rückgängig machen.",
      "deleteTitle": "Unterkunft löschen",
      "descriptionHint": "Diese Beschreibung ist für Gäste und Nutzer sichtbar",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Beschreibe diese Unterkunft",
      "errorNotSaved": "Die Unterkunft konnte nicht gespeichert werden. Versuch es noch einmal.",
      "imageCaption": "Tippen, um das Bild der Unterkunft zu ändern",
      "nameLabel": "Name der Unterkunft",
      "namePlaceholder": "Name der Unterkunft eingeben",
      "readOnlyNotice": "Diese Unterkunft hat kein aktives Abo, daher lassen sich ihre Angaben nicht ändern.",
      "save": "Speichern",
      "shortCodeHintAuto": "Wird automatisch aus dem Namen der Unterkunft gebildet. Tippe, um ihn zu überschreiben; leere das Feld, um wieder die Automatik zu nutzen.",
      "shortCodeHintManual": "Wird als kurzes Kürzel in Kalendern und Markierungen verwendet. Leere dieses Feld, um automatisch dem Namen der Unterkunft zu folgen.",
      "shortCodeLabel": "Kürzel",
      "subtitle": "Angaben und Erscheinungsbild der Unterkunft verwalten",
      "title": "Allgemein"
    },
    "propertyIntegrationsView": {
      "communicationSubtitle": "Kanäle für {name}",
      "communicationTitle": "Gästekommunikation",
      "distributionSubtitle": "Wo {name} Buchungen erhält",
      "distributionTitle": "Vertriebskanäle",
      "loading": "Wird geladen…",
      "paymentsSubtitle": "Wie {name} bezahlt wird",
      "paymentsTitle": "Zahlungen"
    },
    "propertyMembersView": {
      "cancelInvitation": "Einladung zurückziehen",
      "codeCopied": "Einladungscode kopiert",
      "copyCode": "Einladungscode kopieren",
      "errorCodeNotCopied": "Kopieren fehlgeschlagen: Markiere den Code und kopiere ihn von Hand.",
      "invite": "Einladen",
      "invitedAs": "Eingeladen als {role}",
      "memberCount": "{count, plural, one {# Mitglied} other {# Mitglieder}}",
      "moreActions": "Weitere Aktionen",
      "noMatches": "Keine Mitglieder entsprechen deiner Suche.",
      "pendingInvitations": "Offene Einladungen",
      "removeConfirm": "{name} aus {property} entfernen?",
      "removeFromProperty": "Aus der Unterkunft entfernen",
      "resend": "Erneut senden",
      "searchPlaceholder": "Mitglieder suchen…",
      "title": "Mitglieder"
    },
    "propertyNotFound": {
      "notFound": "Unterkunft nicht gefunden",
      "syncing": "Unterkunft wird synchronisiert…"
    },
    "propertyPhotosView": {
      "addPhotos": "Fotos hinzufügen",
      "added": "{count, plural, one {Foto hinzugefügt} other {# Fotos hinzugefügt}}",
      "addedSome": "{total, plural, one {{added} von # Foto hinzugefügt.} other {{added} von # Fotos hinzugefügt.}}",
      "addedSomeWithReason": "{total, plural, one {{added} von # Foto hinzugefügt. {reason}} other {{added} von # Fotos hinzugefügt. {reason}}}",
      "descriptionHint": "Wird von Screenreadern vorgelesen und ist der einzige Text, den Suchmaschinen zu diesem Bild erhalten.",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "z. B. Die Terrasse in der Abenddämmerung",
      "emptyDescription": "Füge Fotos der Unterkunft und ihrer Zimmer hinzu. Bis dahin erscheint deine öffentliche Seite nicht in Suchergebnissen.",
      "emptyTitle": "Noch keine Fotos",
      "errorDescriptionNotSaved": "Die Beschreibung konnte nicht gespeichert werden",
      "errorNotAdded": "Das Foto konnte nicht hinzugefügt werden",
      "errorNotMoved": "Das Foto konnte nicht verschoben werden",
      "errorNotRemoved": "Das Foto konnte nicht entfernt werden",
      "errorNotReordered": "Die Fotos konnten nicht neu sortiert werden",
      "intro": "Diese erscheinen auf der öffentlichen Seite deiner Unterkunft. Das erste Foto steht vorn in der Galerie und wird beim Teilen der Seite verwendet.",
      "mainGallery": "Hauptgalerie",
      "moveEarlier": "Nach vorn",
      "moveLater": "Nach hinten",
      "removePhoto": "Foto entfernen",
      "removed": "Foto entfernt",
      "showsOn": "Erscheint bei",
      "title": "Fotos",
      "uploading": "Wird hochgeladen…"
    },
    "propertyRatesView": {
      "addSeason": "Saison hinzufügen",
      "basePerNight": "Grundpreis / Nacht",
      "cancel": "Abbrechen",
      "editSeason": "Saison {name} bearbeiten",
      "editingSeason": "„{name}“ wird bearbeitet",
      "ensureFailedDescription": "Deine Tarife konnten nicht angelegt werden. Prüf deine Verbindung und versuch es noch einmal.",
      "ensureFailedTitle": "Preise konnten nicht eingerichtet werden",
      "errorBaseRateRolledBack": "Der Preis pro Nacht konnte nicht gespeichert werden. Versuch es noch einmal.",
      "errorFloorRolledBack": "Der Mindestpreis konnte nicht gespeichert werden. Versuch es noch einmal.",
      "errorRemoveSeasonRolledBack": "Die Saison konnte nicht entfernt werden. Sie ist wieder da.",
      "errorSaveSeason": "Die Saison konnte nicht gespeichert werden. Versuch es noch einmal.",
      "firstNight": "Erste Nacht",
      "floorHint": "Keine Nacht, keine Saison und kein Grundpreis darf darunter liegen.",
      "floorLabel": "Mindestpreis",
      "floorOwnerOnly": "Nur der Inhaber kann ihn ändern.",
      "intro": "Leg einen Grundpreis pro Einheitstyp fest und bepreise Zeiträume mit Saisons. Änderungen werden mit deinen verbundenen Kanälen synchronisiert.",
      "lastNight": "Letzte Nacht",
      "minStay": "Mindestaufenthalt",
      "minStayPlaceholder": "Beliebig",
      "noFloor": "Kein Mindestpreis festgelegt",
      "noSeasons": "Keine Saisons. Für alle Nächte gilt der Grundpreis oben.",
      "noUnitsDescription": "Füge dieser Unterkunft Einheiten hinzu, bevor du Preise festlegst.",
      "noUnitsTitle": "Noch keine Einheiten",
      "none": "Keine",
      "notSet": "Nicht festgelegt",
      "occupancyReduction": "Pro Gast weniger",
      "occupancyReductionHint": "Wird für jeden Gast unter der Kapazität des Einheitstyps vom Preis pro Nacht abgezogen. Nur bei Direktbuchungen; auf den Kanälen gilt der volle Preis.",
      "openRates": "Preise pro Nacht ansehen und ändern",
      "pricePerNight": "Preis / Nacht",
      "pricePlaceholder": "Grundpreis",
      "priority": "Priorität",
      "removeSeason": "Saison {name} entfernen",
      "saveChanges": "Änderungen speichern",
      "savedFloor": "Gespeichert: {amount}",
      "savedNoFloor": "Gespeichert: kein Mindestpreis",
      "seasonBaseRate": "Grundpreis",
      "seasonDates": "{start} bis {end}",
      "seasonLabel": "Saison",
      "seasonMinStay": "{count, plural, one {· mind. {count} Nacht} other {· mind. {count} Nächte}}",
      "seasonOccupancyReduction": "· −{amount} pro Gast unter Kapazität (direkt)",
      "seasonPlaceholder": "Sommer 2027",
      "seasonPriority": "· Priorität {priority}",
      "seasonShortStaySurcharge": "{count, plural, one {· +{amount} unter {count} Nacht (direkt)} other {· +{amount} unter {count} Nächten (direkt)}}",
      "seasonsHeading": "Saisons",
      "seasonsPriorityHint": "Bei überlappenden Zeiträumen gewinnt die höchste Priorität",
      "settingUp": "Wird eingerichtet…",
      "shortStayPlaceholder": "Nächte",
      "shortStayUnder": "Kurzaufenthalt unter",
      "surcharge": "Zuschlag",
      "surchargeHint": "Wird bei einem Aufenthalt aufgeschlagen, der kürzer ist als die Nächte oben. Nur bei Direktbuchungen: Die Kanaldaten kennen nur einen festen Preis pro Nacht und können ihn nicht abbilden.",
      "title": "Preise",
      "tryAgain": "Erneut versuchen"
    },
    "propertyRegistrationView": {
      "asksBeforeSubmitting": "Deine Zugangsdaten bleiben gespeichert. Vidimo fragt dich, bevor damit etwas übermittelt wird.",
      "checkAgainAfter": "Du kannst nach {time} erneut prüfen.",
      "checkBusy": "Eine Prüfung läuft bereits.",
      "checkFailed": "Die Prüfung konnte nicht ausgeführt werden. Bitte versuch es noch einmal.",
      "checkNow": "Jetzt prüfen",
      "checkRefused": "Diese Zugangsdaten wurden abgelehnt. Aktualisiere sie, um erneut zu prüfen.",
      "checkTooOften": "Zu oft geprüft. Versuch es später noch einmal.",
      "checking": "Wird geprüft…",
      "confirmDisconnect": "Diese Zugangsdaten trennen? Wir entfernen sie aus deinem Konto.",
      "confirmDisconnectChecked": "Diese Zugangsdaten trennen? Wir entfernen sie aus deinem Konto und prüfen sie nicht mehr.",
      "confirmDisconnectFiling": "Diese Zugangsdaten trennen? Wir melden dann nicht mehr an dieses System, bis du sie neu hinterlegst.",
      "confirmDisconnectWaiting": "Diese Zugangsdaten trennen? Wir entfernen sie aus deinem Konto, und die Einrichtung öffnet sich erst wieder, wenn die automatische Übermittlung bereit ist.",
      "connectToCheck": "Verbinden und prüfen",
      "connectToCheckLine": "Verbinde jetzt dein Konto, dann prüft Vidimo, ob es funktioniert. Bei der Prüfung wird nichts gemeldet.",
      "credentialsDisconnected": "Zugangsdaten getrennt",
      "credentialsStay": "Deine Zugangsdaten bleiben gespeichert, und wir beginnen mit der Übermittlung, sobald sie bereit ist.",
      "disconnect": "Trennen",
      "disconnecting": "Wird getrennt…",
      "errorDisconnect": "Trennen fehlgeschlagen. Bitte versuch es noch einmal.",
      "errorLoadCredentials": "Die Zugangsdaten konnten nicht geladen werden. Bitte versuch es noch einmal.",
      "fileEachGuestYourself": "Melde jeden Gast vor Ablauf der Frist selbst.",
      "filesFrom": "Vidimo meldet Gäste, die ab dem {date} anreisen. Frühere Aufenthalte, die Vidimo nicht gemeldet hat, meldest du selbst.",
      "inPreparationConnector": "Vidimo bereitet deine Meldungen an {system} vor. Die automatische Übermittlung ist noch in Entwicklung.",
      "onFileSecret": "{label}: ••••",
      "onFileValue": "{label}: {value}",
      "setUp": "Einrichten",
      "setupOpensLater": "Die Einrichtung der Zugangsdaten öffnet sich hier, sobald das bereit ist.",
      "statusConnected": "Verbunden",
      "statusInPreparation": "In Entwicklung",
      "statusNeedsAttention": "Handlungsbedarf",
      "statusNotConnected": "Nicht verbunden",
      "updateCredentials": "Zugangsdaten aktualisieren"
    },
    "propertySettingsView": {
      "activityDescription": "Wer Preise und Reservierungen geändert hat, und wann",
      "activityTitle": "Aktivität",
      "blockedDatesDescription": "Nächte für Eigennutzung, Wartung oder manuelle Sperren aus dem Verkauf nehmen",
      "blockedDatesTitle": "Gesperrte Nächte",
      "breakfastDescription": "Zeiten, Preis und wo serviert wird",
      "breakfastTitle": "Frühstück",
      "cleaningDescription": "Wer jede Reinigungsaufgabe bekommt und mit welchen Schritten sie angelegt wird",
      "cleaningTitle": "Reinigung",
      "complianceDescription": "Gästemeldung, Statistik, Kurtaxe und Gästeverzeichnis",
      "complianceTitle": "Meldewesen",
      "customDomainDescription": "Deine Places-Website unter deiner eigenen Domain",
      "customDomainTitle": "Eigene Domain",
      "generalDescription": "Name, Adresse, Beschreibung und Details",
      "generalTitle": "Allgemein",
      "groupAccount": "Konto",
      "groupGuests": "Gäste",
      "groupProperty": "Unterkunft",
      "guestEmailsDescription": "Was wir deinen Gästen automatisch mailen, und von welcher Adresse",
      "guestEmailsTitle": "Gäste-E-Mails",
      "guestPortalDescription": "Was Gäste auf ihrer Aufenthaltsseite lesen, mit Vorschau: Zugang, Hausordnung, WLAN",
      "guestPortalTitle": "Gästeportal",
      "guestPreviewDescription": "Die Aufenthaltsseite aus Sicht der Gäste ansehen, von vor der Anreise bis nach dem Check-out",
      "guestPreviewTitle": "Als Gast ansehen",
      "guestRegistryDescription": "Gesetzlicher Nachweis, wer hier übernachtet hat, mit CSV-Export",
      "guestRegistryTitle": "Gästeverzeichnis",
      "importsDescription": "Buchungen, die deine KI-App aus deinem bisherigen System kopiert hat, abgeglichen mit dessen Summen, wo es sie anzeigt",
      "importsTitle": "Importierte Buchungen",
      "membersDescription": "Verwalten, wer Zugriff auf diese Unterkunft hat",
      "membersTitle": "Mitglieder",
      "messagingDescription": "Wo Gäste dich erreichen und welche E-Mails wir für dich senden",
      "messagingTitle": "Nachrichten",
      "notFoundTitle": "Unterkunft",
      "parkingDescription": "Wo Gäste parken, angezeigt vor und während des Aufenthalts",
      "parkingTitle": "Parken",
      "photosDescription": "Fotos auf der öffentlichen Seite deiner Unterkunft",
      "photosTitle": "Fotos",
      "pricingDescription": "Preise pro Nacht, Mindestaufenthalt und geschlossene Nächte deiner Einheiten",
      "pricingTitle": "Preise",
      "roomsDescription": "Einheiten, Preise, gesperrte Nächte und die Kanäle, mit denen sie synchronisiert werden",
      "roomsTitle": "Zimmer & Preise",
      "sectionExtras": "Extras",
      "sectionHousekeeping": "Hauswirtschaft",
      "sectionInventory": "Was du anbietest",
      "sectionMoving": "Wechsel zu Vidimo",
      "sectionPeople": "Personen",
      "sectionPublicPage": "Öffentliche Seite",
      "sectionRecords": "Nachweise",
      "sectionSentAutomatically": "Automatisch gesendet",
      "sectionStayPage": "Aufenthaltsseite",
      "siteDescription": "Deine öffentliche Seite: Inhalte, Fotos und Domain, dazu Kartenzahlungen",
      "siteTitle": "Website",
      "stayDescription": "Was Gäste vor und während ihres Aufenthalts lesen, Parken und Frühstück",
      "stayTitle": "Gästeaufenthalt",
      "teamDescription": "Mitglieder, Reinigungsregeln und Checklisten sowie wer was geändert hat",
      "teamTitle": "Team",
      "title": "Einstellungen",
      "unitsDescription": "Einheiten und Einheitstypen der Unterkunft verwalten",
      "unitsTitle": "Einheiten",
      "websiteDescription": "Geschichte, Highlights, Bewertungen und FAQ für deine öffentliche Seite",
      "websiteTitle": "Seiteninhalte"
    },
    "propertyUnitsView": {
      "clearSearch": "Suche löschen",
      "createUnit": "Einheit anlegen",
      "emptyDescription": "Lege deine erste Einheit an, um loszulegen.",
      "emptyTitle": "Noch keine Einheiten",
      "maxGuests": "{count, plural, one {{count} Gast} other {{count} Gäste}}",
      "noMatchDescription": "Versuch es mit einem anderen Suchbegriff oder lösche die Suche.",
      "noMatchTitle": "Keine Einheiten entsprechen deiner Suche",
      "searchPlaceholder": "Einheiten suchen…",
      "title": "Einheiten"
    },
    "propertyWebsiteView": {
      "activitiesIntroLabel": "Einleitung",
      "activitiesIntroPlaceholder": "Was kann man in der Nähe unternehmen?",
      "activityBlurbPlaceholder": "Auf dem smaragdgrünen Fluss",
      "activityTitlePlaceholder": "Kajakfahren",
      "addActivity": "Aktivität hinzufügen",
      "addDistance": "Entfernung hinzufügen",
      "addHighlight": "Highlight hinzufügen",
      "addQuestion": "Frage hinzufügen",
      "addReview": "Bewertung hinzufügen",
      "defaultsToPropertyName": "Standardmäßig der Name der Unterkunft",
      "enquiryLabel": "WhatsApp-Anfrage-Button anzeigen",
      "errorImageNotUploaded": "Das Bild konnte nicht hochgeladen werden",
      "errorNotLoaded": "Die Inhalte deiner Website konnten nicht geladen werden",
      "errorNotSaved": "Deine Änderungen konnten nicht gespeichert werden",
      "facebookLabel": "Facebook-URL",
      "faqAnswerPlaceholder": "Antwort",
      "faqQuestionPlaceholder": "Frage",
      "headlineLabel": "Eigene Überschrift",
      "highlightIconPlaceholder": "Symbol (z. B. waves)",
      "highlightLabelPlaceholder": "Schwimmbad",
      "highlightSublabelPlaceholder": "Geöffnet von Mai bis November",
      "instagramLabel": "Instagram-Name",
      "instagramPlaceholder": "deinhotel",
      "intro": "Alles hier erscheint auf der öffentlichen Seite deiner Unterkunft. Lass einen Abschnitt leer, um ihn auszublenden.",
      "loadFailed": "Die Inhalte deiner Website konnten nicht geladen werden.",
      "locationIntroLabel": "Einleitung zur Lage",
      "locationIntroPlaceholder": "Was in der Nähe ist, in ein, zwei Sätzen",
      "nearbyLabelPlaceholder": "Marktplatz",
      "nearbyValuePlaceholder": "2 Min. zu Fuß",
      "off": "Aus",
      "on": "An",
      "remove": "Entfernen",
      "removeImage": "Bild entfernen",
      "replacePhoto": "Foto ersetzen",
      "reviewAuthorPlaceholder": "Name",
      "reviewLocationPlaceholder": "Ort (optional)",
      "reviewQuotePlaceholder": "Was der Gast gesagt hat",
      "reviewRatingPlaceholder": "Bewertung 1–5",
      "reviewSourcePlaceholder": "TripAdvisor (optional)",
      "saveChanges": "Änderungen speichern",
      "saved": "Website aktualisiert",
      "sectionEnquiries": "Anfragen",
      "sectionFaqs": "FAQ",
      "sectionHero": "Titelbereich",
      "sectionHighlights": "Highlights",
      "sectionLocation": "Lage",
      "sectionReviews": "Bewertungen",
      "sectionSearch": "Suche (SEO)",
      "sectionSocial": "Social Media",
      "sectionStory": "Geschichte",
      "sectionThingsToDo": "Unternehmungen",
      "seoDescriptionLabel": "Meta-Beschreibung",
      "seoDescriptionPlaceholder": "Ein oder zwei Sätze für die Suchergebnisse",
      "seoTitleLabel": "Eigener Seitentitel",
      "storyImageLabel": "Bild zur Geschichte",
      "storyLabel": "Deine Geschichte",
      "storyPlaceholder": "Wie dieser Ort entstanden ist…",
      "taglineLabel": "Slogan",
      "taglinePlaceholder": "Eine kurze Zeile, die Lust auf den Aufenthalt macht",
      "tiktokLabel": "TikTok-URL",
      "title": "Seiteninhalte",
      "tryAgain": "Erneut versuchen",
      "uploadPhoto": "Foto hochladen",
      "viewPublicPage": "Öffentliche Seite ansehen"
    },
    "registrationCards": {
      "comingBody": "Vidimo schaltet Gästemeldung und Kurtaxe Land für Land frei. Bis das Land deiner Unterkunft dabei ist, erledigst du beides weiterhin wie bisher. Sag uns, dass {name} dabei sein soll, und wir melden uns, sobald es so weit ist.",
      "comingTitle": "Weitere Länder folgen",
      "filesGuests": "Gästemeldung",
      "filesStatistics": "Statistik",
      "filesTouristTax": "Kurtaxe",
      "pickMunicipality": "Wähle deine Gemeinde aus, um Integrationen einzurichten.",
      "registrationSubtitle": "Gäste von {name} bei den Behörden melden",
      "registrationTitle": "Gästemeldung",
      "statisticsNotCovered": "Vidimo meldet die Tourismusstatistik für die Region deiner Gemeinde noch nicht, sende sie also weiterhin selbst an das zuständige Amt deiner Region.",
      "statisticsSubtitle": "Meldungen zur Tourismusstatistik für {name}",
      "statisticsTitle": "Statistik",
      "statusConnected": "Verbunden",
      "statusInPreparation": "In Entwicklung",
      "statusNeedsAttention": "Handlungsbedarf",
      "statusNotConnected": "Nicht verbunden"
    },
    "registrationCredentialForm": {
      "beforeYouStart": "Bevor du loslegst",
      "checkNotice": "Beim Speichern meldet sich Vidimo bei {system} an und prüft einen Testdatensatz. Bei der Prüfung wird nichts gemeldet.",
      "checkNoticeAsks": "Beim Speichern meldet sich Vidimo bei {system} an und prüft einen Testdatensatz. Bei der Prüfung wird nichts gemeldet, und Vidimo fragt dich, bevor ein Gast übermittelt wird.",
      "chooseFile": "Datei auswählen",
      "connect": "Verbinden",
      "errorInvalid": "Speichern fehlgeschlagen. Prüf deine Eingaben und versuch es noch einmal.",
      "errorPlaceChanged": "Speichern fehlgeschlagen: {system} ist am jetzigen Standort deiner Unterkunft nicht verfügbar. Prüf ihre Gemeinde.",
      "errorReadFile": "Diese Datei konnte nicht gelesen werden.",
      "errorSave": "Die Zugangsdaten konnten nicht gespeichert werden. Bitte versuch es noch einmal.",
      "fileOnFile": "gespeichert",
      "fileOnFileNamed": "{name} gespeichert",
      "noFileSelected": "Keine Datei ausgewählt",
      "openAuthority": "{authority} öffnen",
      "replaceFile": "Datei ersetzen",
      "saved": "Zugangsdaten gespeichert",
      "savedAlreadyRefused": "Gespeichert. {system} hat sie bereits abgelehnt, daher wurden sie nicht erneut geprüft",
      "savedNoAnswer": "Gespeichert. {system} hat auf die Prüfung nicht geantwortet",
      "savedNotChecked": "Gespeichert. Noch nicht geprüft",
      "savedRefused": "Gespeichert, aber {system} hat sie abgelehnt",
      "savedRefusedAccount": "Gespeichert, aber {system} hat die Prüfung für dieses Konto abgelehnt",
      "savedUnreadable": "Gespeichert, aber Vidimo konnte sie nicht lesen",
      "savedWorks": "Gespeichert. Dein Konto funktioniert",
      "secretOnFilePlaceholder": "•••••••• gespeichert. Leer lassen, um es zu behalten.",
      "update": "Aktualisieren"
    },
    "integrationPage": {
      "changeMunicipality": "Gemeinde unter „Meldewesen“ ändern",
      "deadline": "Frist",
      "deadlineFromArrival": "{hours, plural, one {{hours} Std. ab Ankunft} other {{hours} Std. ab Ankunft}}",
      "deadlineFromArrivalWithDeparture": "{hours, plural, one {{hours} Std. ab Ankunft; Abreise wird ebenfalls gemeldet} other {{hours} Std. ab Ankunft; Abreise wird ebenfalls gemeldet}}",
      "deadlineShortStay": "{hours, plural, one {{hours} Std.} other {{hours} Std.}}, wenn der Aufenthalt {maxStayHours, plural, one {{maxStayHours} Std.} other {{maxStayHours} Std.}} oder kürzer dauert",
      "disconnectAccount": "Du kannst das zuvor eingerichtete Konto trennen.",
      "lawRequires": "Was das Gesetz verlangt",
      "loginTitle": "Zugangsdaten für {system}",
      "municipality": "Gemeinde",
      "noMunicipality": "Wähle die Gemeinde deiner Unterkunft aus, damit Vidimo weiß, dass {system} dort gilt.",
      "notFound": "Integration nicht gefunden",
      "notOffered": "{system} ist im Land deiner Unterkunft nicht verfügbar. Prüf die Adresse der Unterkunft.",
      "notPicked": "Noch nicht ausgewählt",
      "pickMunicipality": "Gemeinde unter „Meldewesen“ auswählen",
      "propertyTitle": "Diese Unterkunft bei {system}",
      "regionMoved": "Diese Zugangsdaten gelten für {onFile}, deine Gemeinde gehört aber zu {current}. Aktualisiere sie mit deinen Zugangsdaten für {current}.",
      "regionNotCovered": "Vidimo meldet für die Region deiner Gemeinde noch keine Statistik.",
      "reportsTo": "Zuständige Region",
      "requiredFields": "Pflichtangaben für jeden gemeldeten Gast",
      "scopeAllGuests": "Alle Gäste",
      "scopeForeignGuestsOnly": "Nur ausländische Gäste",
      "setBy": "Festgelegt durch <bases></bases>",
      "who": "Wer"
    },
    "roleSelect": {
      "changeRoleFrom": "Rolle ändern (bisher {role})",
      "title": "Rolle ändern"
    },
    "searchSortBar": {
      "sortAscending": "A–Z sortieren (klicken für Z–A)",
      "sortDescending": "Z–A sortieren (klicken für A–Z)"
    },
    "settingsRowStates": {
      "breakfastOff": "Aus",
      "breakfastOn": "An",
      "members": "{count, plural, one {# Person} other {# Personen}}",
      "parking": "{count, plural, =0 {Noch keine} one {# Stellplatz} other {# Stellplätze}}",
      "photos": "{count, plural, =0 {Noch keine} one {# Foto} other {# Fotos}}",
      "units": "{count, plural, =0 {Noch keine} one {# Einheit} other {# Einheiten}}"
    },
    "signInMethods": {
      "apple": "Apple",
      "credential": "E-Mail & Passwort",
      "google": "Google"
    },
    "signInSecuritySection": {
      "changePassword": "Passwort ändern",
      "connect": "Verbinden",
      "description": "Die Wege, wie du dieses Konto öffnen kannst. Füge einen zweiten hinzu, damit du nie ausgesperrt bist, wenn ein Anbieter nicht erreichbar ist.",
      "errorLoad": "Deine Anmeldemethoden konnten nicht geladen werden. Prüf deine Verbindung und versuch es noch einmal.",
      "errorOffline": "Du bist offline, daher können deine Anmeldemethoden gerade nicht geladen werden.",
      "errorPasswordNotChanged": "Dein Passwort konnte nicht geändert werden. Versuch es noch einmal.",
      "errorSessionNotFresh": "Melde dich zu deiner Sicherheit ab und wieder an, bevor du eine Anmeldemethode entfernst.",
      "errorUnlinkFailed": "Diese Anmeldemethode konnte nicht entfernt werden.",
      "errorWrongCurrentPassword": "Das ist nicht dein aktuelles Passwort. Versuch es noch einmal.",
      "loading": "Deine Anmeldemethoden werden geladen…",
      "remove": "Entfernen",
      "retry": "Erneut versuchen",
      "setPassword": "Passwort festlegen",
      "statusConnected": "Verbunden",
      "statusNoPassword": "Kein Passwort festgelegt",
      "statusNotConnected": "Nicht verbunden",
      "statusOnlyMethod": "Deine einzige Anmeldemethode",
      "statusPasswordSet": "Passwort festgelegt",
      "title": "Anmeldung & Sicherheit"
    },
    "staffAvailabilityForm": {
      "addTimeOff": "Abwesenheit hinzufügen",
      "addWindow": "Zeitfenster hinzufügen",
      "dayLabel": "Tag",
      "endLabel": "Ende <optional>(optional)</optional>",
      "errorTimeOffNotAdded": "Die Abwesenheit konnte nicht hinzugefügt werden. Versuch es noch einmal.",
      "errorTimeOffNotRemoved": "Die Abwesenheit konnte nicht entfernt werden. Sie ist wieder da.",
      "errorWindowNotAdded": "Die Zeiten konnten nicht hinzugefügt werden. Versuch es noch einmal.",
      "errorWindowNotRemoved": "Die Zeiten konnten nicht entfernt werden. Sie sind wieder da.",
      "fromLabel": "Von",
      "noTimeOff": "Keine Abwesenheit eingetragen.",
      "noWindows": "Noch keine Zeitfenster: {name} erscheint überall als nicht verfügbar.",
      "noteLabel": "Notiz",
      "notePlaceholder": "Optional (z. B. Zahnarzt)",
      "removeTimeOff": "Abwesenheit entfernen",
      "removeWindow": "Zeitfenster entfernen",
      "startLabel": "Beginn",
      "timeOffTitle": "Abwesenheit",
      "title": "Verfügbarkeit",
      "toLabel": "Bis",
      "viewOnly": "Nur Ansicht: Die Verfügbarkeit legen Inhaber oder Manager fest.",
      "weeklyDescription": "{name} ist in diesen Zeitfenstern verfügbar. Außerhalb davon kannst du für Einzelfälle trotzdem manuell zuweisen.",
      "weeklyTitle": "Wöchentliche Verfügbarkeit",
      "windowRange": "{day} {start}–{end}"
    },
    "staffTaskFunctionsForm": {
      "description": "Eine Reinigungsregel, die eine dieser Fähigkeiten verlangt, wählt nur jemanden, der sie hat. Von Hand kannst du trotzdem jede Person zuweisen.",
      "errorNotSaved": "Diese Änderung konnte nicht gespeichert werden. Versuch es noch einmal.",
      "title": "Was diese Person übernimmt"
    },
    "statisticsFilingsHistory": {
      "description": "Übernachtungsmeldungen an dein regionales Amt für Tourismusstatistik.",
      "errorRetry": "Die Meldung konnte nicht erneut versucht werden. Versuch es noch einmal.",
      "reference": "Referenz: {reference}",
      "retry": "Erneut versuchen",
      "retryFailedAgain": "Die Meldung ist erneut fehlgeschlagen.",
      "retryFiled": "Statistikmeldung übermittelt.",
      "retryNotWaiting": "Diese Meldung wartet nicht mehr auf dich.",
      "statusActionNeeded": "Handlungsbedarf",
      "statusCanceled": "Storniert",
      "statusFiled": "Gemeldet",
      "statusFiling": "Wird gemeldet…",
      "statusRetrying": "Neuer Versuch",
      "statusScheduled": "Geplant",
      "statusSubmitted": "Übermittelt",
      "title": "Statistikmeldungen"
    },
    "stayTimesSection": {
      "checkIn": "Check-in ab",
      "checkOut": "Check-out bis"
    },
    "taskCalendarFeedSection": {
      "cancel": "Abbrechen",
      "copyLink": "Link kopieren",
      "create": "Kalenderlink erstellen",
      "createPending": "Link wird erstellt…",
      "description": "Verfolge deine zugewiesenen Aufgaben in Google Kalender, Apple Kalender oder Outlook.",
      "errorCopy": "Der Link konnte nicht kopiert werden",
      "errorCreate": "Dein Kalenderlink konnte nicht erstellt werden. Versuch es noch einmal.",
      "errorLoad": "Dein Kalenderlink konnte nicht geladen werden. Prüf deine Verbindung und versuch es noch einmal.",
      "errorOffline": "Du bist offline, daher kann dein Kalenderlink gerade nicht geladen werden.",
      "errorRegenerate": "Es konnte kein neuer Link erstellt werden. Versuch es noch einmal.",
      "errorTurnOff": "Dein Link konnte nicht deaktiviert werden. Versuch es noch einmal.",
      "linkCopied": "Kalenderlink kopiert",
      "linkLabel": "Kalenderlink",
      "loading": "Dein Kalenderlink wird geladen…",
      "newLink": "Neuer Link",
      "offlineActionsNote": "Du bist offline. Kopieren geht weiterhin; für einen neuen Link oder das Deaktivieren brauchst du eine Verbindung.",
      "offlineCreateNote": "Du bist offline. Zum Erstellen eines Links brauchst du eine Verbindung.",
      "privacyNote": "Jeder mit diesem Link kann deine Aufgaben sehen. Wenn er in falsche Hände gerät, erstelle einen neuen.",
      "regenerateConfirm": "Neuen Link erstellen",
      "regenerateDescription": "Dein aktueller Link funktioniert sofort nicht mehr, und Kalender, die ihn nutzen, werden nicht mehr aktualisiert, bis du den neuen hinzufügst.",
      "regeneratePending": "Link wird erstellt…",
      "regenerateTitle": "Neuen Link erstellen?",
      "retry": "Erneut versuchen",
      "subscribeHelp": "Füge ihn in deiner Kalender-App als Kalender per URL hinzu. Kalender-Apps prüfen nach eigenem Zeitplan auf Änderungen, das kann ein paar Stunden dauern.",
      "title": "Aufgabenkalender",
      "turnOff": "Deaktivieren",
      "turnOffConfirm": "Deaktivieren",
      "turnOffDescription": "Dein Link funktioniert sofort nicht mehr, und Kalender, die ihn nutzen, werden nicht mehr aktualisiert. Du kannst hier jederzeit einen neuen Link erstellen.",
      "turnOffPending": "Wird deaktiviert…",
      "turnOffTitle": "Kalenderlink deaktivieren?"
    },
    "taskRulesPage": {
      "anyone": "Beliebige Person",
      "assignTo": "Zuweisen an",
      "defaultOperator": "Mitarbeiter vor Ort (Standard)",
      "defaultReceptionist": "Rezeption (Standard)",
      "errorSave": "Diese Regel konnte nicht gespeichert werden. Versuch es noch einmal.",
      "fallbackOperator": "In dieser Unterkunft hat kein Mitarbeiter vor Ort Arbeitszeiten, daher gehen diese Aufgaben an einen Inhaber oder Manager, der zu dieser Zeit arbeitet. Arbeitet keiner von ihnen, bleiben sie unzugewiesen. Damit sie stattdessen an Mitarbeiter vor Ort gehen, lege unter „Mitglieder“ Arbeitszeiten für einen Mitarbeiter vor Ort fest.",
      "fallbackReceptionist": "In dieser Unterkunft hat niemand an der Rezeption Arbeitszeiten, daher gehen diese Aufgaben an einen Inhaber oder Manager, der zu dieser Zeit arbeitet. Arbeitet keiner von ihnen, bleiben sie unzugewiesen. Damit sie stattdessen an die Rezeption gehen, lege unter „Mitglieder“ Arbeitszeiten für jemanden an der Rezeption fest.",
      "formerMember": "Jemand, der diese Unterkunft verlassen hat",
      "functionHint": "Die Fähigkeiten jeder Person legst du unter „Mitglieder“ fest.",
      "functionLabel": "Muss übernehmen können",
      "hintAny": "Alle anderen Reinigungsaufgaben, auch von Hand erstellte.",
      "hintDefaultOperator": "Die Aufgabe geht an Mitarbeiter vor Ort, die zu dieser Zeit arbeiten, und zwar an die Person mit den wenigsten Aufgaben an diesem Tag. Arbeitet dann niemand vor Ort, geht die Aufgabe an einen Inhaber oder Manager, der dann arbeitet. Arbeitet niemand, bleibt sie unzugewiesen.",
      "hintDefaultReceptionist": "Die Aufgabe geht an die Rezeption, und zwar an die Person, die zu dieser Zeit arbeitet und an diesem Tag die wenigsten Aufgaben hat. Arbeitet dann niemand an der Rezeption, geht die Aufgabe an einen Inhaber oder Manager, der dann arbeitet. Arbeitet niemand, bleibt sie unzugewiesen.",
      "hintFollowsAny": "Folgt der Regel für alle anderen Reinigungsaufgaben, siehe unten.",
      "loading": "Zuständigkeiten für die Reinigung werden geladen…",
      "noOperator": "Für Mitarbeiter vor Ort, Inhaber und Manager sind hier keine Arbeitszeiten festgelegt, daher bleiben diese Aufgaben unzugewiesen. Lege Arbeitszeiten unter „Mitglieder“ fest.",
      "noReceptionist": "Für die Rezeption, Inhaber und Manager sind hier keine Arbeitszeiten festgelegt, daher bleiben diese Aufgaben unzugewiesen. Lege Arbeitszeiten unter „Mitglieder“ fest.",
      "noRuleFollowsAny": "Wie alle anderen Reinigungsaufgaben",
      "noRuleKindDefaults": "Standard je Aufgabenart",
      "nobodyYet": "Noch niemand",
      "person": "Person",
      "personHasLeft": "Diese Person hat die Unterkunft verlassen, daher weist diese Regel niemanden zu. Wähle jemand anderen.",
      "personHint": "Die Person bekommt die Aufgabe auch, wenn sie abwesend ist; die Warnung siehst du dann direkt bei der Aufgabe.",
      "summaryOperator": "Ein Mitarbeiter vor Ort",
      "summaryOwnerOrManager": "Ein Inhaber oder Manager",
      "summaryReceptionist": "Jemand an der Rezeption",
      "summaryUnassigned": "Nicht zugewiesen",
      "unavailableDescription": "Vidimo kann die Regeln auf diesem Gerät nicht laden. Versuch es noch einmal; die App wird dabei neu geladen.",
      "unavailableTitle": "Aufgabenregeln lassen sich gerade nicht ändern"
    },
    "taxReturns": {
      "badgeMore": "Nachzahlung",
      "badgeOpen": "Zu zahlen",
      "badgePaid": "Bezahlt",
      "badgeRunning": "Dieser Monat",
      "description": "Die Kurtaxe für jeden Monat, einschließlich der Tourismusförderabgabe (promocijska taksa), berechnet aus den Aufenthalten, deren letzte Nacht in den jeweiligen Monat fällt. Führe sie fristgerecht an die Gemeinde ab und markiere sie dann hier als bezahlt. Kurtaxe, die ein Gast dir schon vor dem jeweiligen Monat gezahlt hat, ist im Monat nach seiner Zahlung fällig.",
      "errorMarkPaid": "Die Kurtaxe dieses Monats konnte nicht als bezahlt markiert werden. Versuch es noch einmal.",
      "markPaid": "Als bezahlt markieren",
      "markedPaid": "Als bezahlt markiert.",
      "overpaid": "Du hast {amount} mehr gezahlt, als für diese Aufenthalte jetzt fällig ist.",
      "stays": "{count, plural, one {# Aufenthalt} other {# Aufenthalte}}",
      "summaryMore": "{amount} bis {date} nachzuzahlen",
      "summaryOpen": "{amount} bis {date} zu zahlen",
      "summaryPaid": "{amount} bezahlt",
      "summaryRunning": "Bisher {amount}, fällig am {date}",
      "title": "Kurtaxe-Zahlungen",
      "uncomputed": "{count, plural, one {Für # Aufenthalt ist die Kurtaxe noch nicht berechnet und daher nicht im Betrag enthalten.} other {Für # Aufenthalte ist die Kurtaxe noch nicht berechnet und daher nicht im Betrag enthalten.}}"
    },
    "taxRules": {
      "ageFrom": "ab {age} Jahren",
      "ageRange": "von {from} bis {to} Jahren",
      "ageUnder": "unter {age} Jahren",
      "chargesNothing": "Hier wird keine Kurtaxe erhoben",
      "checked": "Geprüft am {date}",
      "from": "Ab {date}: {rule}",
      "maxNights": "{count, plural, one {höchstens # Nacht pro Aufenthalt} other {höchstens # Nächte pro Aufenthalt}}",
      "paysFree": "{ages} befreit",
      "paysHalf": "{ages} zum halben Satz",
      "paysPercent": "{ages} zu {percent} des Satzes",
      "perPersonNight": "{amounts} pro Person und Nacht",
      "rateCategory": "{category}: {rate}",
      "ratePercent": "{percent} des Preises, höchstens {cap}",
      "awaitsFacility": "Die Kurtaxe hängt hier davon ab, wo in der Gemeinde deine Unterkunft liegt, welcher Art sie ist oder wer sie betreibt. Vidimo schlägt das im Register nach, und zwar anhand der {field}, die du in den Einstellungen für {system} angibst. Die Kurtaxe erscheint, sobald Vidimo deine Unterkunft dort findet.",
      "errorLoad": "Die Kurtaxe konnte nicht geladen werden. Versuch es noch einmal.",
      "notCovered": "Vidimo kennt die Kurtaxe am Standort dieser Unterkunft noch nicht, daher zeigen ihre Buchungen vorerst keine Kurtaxe an.",
      "source": "Quelle",
      "withSurcharge": "{rate} + {surcharge} {label}",
      "zone": "Satz für {zone}"
    },
    "timezoneField": {
      "hint": "Für Check-in-/Check-out-Zeiten und die Planung",
      "label": "Zeitzone"
    },
    "unitForm": {
      "amenitiesLabel": "Ausstattung",
      "amenitiesPlaceholder": "Ausstattung auswählen",
      "babyCots": "Babybetten",
      "cancel": "Abbrechen",
      "codeHintAuto": "{count, plural, one {Wird automatisch aus dem Namen der Einheit gebildet. Tippe, um es zu überschreiben; leere das Feld, um wieder die Automatik zu nutzen. Max. # Zeichen.} other {Wird automatisch aus dem Namen der Einheit gebildet. Tippe, um es zu überschreiben; leere das Feld, um wieder die Automatik zu nutzen. Max. # Zeichen.}}",
      "codeHintManual": "{count, plural, one {Kurzes Kürzel für Kalender und Aufgabenlisten, z. B. 101, APH-SV. Leere dieses Feld, um automatisch dem Namen der Einheit zu folgen. Max. # Zeichen.} other {Kurzes Kürzel für Kalender und Aufgabenlisten, z. B. 101, APH-SV. Leere dieses Feld, um automatisch dem Namen der Einheit zu folgen. Max. # Zeichen.}}",
      "codeLabel": "Kürzel",
      "codePlaceholder": "z. B. 101 oder APH",
      "cotsAndExtraBeds": "Babybetten und Zustellbetten",
      "createSubtitle": "Füge dieser Unterkunft eine neue buchbare Einheit hinzu",
      "createTitle": "Einheit anlegen",
      "deleteDescription": "Diese Einheit endgültig entfernen. Mit ihr verknüpfte Buchungen müssen womöglich angepasst werden. Das lässt sich nicht rückgängig machen.",
      "deleteLabel": "Einheit löschen",
      "descriptionHint": "Erscheint auf der öffentlichen Seite des Zimmers und hilft, in Suchergebnissen gefunden zu werden.",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Beschreibe dieses Zimmer: die Aussicht, das Licht, was es besonders macht. Wird auf deiner öffentlichen Zimmerseite angezeigt.",
      "duplicate": "Einheit duplizieren",
      "editSubtitle": "Angaben zur Einheit verwalten",
      "editTitle": "Einheit bearbeiten",
      "errorDelete": "Die Einheit konnte nicht gelöscht werden. Versuch es noch einmal.",
      "errorDuplicate": "Die Einheit konnte nicht dupliziert werden. Versuch es noch einmal.",
      "errorSave": "Die Einheit konnte nicht gespeichert werden. Versuch es noch einmal.",
      "extraBeds": "Zustellbetten",
      "maxAdults": "Max. Erwachsene",
      "maxChildren": "Max. Kinder",
      "maxChildrenPayable": "Kinder (zahlungspflichtig)",
      "maxGuests": "Max. Gäste",
      "nameLabel": "Name",
      "namePlaceholder": "z. B. Zimmer 101 oder Apartment A",
      "occupancy": "Belegung",
      "save": "Speichern",
      "sizeLabel": "Größe",
      "sizePlaceholder": "z. B. 25",
      "sizeUnitLabel": "Maßeinheit",
      "smokingAllowed": "Rauchen erlaubt",
      "smokingLabel": "Rauchen",
      "smokingNonSmoking": "Nichtraucher",
      "smokingPlaceholder": "Regel auswählen",
      "smokingUnknown": "Unbekannt",
      "unitTypeLabel": "Einheitstyp",
      "unitTypePlaceholder": "Einheitstyp auswählen"
    },
    "unitsEdit": {
      "notFound": "Einheit nicht gefunden"
    },
    "unlinkMethodDialog": {
      "cancel": "Abbrechen",
      "confirm": "Entfernen",
      "confirmPending": "Wird entfernt…",
      "description": "Du kannst dich dann nicht mehr mit {method} anmelden. Deine anderen Anmeldemethoden funktionieren weiter, und du kannst es auf diesem Bildschirm jederzeit neu verbinden.",
      "title": "{method} entfernen?"
    },
    "wifiSection": {
      "hidePassword": "WLAN-Passwort verbergen",
      "hint": "Wird Gästen ab dem Anreisetag angezeigt, sobald Netzwerkname und Passwort festgelegt sind. Das Passwort steht nie in KI-Entwürfen.",
      "label": "WLAN",
      "passwordLabel": "WLAN-Passwort",
      "passwordPlaceholder": "Passwort",
      "revealPassword": "WLAN-Passwort anzeigen",
      "ssidLabel": "WLAN-Name",
      "ssidPlaceholder": "Netzwerkname"
    }
  },

  "setup": {
    "setupBookingsStep": {
      "continue": "Weiter",
      "description": "Deine KI-App kann sie in Vidimo übernehmen, damit du nicht zwei Kalender parallel führen musst.",
      "fresh": "Nein, ich fange neu an",
      "import": "Ja, ich möchte sie übernehmen",
      "imported": "Buchungen aus {source} importiert.",
      "openImports": "Importierte Buchungen öffnen",
      "results": "Du kannst das auch später am Computer erledigen. Den Prompt und deine Importe findest du jederzeit in den Einstellungen.",
      "skip": "Vorerst überspringen",
      "title": "Nutzt du für deine Buchungen bereits ein anderes System?"
    },
    "setupEmptyState": {
      "calendarDescription": "Richte deine Unterkunft und Einheiten fertig ein, dann siehst du hier deine Reservierungen im Kalender.",
      "calendarTitle": "Hier erscheint dein Buchungskalender",
      "chatsDescription": "Richte deine Unterkunft fertig ein, dann kommen hier Gästenachrichten, Buchungen und KI-Antworten an.",
      "chatsTitle": "Hier landen deine Gästeunterhaltungen",
      "setUp": "Unterkunft einrichten",
      "skip": "Vorerst überspringen",
      "tasksDescription": "Richte deine Unterkunft fertig ein, um deinem Team Reinigungen, Check-ins und Wartung zuzuweisen.",
      "tasksTitle": "Hier erscheinen die Aufgaben deines Teams",
      "todayDescription": "Richte deine Unterkunft fertig ein, dann landen hier jeden Tag Anreisen, Abreisen und Gäste im Haus.",
      "todayTitle": "Hier beginnt dein Tag"
    },
    "setupEssentialsStep": {
      "addressHint": "Suche die Adresse und wähle sie aus, um den Standort festzulegen und das Land einzutragen.",
      "addressLabel": "Adresse",
      "addressPlaceholder": "Adresse der Unterkunft suchen…",
      "continue": "Speichern & weiter",
      "description": "Die Grundlagen, auf die sich Gäste und dein Team verlassen. Alles lässt sich später in den Einstellungen verfeinern.",
      "errorNotSaved": "Die Angaben zur Unterkunft konnten nicht gespeichert werden. Versuch es noch einmal.",
      "nameLabel": "Name der Unterkunft *",
      "namePlaceholder": "Name der Unterkunft eingeben",
      "timezoneConfirm": "Bestätigen",
      "timezoneDetected": "Von diesem Gerät erkannt: wird erst gespeichert, wenn du sie bestätigst oder eine Adresse wählst.",
      "timezoneHint": "Für Check-in-/Check-out-Zeiten und die Planung.",
      "timezoneLabel": "Zeitzone",
      "timezonePlaceholder": "Zeitzone auswählen",
      "title": "Grunddaten der Unterkunft"
    },
    "setupStepLayout": {
      "back": "Zurück",
      "saving": "Wird gespeichert…",
      "skip": "Überspringen"
    },
    "setupSummaryStep": {
      "addressLabel": "Adresse",
      "bookingsImported": "Aus {source} importiert",
      "bookingsLabel": "Buchungen",
      "bookingsNone": "Nichts zu übernehmen",
      "bookingsNotYet": "Noch nicht übernommen",
      "descriptionComplete": "Alles bereit. Deine Unterkunft kann loslegen.",
      "descriptionIncomplete": "Du kannst jetzt abschließen und die restlichen Grunddaten jederzeit in den Einstellungen ergänzen.",
      "finish": "Einrichtung abschließen",
      "finishAnyway": "Trotzdem abschließen",
      "invitesNone": "Noch keine Einladungen (optional)",
      "invitesPending": "{count, plural, one {{count} Einladung ausstehend} other {{count} Einladungen ausstehend}}",
      "nameLabel": "Name der Unterkunft",
      "notSet": "Noch nicht festgelegt",
      "teamLabel": "Team",
      "timezoneLabel": "Zeitzone",
      "title": "Überblick",
      "unitsAdded": "{count, plural, one {{count} Einheit hinzugefügt} other {{count} Einheiten hinzugefügt}}",
      "unitsLabel": "Einheiten",
      "unitsNone": "Füge mindestens eine Einheit hinzu"
    },
    "setupTeamStep": {
      "continue": "Weiter",
      "description": "Lade jemanden aus deinem Team ein, der dir hilft. Das geht auch später, es ist optional.",
      "emailHint": "Wir schicken per E-Mail einen Link zum Beitreten und einen Einladungscode für die App.",
      "emailLabel": "E-Mail-Adresse",
      "emailPlaceholder": "name@beispiel.de",
      "errorNotSent": "Die Einladung konnte nicht gesendet werden.",
      "invitationPending": "{role} · Einladung ausstehend",
      "invitationSent": "Einladung gesendet",
      "noPermission": "Du darfst in dieser Unterkunft keine Mitglieder einladen.",
      "roleLabel": "Rolle",
      "rolePlaceholder": "Rolle auswählen",
      "send": "Einladung senden",
      "sending": "Wird gesendet…",
      "skip": "Vorerst überspringen",
      "title": "Team einladen"
    },
    "setupUnitsStep": {
      "add": "Einheit hinzufügen",
      "adding": "Wird hinzugefügt…",
      "continue": "Weiter",
      "description": "Füge die Zimmer oder Apartments hinzu, die Gäste buchen können. Mindestens eine ist nötig; weitere jederzeit in den Einstellungen.",
      "errorNotAdded": "Die Einheit konnte nicht hinzugefügt werden. Versuch es noch einmal.",
      "errorNotRemoved": "Die Einheit konnte nicht entfernt werden. Versuch es noch einmal.",
      "maxGuestsLabel": "Max. Gäste",
      "nameLabel": "Name der Einheit",
      "namePlaceholder": "z. B. Zimmer 101 oder Apartment A",
      "remove": "{name} entfernen",
      "skip": "Vorerst überspringen",
      "title": "Einheiten",
      "typeLabel": "Typ",
      "typePlaceholder": "Typ auswählen",
      "typeSleeps": "{count, plural, one {{type} · {count} Schlafplatz} other {{type} · {count} Schlafplätze}}",
      "unitFallback": "Einheit"
    },
    "setupWizard": {
      "skipSetup": "Einrichtung überspringen",
      "stepBookings": "Buchungen",
      "stepEssentials": "Grunddaten",
      "stepReview": "Überblick",
      "stepTeam": "Team",
      "stepUnits": "Einheiten",
      "subtitle": "Mach deine Unterkunft startklar",
      "titleNamed": "{name} einrichten",
      "titleUnnamed": "Unterkunft einrichten"
    }
  },

  "shell": {
    "appHeader": {
      "search": "Suche"
    },
    "appNavRail": {
      "label": "Hauptnavigation"
    },
    "auditFormatting": {
      "fieldLabel": {
        "assignedTo": "Zuständig",
        "description": "Beschreibung",
        "endAt": "Check-out",
        "expectedArrivalTime": "Ankunftszeit",
        "linkedGuest": "Gastverknüpfung",
        "mergedDuplicate": "Zusammenführung",
        "startAt": "Check-in",
        "status": "Status",
        "taxNote": "Steuerhinweis",
        "title": "Titel",
        "type": "Typ",
        "unitId": "Einheit"
      },
      "fromTo": "{from} → {to}",
      "none": "keine",
      "withheldChange": "{kind, select, added {hinzugefügt} removed {entfernt} other {geändert}}",
      "withheldField": "{field} {kind, select, added {hinzugefügt} removed {entfernt} other {geändert}}"
    },
    "auditTimeline": {
      "bySupport": "Vidimo-Support im Namen von {actor}",
      "changeTo": "→",
      "headline": {
        "guestCreate": "Gast hinzugefügt: {summary}",
        "guestDelete": "Gast entfernt: {summary}",
        "guestUpdate": "Gast geändert: {summary}",
        "rateCreate": "Preise hinzugefügt: {summary}",
        "rateDelete": "Preise entfernt: {summary}",
        "rateUpdate": "Preise geändert: {summary}",
        "reservationCreate": "Reservierung hinzugefügt: {summary}",
        "reservationDelete": "Reservierung entfernt: {summary}",
        "reservationUpdate": "Reservierung geändert: {summary}",
        "taskCreate": "Aufgabe hinzugefügt: {summary}",
        "taskDelete": "Aufgabe entfernt: {summary}",
        "taskMissTakenBack": "Wieder offen: Der Gast ist doch noch nicht angereist",
        "taskMissed": "Verpasst: Der Gast ist angereist, bevor die Aufgabe erledigt war",
        "taskUpdate": "Aufgabe geändert: {summary}"
      },
      "byVidimo": "Vidimo",
      "onBehalf": "{agent} (Vidimo-Support) im Namen von {actor}",
      "open": {
        "guest": "Gast öffnen",
        "reservation": "Reservierung öffnen",
        "task": "Aufgabe öffnen"
      },
      "title": "Aktivität",
      "unknownActor": "Unbekannt"
    },
    "avatarUpload": {
      "chooseImage": "Bild auswählen",
      "errorUpload": "Das Bild konnte nicht hochgeladen werden. Bitte versuch es noch einmal."
    },
    "connectionStatusBanner": {
      "backendUnreachable": "Vidimo ist nicht erreichbar. Änderungen werden synchronisiert, sobald die Verbindung wieder steht.",
      "changesNotSent": "Einige Änderungen wurden noch nicht synchronisiert. Lass die App geöffnet, während wir es noch einmal versuchen.",
      "deviceOffline": "Du bist offline. Änderungen werden synchronisiert, sobald du wieder online bist."
    },
    "copyRecordLink": {
      "copied": "Link kopiert",
      "errorNotCopied": "Link konnte nicht kopiert werden"
    },
    "deviceReplica": {
      "clearDatabase": {
        "cancel": "Behalten",
        "confirm": "Trotzdem löschen",
        "unsynced": "{count, plural, one {{count} Änderung auf diesem Gerät ist noch nicht synchronisiert. Wenn du jetzt löschst, wird sie von diesem Gerät entfernt und erreicht Vidimo nicht.} other {{count} Änderungen auf diesem Gerät sind noch nicht synchronisiert. Wenn du jetzt löschst, werden sie von diesem Gerät entfernt und erreichen Vidimo nicht.}}",
        "unsyncedUnknown": "Einige Änderungen auf diesem Gerät sind womöglich noch nicht synchronisiert. Wenn du jetzt löschst, werden sie von diesem Gerät entfernt und erreichen Vidimo nicht."
      },
      "signOut": {
        "cancel": "Angemeldet bleiben",
        "confirm": "Trotzdem abmelden",
        "unsynced": "{count, plural, one {{count} Änderung auf diesem Gerät ist noch nicht synchronisiert. Wenn du dich jetzt abmeldest, wird sie von diesem Gerät entfernt und erreicht Vidimo nicht.} other {{count} Änderungen auf diesem Gerät sind noch nicht synchronisiert. Wenn du dich jetzt abmeldest, werden sie von diesem Gerät entfernt und erreichen Vidimo nicht.}}",
        "unsyncedUnknown": "Einige Änderungen auf diesem Gerät sind womöglich noch nicht synchronisiert. Wenn du dich jetzt abmeldest, werden sie von diesem Gerät entfernt und erreichen Vidimo nicht."
      },
      "signOutFailed": "Abmelden fehlgeschlagen. Prüf deine Verbindung und versuch es noch einmal.",
      "signOutOffline": "Du bist offline. Stell eine Verbindung her, um dich abzumelden; bis dahin bleibt alles auf diesem Gerät.",
      "unsyncedTitle": "Nicht synchronisierte Änderungen"
    },
    "errorBoundary": {
      "description": "Lade die App neu, um weiterzumachen.",
      "reload": "App neu laden",
      "title": "Etwas ist schiefgelaufen"
    },
    "loading": "Wird geladen…",
    "mrzScanner": {
      "alreadyOnBooking": "{name} ist bereits in dieser Buchung. {outcome}",
      "confirm": "Bestätigen",
      "errorNoReservation": "Es ist nicht klar, zu welcher Buchung das gehört. Öffne die Reservierung erneut und versuch es noch einmal.",
      "errorNotAccepted": "Die Angaben wurden nicht akzeptiert. Gleiche sie mit dem Dokument ab und versuch es noch einmal.",
      "errorNotOnBooking": "Diese Person ist nicht mehr in dieser Buchung. Öffne die Reservierung erneut, um zu sehen, wer dabei ist.",
      "errorPartyFull": "Für diese Buchung sind bereits alle erwarteten Gäste erfasst. Um jemanden hinzuzufügen, erhöhe zuerst die Zahl der Erwachsenen, Kinder oder Kleinkinder. Um jemanden zu scannen, der schon dabei ist, tippe in seiner Zeile auf das Ausweissymbol.",
      "errorReservationNotActive": "Für diese Reservierung ist kein Check-in mehr möglich.",
      "errorUnreachable": "Der Server ist nicht erreichbar. Prüf deine Verbindung und versuch es noch einmal.",
      "guestPickerLabel": "Wem gehört dieser Ausweis?",
      "noGuests": "Diese Reservierung hat noch keine Gäste: Der erste Scan legt sie an.",
      "outcomeActionNeeded": "Gespeichert, aber die Meldung braucht noch Aufmerksamkeit. Unter „Meldung“ beim Gast siehst du, was fehlt.",
      "outcomeFiled": "Gespeichert und gemeldet. Die Behörde hat es bestätigt.",
      "outcomeNone": "Dokument beim Gast gespeichert.",
      "outcomeSubmitted": "Gespeichert und übermittelt. Bestätigung ausstehend.",
      "scanner": {
        "back": "Zurück",
        "cameraFailed": "Die Kamera konnte nicht gestartet werden. Prüf die Berechtigungen und versuch es erneut.",
        "cancelScan": "Scan abbrechen",
        "checkingRequirements": "Wir prüfen, was die Meldung dieses Aufenthalts erfordert…",
        "chooseOneOf": "Wähle: {choices}.",
        "chooseWho": "Wähle aus, wer eincheckt.",
        "close": "Schließen",
        "countryClear": "Löschen",
        "documentNumber": "Dokument-Nr.",
        "documentNumberPlaceholder": "Dokumentnummer",
        "doubleCheck": "Bitte noch einmal prüfen: {fields}",
        "expiryDate": "Gültig bis",
        "failedBody": "Das kommt oft vor. Wähle, was am einfachsten ist:",
        "failedTitle": "Ausweis konnte nicht gelesen werden",
        "guestFallback": "Gast {id}",
        "manualBody": "Übernimm die Angaben aus dem Dokument, sie müssen genau übereinstimmen.",
        "manualSubmit": "Angaben speichern",
        "manualTitle": "Ausweisdaten eingeben",
        "missingLicense": "Das Scannen von Dokumenten ist gerade nicht verfügbar. Bitte wende dich an deinen Gastgeber.",
        "noCamera": "Keine Kamera? Angaben manuell eingeben",
        "openingCamera": "Kamera wird geöffnet…",
        "optional": "Optional",
        "personalNumber": "Nationale Identifikationsnummer",
        "personalNumberPlaceholder": "Wie auf dem Dokument",
        "pickGuest": "Wähle aus, zu wem diese Angaben gehören.",
        "regimeFieldsIntro": "Für die Meldung hier erforderlich, steht aber nicht auf dem Dokument.",
        "required": "Pflichtfeld",
        "retake": "Erneut scannen",
        "reviewBody": "Auf deinem Handy aus dem Dokument gelesen. Korrigiere alles, was nicht stimmt, die Angaben müssen genau übereinstimmen.",
        "reviewTitle": "Mit dem Ausweis abgleichen",
        "scanBody": "Halte die Seite mit dem Foto in den Rahmen. Der Scan startet von selbst, du musst nichts drücken.",
        "scanButton": "Reisepass oder Ausweis scannen",
        "scanEyebrow": "Ausweis scannen",
        "scanTarget": "Für",
        "scanTitle": "Reisepass oder Ausweis des Gastes scannen",
        "scanned": "✓ Gescannt",
        "select": "Auswählen",
        "selectSex": "Geschlecht auswählen",
        "submitFailed": "Der Check-in konnte nicht übermittelt werden.",
        "submitting": "Wird übermittelt…",
        "tryAgainSub": "Mehr Licht, weniger Spiegelung, flach halten",
        "tryAgainTitle": "Erneut versuchen",
        "typeInsteadSub": "Gib ein, was auf dem Dokument steht",
        "typeInsteadTitle": "Angaben stattdessen eingeben",
        "view": {
          "bothSidesScanned": "Beide Seiten gescannt ✓",
          "cameraAccessDenied": "Kein Zugriff auf die Kamera",
          "closeScanner": "Scanner schließen",
          "flipDocument": "Jetzt die Seite mit dem Foto scannen",
          "flipDocumentCountdown": "Umdrehen und die andere Seite scannen ({seconds} s)",
          "holdSteady": "Ruhig halten…",
          "loadImageFailed": "Bild konnte nicht geladen werden",
          "portraitScanned": "Foto gescannt ✓",
          "positionMRZ": "Die maschinenlesbare Zone (MRZ) in den Rahmen halten",
          "positionPortrait": "Das Foto in den Rahmen halten",
          "rotateDevice": "Bitte halte dein Gerät hochkant",
          "scanMRZFirst": "Zuerst die Seite mit der MRZ scannen",
          "scanSuccess": "MRZ gescannt ✓",
          "scanningPortrait": "Foto wird gescannt…",
          "skipPortraitLabel": "Foto-Scan überspringen",
          "switchCamera": "Kamera wechseln",
          "toggleFlash": "Blitz ein/aus"
        }
      }
    },
    "notFound": {
      "description": "Dieser Link führt zu keiner Seite in Vidimo. Vielleicht ist er veraltet oder enthält einen Tippfehler.",
      "goToToday": "„Heute“ öffnen",
      "title": "Seite nicht gefunden"
    },
    "osHelpers": {
      "cancel": "Abbrechen",
      "settings": "Einstellungen"
    },
    "pageHeader": {
      "back": "Zurück"
    },
    "parkedDrawerBar": {
      "close": "Details schließen",
      "reopen": "{name} wieder öffnen"
    },
    "paywallGate": {
      "errorOwnerOnly": "Nur der Inhaber der Unterkunft kann die Abrechnung einrichten.",
      "lapsedNativeDescription": "Diese Unterkunft ist pausiert. Es wurde nichts gelöscht, und der Zugriff ist wieder da, sobald das Abo wieder aktiv ist.",
      "lapsedNotice": "Das Abo dieser Unterkunft ist abgelaufen. Bitte den Inhaber, es zu verlängern.",
      "lapsedTitle": "Dein Abo ist abgelaufen",
      "noSubscriptionDescription": "Sie braucht ein aktives Abo. Bis dahin bleiben deine Daten sicher.",
      "noSubscriptionTitle": "Diese Unterkunft ist noch nicht aktiv",
      "pastDueNative": "Zahlung fehlgeschlagen. Der Zugriff endet womöglich bald.",
      "propertySettings": "Einstellungen der Unterkunft",
      "signOut": "Abmelden",
      "trialActive": "Kostenloser Testzeitraum aktiv.",
      "trialDaysLeft": "Kostenloser Testzeitraum: noch {days, plural, one {# Tag} other {# Tage}}."
    },
    "persisted": {
      "lateRollback": "Eine gerade gespeicherte Änderung wurde nicht übernommen. Prüf sie und versuch es noch einmal."
    },
    "placePicker": {
      "errorDetails": "Diese Adresse konnte nicht geladen werden. Versuch ein anderes Ergebnis.",
      "errorLookup": "Adresssuche fehlgeschlagen. Prüf deine Verbindung.",
      "poweredByGoogle": "Bereitgestellt von Google",
      "searching": "Wird gesucht…",
      "unavailable": "Adresssuche nicht verfügbar"
    },
    "powersyncUploadFeedback": {
      "breakfastAlreadySetUp": "Das Frühstück wurde schon auf einem anderen Gerät eingerichtet, deshalb wurde deine Änderung nicht gespeichert.",
      "discarded": "Einige Änderungen konnten nicht gespeichert werden und wurden zurückgesetzt.",
      "discardedEntity": "Einige Änderungen (Bereich: {label}) konnten nicht gespeichert werden und wurden zurückgesetzt.",
      "labels": {
        "availability": "Verfügbarkeit",
        "breakfast": "Frühstück",
        "charge": "Posten",
        "conversation": "Unterhaltung",
        "guest": "Gast",
        "message": "Nachricht",
        "payment": "Zahlung",
        "pricing": "Preise",
        "property": "Unterkunft",
        "reaction": "Reaktion",
        "reservation": "Reservierung",
        "suggestion": "Vorschlag",
        "task": "Aufgabe",
        "timeOff": "Abwesenheit",
        "unit": "Einheit"
      }
    },
    "prerenderRoutes": {
      "signupMetaDescription": "Erstelle ein Vidimo-Konto und verwalte Unterkünfte, Reservierungen, Gästenachrichten und Check-ins an einem Ort.",
      "signupTitle": "Konto erstellen · Vidimo"
    },
    "primaryTabs": {
      "calendar": "Kalender",
      "chats": "Chats",
      "guests": "Gäste",
      "tasks": "Aufgaben",
      "today": "Heute"
    },
    "propertyFacet": {
      "addProperty": "Unterkunft hinzufügen",
      "allProperties": "Alle Unterkünfte",
      "colorLabel": "Farbe der Unterkunft {name}",
      "empty": "Keine Unterkünfte verfügbar.",
      "only": "Nur",
      "onlyLabel": "Nur {name} anzeigen",
      "settingsLabel": "Einstellungen für {name}",
      "title": "Deine Unterkünfte"
    },
    "rowPending": {
      "syncing": "{kind, select, guest {Gast wird synchronisiert…} member {Mitglied wird synchronisiert…} parking {Parkplatz wird synchronisiert…} reservation {Reservierung wird synchronisiert…} staffMember {Teammitglied wird synchronisiert…} task {Aufgabe wird synchronisiert…} unit {Einheit wird synchronisiert…} other {Wird synchronisiert…}}"
    },
    "scopeChip": {
      "allProperties": "Alle Unterkünfte",
      "clearFilters": "Zurücksetzen<suffix> ({count, plural, one {# Filter} other {# Filter}})</suffix>",
      "clearFiltersLabel": "{count, plural, one {# Filter zurücksetzen} other {# Filter zurücksetzen}}",
      "noProperties": "Keine Unterkünfte",
      "propertyCount": "{count, plural, one {# Unterkunft} other {# Unterkünfte}}",
      "scopeLabel": "Bereich: {label}",
      "scopeLabelFiltered": "Bereich: {label} ({count, plural, one {# Filter} other {# Filter}} aktiv)"
    },
    "scopeDrawer": {
      "title": "Bereich"
    },
    "searchOverlay": {
      "close": "Suche schließen",
      "emptyDescription": "Suche nach Gästen, Team, Reservierungen und Aufgaben",
      "guestFallback": "Gast",
      "noResultsDescription": "Versuch es mit einem anderen Suchbegriff",
      "noResultsTitle": "Keine Ergebnisse",
      "placeholder": "Gäste, Team, Reservierungen, Aufgaben suchen…",
      "reservationFallback": "Reservierung",
      "taskSubtitle": "Aufgabe",
      "taskSubtitleAssigned": "Aufgabe • {assignee}",
      "title": "Suche"
    },
    "staffFacet": {
      "allStaff": "Ganzes Team",
      "empty": "Kein Team verfügbar.",
      "meSuffix": "(ich)",
      "only": "Nur",
      "onlyLabel": "Nur {name} anzeigen",
      "title": "Team"
    },
    "stillLooking": {
      "description": "Womöglich wird noch synchronisiert. Erscheint es nicht, wurde es vielleicht entfernt oder gehört zu einer Unterkunft, auf die du keinen Zugriff hast.",
      "title": "{kind, select, guest {Gast wird noch gesucht} member {Mitglied wird noch gesucht} parking {Parkplatz wird noch gesucht} reservation {Reservierung wird noch gesucht} staffMember {Teammitglied wird noch gesucht} task {Aufgabe wird noch gesucht} unit {Einheit wird noch gesucht} other {Wird noch gesucht}}"
    },
    "supportSession": {
      "ended": {
        "description": "Die Kundendaten wurden aus diesem Tab entfernt. Du kannst ihn schließen.",
        "title": "Support-Sitzung beendet"
      },
      "failed": {
        "description": "Prüf die Verbindung und öffne dann im CRM eine neue.",
        "title": "Die Sitzung konnte nicht geöffnet werden"
      },
      "invalid": {
        "description": "Jeder Link öffnet nur eine Sitzung und gilt eine Minute lang. Öffne im CRM einen neuen.",
        "title": "Dieser Link ist abgelaufen oder wurde bereits verwendet"
      },
      "opening": "Die Kundenansicht wird geöffnet…"
    },
    "supportSessionBanner": {
      "exit": "Beenden",
      "viewingAs": "Ansicht als {name}, Vidimo-Support"
    },
    "syncingState": {
      "defaultLabel": "Deine Unterhaltungen werden synchronisiert…",
      "retry": "Erneut versuchen",
      "retrying": "Neuer Versuch…",
      "slow": "Die Synchronisierung dauert länger als üblich…",
      "unreachableDescription": "Deine Daten werden geladen, sobald die Verbindung wieder steht. Prüf deine Internetverbindung oder versuch es gleich noch einmal.",
      "unreachableTitle": "Sync-Server nicht erreichbar"
    },
    "useAcceptInvitation": {
      "errorInvitationNotFound": "Dieser Einladungscode ist nicht mehr gültig: Er ist womöglich abgelaufen oder wurde zurückgezogen. Bitte um einen neuen.",
      "errorNotJoined": "Beitritt zur Unterkunft fehlgeschlagen. Prüf deinen Einladungscode und versuch es noch einmal.",
      "errorSupportSession": "Einer Unterkunft beizutreten ist in einer Support-Sitzung nicht möglich.",
      "errorWrongRecipient": "Diese Einladung ging an eine andere E-Mail-Adresse. Melde dich mit dieser Adresse an, um sie anzunehmen.",
      "joined": "Unterkunft beigetreten"
    },
    "useDirtyGuard": {
      "discardPrompt": "Du hast ungespeicherte Änderungen. Verwerfen?"
    },
    "userDrawer": {
      "account": "Konto",
      "accountDescription": "Profil, Darstellung und Aufgabenkalender",
      "accountSection": "Konto",
      "contactSupport": "Support kontaktieren",
      "contactSupportDescription": "Schreib dem Vidimo-Team",
      "help": "Hilfe",
      "helpDescription": "Anleitungen für Vidimo",
      "joinProperty": "Einer Unterkunft beitreten",
      "joinPropertyDescription": "Mit einem Einladungscode aus deinem Team",
      "legalSection": "Rechtliches",
      "notifications": "Benachrichtigungen",
      "notificationsDescription": "Töne für Nachrichten, Gruppen und Anrufe",
      "privacy": "Datenschutzerklärung",
      "privacyDescription": "Wie Vidimo mit deinen Daten umgeht",
      "signOut": "Abmelden",
      "signedIn": "Angemeldet",
      "supportSection": "Support",
      "terms": "Nutzungsbedingungen",
      "termsDescription": "Die Vereinbarung für deine Nutzung von Vidimo",
      "trigger": "Benutzermenü",
      "triggerWithNews": "Benutzermenü, mit etwas Neuem unter Neuigkeiten",
      "whatsNew": "Neuigkeiten",
      "whatsNewDescription": "Was sich in Vidimo geändert hat, Version für Version",
      "whatsNewUnseen": "Neuer Eintrag"
    }
  },

  "stayPreview": {
    "stayPreviewFrame": {
      "frameTitle": "Vorschau der Gästeseite",
      "loadFailed": "Die Vorschau wurde nicht geladen.",
      "tryAgain": "Erneut versuchen"
    },
    "stayPreviewHost": {
      "preview": "Vorschau",
      "title": "Als Gast ansehen"
    },
    "stayPreviewPanel": {
      "copyLink": "Link kopieren",
      "errorCopyFailed": "Link konnte nicht kopiert werden",
      "linkCopied": "Vorschaulink kopiert",
      "phaseAfter": "Nach dem Check-out",
      "phaseArrivalDay": "Anreisetag",
      "phaseBefore": "Vor der Anreise",
      "phaseGroupLabel": "Aufenthaltsphase",
      "phaseInStay": "Während des Aufenthalts",
      "qrCodeLabel": "QR-Code, um diese Vorschau auf deinem Handy zu öffnen",
      "sampleNotice": "Ein Beispielaufenthalt: Daten, Gäste und Türcode sind Beispiele.",
      "scanHint": "Scannen, um diese Vorschau auf deinem Handy zu öffnen. Sie zeigt, was du gespeichert hast."
    }
  },

  "tasks": {
    "completed": {
      "completeFailed": "Die Aufgabe konnte nicht abgeschlossen werden. Versuch es noch einmal.",
      "title": "Aufgabe erledigt",
      "undo": "Rückgängig",
      "undoFailed": "Rückgängig machen fehlgeschlagen. Die Aufgabe ist weiterhin erledigt."
    },
    "completionNote": {
      "dictate": "Notiz diktieren",
      "hint": "Notiere alles, was nachverfolgt werden muss.",
      "optional": "Optional",
      "placeholder": "Notiz eingeben…",
      "save": "Notiz speichern",
      "saveFailed": "Die Notiz konnte nicht gespeichert werden. Versuch es noch einmal.",
      "saved": "Gespeichert",
      "stopRecording": "Aufnahme beenden",
      "title": "Notiz zur Aufgabe hinzufügen",
      "transcribeFailed": "Die Aufnahme konnte nicht transkribiert werden. Bitte versuch es noch einmal.",
      "transcribing": "Wird transkribiert…"
    },
    "editTaskForm": {
      "assignedTo": "Zugewiesen an",
      "back": "Zurück",
      "backToTasks": "Zurück zu den Aufgaben",
      "cancel": "Abbrechen",
      "create": "Erstellen",
      "created": "Aufgabe erstellt.",
      "dateLabel": "Datum <hint>(optional: leer lassen für eine Aufgabe ohne festen Termin)</hint>",
      "delete": "Löschen",
      "deleteDescription": "Sie verschwindet für alle. Meist ist Erledigen der bessere Weg, eine Aufgabe abzuschließen; Löschen ist für eine, die es nie hätte geben sollen.",
      "deleteTask": "Aufgabe löschen",
      "deleteTitle": "Diese Aufgabe löschen?",
      "deleted": "Aufgabe gelöscht",
      "deleting": "Wird gelöscht…",
      "descriptionLabel": "Beschreibung",
      "descriptionPlaceholder": "Beschreibung der Aufgabe (optional)",
      "endTimeLabel": "Endzeit",
      "errorNotDeleted": "Diese Aufgabe konnte nicht gelöscht werden. Bitte versuch es noch einmal.",
      "errorNotSaved": "Die Aufgabe konnte nicht gespeichert werden. Versuch es noch einmal.",
      "notFound": "Aufgabe nicht gefunden",
      "priorityHigh": "Hoch",
      "priorityLabel": "Priorität",
      "priorityLow": "Niedrig",
      "priorityMedium": "Mittel",
      "propertyLabel": "Unterkunft",
      "propertyPlaceholder": "Unterkunft auswählen",
      "save": "Speichern",
      "startTimeLabel": "Startzeit",
      "statusLabel": "Status",
      "titleEdit": "Aufgabe bearbeiten",
      "titleLabel": "Titel",
      "titleNew": "Neue Aufgabe",
      "titlePlaceholder": "Titel der Aufgabe",
      "typeCleaning": "Reinigung",
      "typeLabel": "Typ",
      "typeMaintenance": "Wartung",
      "unitLabel": "Einheit",
      "unitNeedsProperty": "Bitte wähle zuerst eine Unterkunft aus",
      "updated": "Aufgabe aktualisiert."
    },
    "staffAssigneeSelect": {
      "assigned": "Zugewiesen",
      "cancel": "Abbrechen",
      "confirm": "Trotzdem zuweisen",
      "confirmDescription": "Diese Person ist für diesen Zeitraum als nicht verfügbar markiert. Wenn es dringend ist, kannst du sie trotzdem zuweisen.",
      "confirmDescriptionReason": "Diese Person ist für diesen Zeitraum als nicht verfügbar markiert: {reason}. Wenn es dringend ist, kannst du sie trotzdem zuweisen.",
      "confirmTitle": "{name} trotzdem zuweisen?",
      "filteringNote": "{taskFunction, select, check_in {Es werden Teammitglieder angezeigt, die Check-ins übernehmen.} check_out {Es werden Teammitglieder angezeigt, die Check-outs übernehmen.} cleaning {Es werden Teammitglieder angezeigt, die Reinigungen übernehmen.} concierge {Es werden Teammitglieder angezeigt, die Concierge-Aufgaben übernehmen.} maintenance {Es werden Teammitglieder angezeigt, die Wartungsarbeiten übernehmen.} other {Es werden Teammitglieder angezeigt, die {taskFunction} übernehmen.}}",
      "noFunction": "{taskFunction, select, check_in {Übernimmt keine Check-ins} check_out {Übernimmt keine Check-outs} cleaning {Übernimmt keine Reinigung} concierge {Übernimmt keine Concierge-Aufgaben} maintenance {Übernimmt keine Wartung} other {Übernimmt nicht: {taskFunction}}}",
      "showEveryone": "Alle anzeigen",
      "showQualified": "Nur passende Teammitglieder anzeigen",
      "unassigned": "Nicht zugewiesen"
    },
    "taskCues": {
      "label": {
        "infant": "Babybett aufstellen: Kleinkind",
        "pet": "Reist mit Haustier",
        "petWithNotes": "Haustier: {notes}"
      },
      "short": {
        "accessibility": "Barrierefreiheit",
        "dietary": "Ernährung",
        "infant": "Babybett",
        "pet": "Haustier"
      }
    },
    "taskDetails": {
      "accessibility": "Barrierefreiheit",
      "afterCheckout": "Nach dem Check-out um {checkOut}",
      "afterCheckoutBeforeCheckIn": "Nach dem Check-out um {checkOut} · Vor dem Check-in um {checkIn}",
      "assignedTo": "Zugewiesen an",
      "assignment": "Zuweisung",
      "beforeCheckIn": "Vor dem Check-in um {checkIn}",
      "checkIn": "Check-in",
      "cleaningUpAfter": "Reinigung nach <guest>{name}</guest>",
      "completionNote": "Abschlussnotiz",
      "description": "Beschreibung",
      "dietary": "Ernährung",
      "eta": "· Ankunft ca. {eta}",
      "markDone": "Als erledigt markieren",
      "notScheduled": "Nicht geplant",
      "openLiveView": "Live-Ansicht öffnen",
      "pets": "Haustiere",
      "prepFor": "Vorbereitung für",
      "specialRequests": "Besondere Wünsche",
      "startTask": "Aufgabe starten",
      "travellingWithPet": "Reist mit Haustier",
      "unassigned": "Nicht zugewiesen",
      "unitCode": "Einheit {code}",
      "unitCodeAndName": "Einheit {code} – {name}",
      "unknownUnit": "Unbekannte Einheit",
      "via": "über",
      "viewFullReservation": "Ganze Reservierung ansehen",
      "viewSummary": "Zusammenfassung ansehen",
      "when": "Wann",
      "where": "Wo"
    },
    "taskLiveView": {
      "allStepsDone": "{total, plural, one {{total} Schritt erledigt} other {Alle {total} Schritte erledigt}}",
      "assignment": "Zuweisung",
      "back": "Zurück",
      "backToTasks": "Zurück zu den Aufgaben",
      "checkInFrom": "Check-in der Gäste ab {time}",
      "checkInFromWithEta": "Check-in der Gäste ab {time} · Ankunft ca. {eta}",
      "checklistTitle": "Reinigung nach Standard",
      "compactCheckIn": "Check-in {time}",
      "compactEta": "Ankunft ca. {time}",
      "edit": "Bearbeiten",
      "errorComplete": "Die Aufgabe konnte nicht abgeschlossen werden. Versuch es noch einmal.",
      "errorStart": "Die Aufgabe konnte nicht gestartet werden. Versuch es noch einmal.",
      "errorStepUpdate": "Dieser Schritt konnte nicht aktualisiert werden. Versuch es noch einmal.",
      "errorUpdate": "Die Aufgabe konnte nicht aktualisiert werden. Versuch es noch einmal.",
      "finishAnyway": "Trotzdem abschließen",
      "finishHintTask": "Schließ die Aufgabe ab, wenn das Zimmer fertig ist, ganz ohne Eile.",
      "finishHintTurnover": "Schließ den Gästewechsel ab, wenn das Zimmer fertig ist, ganz ohne Eile.",
      "missedHint": "Der Gast ist angereist, bevor die Aufgabe fertig war. Falls sie doch noch gemacht wurde, setz sie auf Erledigt und danach das Zimmer auf Sauber.",
      "missedHintAskManager": "Der Gast ist angereist, bevor die Aufgabe fertig war. Falls sie doch noch gemacht wurde, setz sie auf Erledigt und bitte danach einen Inhaber oder Manager, das Zimmer auf Sauber zu setzen.",
      "finishPostCheckout": "Reinigung nach Check-out abschließen",
      "finishPreCheckinRefresh": "Auffrischung vor Anreise abschließen",
      "finishTurnover": "Gästewechsel abschließen",
      "finished": "Abgeschlossen",
      "guestNames": "· {names}",
      "headerTitle": "Aufgabe",
      "headingKindUnit": "{kind} – {unit}",
      "keepGoing": "Weitermachen",
      "kindCleaning": "Reinigung",
      "kindComplete": "{kind} abgeschlossen",
      "kindMaintenance": "Wartung",
      "markComplete": "Als erledigt markieren",
      "markedComplete": "Als erledigt markiert",
      "missing": "Diese Aufgabe ist nicht verfügbar.",
      "notScheduled": "Nicht geplant",
      "notesQuote": "„{notes}“",
      "pause": "Pausieren",
      "prepFor": "Vorbereitung · nächste Gäste",
      "resume": "Fortsetzen",
      "someStepsDone": "{total, plural, one {{done} von {total} Schritt erledigt} other {{done} von {total} Schritten erledigt}}",
      "startTask": "Aufgabe starten",
      "started": "Gestartet",
      "startedAt": "Gestartet um {time}",
      "stepsLeftDescription": "Noch nicht abgehakt:",
      "stepsLeftTitle": "{left, plural, one {Mit {left} offenen Schritt abschließen?} other {Mit {left} offenen Schritten abschließen?}}",
      "task": "Aufgabe",
      "taskComplete": "Aufgabe erledigt",
      "todayBefore": "Heute, jederzeit vor {time}",
      "upNext": "Als Nächstes",
      "upNextFor": "Als Nächstes · {name}",
      "when": "Wann",
      "where": "Wo"
    },
    "taskPrep": {
      "adults": "{count, plural, one {# Erwachsener} other {# Erwachsene}}",
      "children": "{count, plural, one {# Kind} other {# Kinder}}",
      "guests": "{count, plural, one {# Gast} other {# Gäste}}",
      "infants": "{count, plural, one {# Kleinkind} other {# Kleinkinder}}"
    },
    "tasksView": {
      "completeTask": "{title} erledigen",
      "createTask": "Neue Aufgabe erstellen",
      "dateAt": "{date} • {time}",
      "emptyDescription": "Erstelle eine Aufgabe, um loszulegen",
      "emptyTitle": "Keine Aufgaben gefunden",
      "hideCompleted": "Erledigte Aufgaben ausblenden",
      "needsOwner": "braucht eine zuständige Person",
      "openTask": "{title} öffnen",
      "sectionCompleted": "Erledigt",
      "sectionMissed": "Verpasst",
      "sectionOverdue": "Überfällig",
      "sectionToday": "Heute",
      "sectionUnscheduled": "Ohne Termin",
      "sectionUpcoming": "Demnächst",
      "showCompleted": "Erledigte Aufgaben anzeigen",
      "switchToColumns": "Zur Spaltenansicht wechseln",
      "switchToList": "Zur Listenansicht wechseln",
      "syncing": "Deine Aufgaben werden synchronisiert…",
      "taskCount": "{count, plural, one {{count} Aufgabe} other {{count} Aufgaben}}",
      "taskCountNeedsOwner": "{count, plural, one {{count} Aufgabe • braucht eine zuständige Person} other {{count} Aufgaben • brauchen eine zuständige Person}}",
      "title": "Aufgaben",
      "unassigned": "Nicht zugewiesen",
      "unavailableDescription": "Vidimo konnte die Aufgaben auf diesem Gerät nicht laden. Beim erneuten Versuch startet die App neu.",
      "unavailableTitle": "Aufgaben lassen sich gerade nicht anzeigen"
    },
    "waitsForClean": {
      "detail": "Das Zimmer ist noch schmutzig. Starte die Auffrischung, sobald es gereinigt wurde.",
      "title": "Wartet auf die Reinigung"
    }
  }
}
